
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("gS0HJ", function(module, exports) {
$parcel$export(module.exports, "JiraShareButtonOld", () => $ee302918f901bf73$export$81efca47037f6699);
$parcel$export(module.exports, "default", () => $ee302918f901bf73$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goBB5 = parcelRequire("goBB5");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $g9Vr6 = parcelRequire("g9Vr6");

var $lvKO5 = parcelRequire("lvKO5");

var $1KdDN = parcelRequire("1KdDN");

var $2aY2d = parcelRequire("2aY2d");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $cdOxc = parcelRequire("cdOxc");

var $7nneX = parcelRequire("7nneX");

var $b6fok = parcelRequire("b6fok");

var $3bA4v = parcelRequire("3bA4v");

var $exWfC = parcelRequire("exWfC");

var $d7khl = parcelRequire("d7khl");

var $64uMB = parcelRequire("64uMB");

var $hXobJ = parcelRequire("hXobJ");

var $iyFlq = parcelRequire("iyFlq");

var $2QPR8 = parcelRequire("2QPR8");

var $5OUyR = parcelRequire("5OUyR");

var $hRBjl = parcelRequire("hRBjl");

var $hXgLh = parcelRequire("hXgLh");

var $l5lRI = parcelRequire("l5lRI");
const $ee302918f901bf73$export$81efca47037f6699 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const { triggerButtonStyle: triggerButtonStyle, triggerButtonTooltipPosition: triggerButtonTooltipPosition, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, renderCustomTriggerButton: renderCustomTriggerButton, customTriggerButtonIcon: customTriggerButtonIcon, shareShortcutTriggerCount: // remove when fg fix_split_share_button_sentry_error is cleaned up
    shareShortcutTriggerCount = 0, prevShareShortcutTriggerCount: prevShareShortcutTriggerCount = 0, shareFormTitle: shareFormTitle, shareContentType: shareContentType, poSpotlightShareButtonId: poSpotlightShareButtonId, additionalTabs: additionalTabs, shareIntegrations: shareIntegrations, shareFieldsFooter: shareFieldsFooterProp, ...otherProps } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { cloudId: cloudId, activationId: activationId } = (0, $lvKO5.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ loading: loadingOutgoingMailStatus, data: outgoingMailStatus, error: outgoingMailStatusError }, fetchEmailSettings] = (0, $7nneX.default)();
    const [{ data: hasUserPermission, error: userPermissionError }, fetchUserPermission] = (0, $b6fok.default)();
    const [{ loading: loadingComplainceStatusHipaa, data: complainceStatusHIPAA, error: complainceStatusHipaaError }, fetchHipaaComplianceStatus] = (0, $cdOxc.useIsHipaaComplianceService)();
    const maybeExtendedShareDialogEnabled = (0, $exWfC.useMaybeCanSeeExtendedShareDialog)();
    const isSplitShareButtonEnabled = (0, $hXobJ.useIsSplitShareButtonEnabled)();
    const { data: projectContext, updateCache: updateProjectContext } = (0, $2aY2d.useProjectContext)();
    const [currentAccessLevel, setCurrentAccessLevel] = (0, $eJOHy.useState)(projectContext?.accessLevel);
    const handleAccessLevelUpdate = (0, $eJOHy.useCallback)((newAccessLevel)=>{
        setCurrentAccessLevel(newAccessLevel);
        // update projectContext cache with new accessLevel
        projectContext && updateProjectContext({
            ...projectContext,
            accessLevel: newAccessLevel
        });
    }, [
        updateProjectContext,
        projectContext
    ]);
    const { data: projectAccessData, fetch: fetchProjectAccessLevels, loading: isProjectAccessLoading, error: fetchProjectAccessError } = (0, $3bA4v.useProjectAccessLevel)();
    const { data: userRoles, fetch: fetchUserRoles, loading: userRolesLoading, error: fetchUserRolesError } = (0, $d7khl.useUserRole)(projectContext?.projectKey);
    const [isAutoOpen, setIsAutoOpen] = (0, $eJOHy.useState)(true);
    const shortcutPressed = !!(shareShortcutTriggerCount && shareShortcutTriggerCount > 0 && shareShortcutTriggerCount > prevShareShortcutTriggerCount);
    (0, $eJOHy.useEffect)(()=>{
        if (outgoingMailStatus === undefined && isAutoOpenDialog === true) fetchEmailSettings();
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        outgoingMailStatus
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && isAutoOpenDialog === true) fetchHipaaComplianceStatus();
    // complianceStatusHIPAA is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        complainceStatusHIPAA
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (hasUserPermission === undefined && isAutoOpenDialog === true) fetchUserPermission();
    // hasUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        hasUserPermission
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (userRoles === undefined && isAutoOpenDialog === true && maybeExtendedShareDialogEnabled && (0, $epTsa.expVal)('tmp_secure_project_access_share_dialog', 'isEnabled', false)) fetchUserRoles();
    }, [
        fetchUserRoles,
        isAutoOpenDialog,
        maybeExtendedShareDialogEnabled,
        userRoles
    ]);
    // This is used purely to trigger a re-render.
    // If `isAutoOpenDialog` prop is already true, when the prop is recalculated
    // in the parent if it's `true` again there will be no re-render.
    (0, $eJOHy.useEffect)(()=>{
        if (outgoingMailStatus === undefined && shortcutPressed) fetchEmailSettings();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        outgoingMailStatus,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && shortcutPressed) fetchHipaaComplianceStatus();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        complainceStatusHIPAA,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (hasUserPermission === undefined && shortcutPressed) fetchUserPermission();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasUserPermission,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (userRoles === undefined && shortcutPressed && maybeExtendedShareDialogEnabled && (0, $epTsa.expVal)('tmp_secure_project_access_share_dialog', 'isEnabled', false)) fetchUserRoles();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    }, [
        fetchUserRoles,
        maybeExtendedShareDialogEnabled,
        shortcutPressed,
        userRoles
    ]);
    const getCustomFormTitle = (0, $eJOHy.useCallback)(()=>{
        switch(shareContentType){
            case 'summary':
                return formatMessage((0, $5OUyR.default).shareMainTabTextJwmSummary);
            case 'board':
                return formatMessage((0, $5OUyR.default).shareMainTabTextJwmBoard);
            case 'list':
                return formatMessage((0, $5OUyR.default).shareMainTabTextJwmList);
            case 'calendar':
                return formatMessage((0, $5OUyR.default).shareMainTabTextJwmCalendar);
            case 'timeline':
                return formatMessage((0, $5OUyR.default).shareMainTabTextJwmTimeline);
            case 'form':
                return formatMessage((0, $5OUyR.default).shareMainTabTextJwmForm);
            case 'attachments':
                return formatMessage((0, $5OUyR.default).shareMainTabTextJwmAttachments);
            default:
                return shareFormTitle;
        }
    }, [
        formatMessage,
        shareContentType,
        shareFormTitle
    ]);
    // Error handling fires analytics.
    (0, $eJOHy.useEffect)(()=>{
        if (outgoingMailStatusError) (0, $gYnSx.default)({
            meta: {
                id: 'getEmailSettings',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        outgoingMailStatusError
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (complainceStatusHipaaError) (0, $gYnSx.default)({
            meta: {
                id: 'getComplainceStatusHIPAA',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        complainceStatusHipaaError
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (userPermissionError) (0, $gYnSx.default)({
            meta: {
                id: 'userPermissionError',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        userPermissionError
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (fetchProjectAccessError) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetchProjectAccessLevels failed', 'shareButton', {
            source: (0, $64uMB.ANALYTICS_SOURCE),
            error: fetchProjectAccessError
        });
    }, [
        createAnalyticsEvent,
        fetchProjectAccessError
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (fetchUserRolesError) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetchUserRoles failed', 'shareButton', {
            source: (0, $64uMB.ANALYTICS_SOURCE),
            error: fetchUserRolesError
        });
    }, [
        createAnalyticsEvent,
        fetchUserRolesError
    ]);
    // Loading but no errors or data available.
    const shouldAutoOpenPreShareDialog = isAutoOpenDialog === true && (loadingOutgoingMailStatus || loadingComplainceStatusHipaa || complainceStatusHIPAA !== undefined || !!outgoingMailStatusError || !!complainceStatusHipaaError || outgoingMailStatus !== undefined);
    const shareFieldsFooter = maybeExtendedShareDialogEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jiraShareButtonProjectAccessLevel",
        packageName: "jiraShareButton",
        teamName: "a4t-pandora",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l5lRI.ProjectAccessLevelSelectContainer), {
        currentAccessLevel: projectAccessData?.accessLevel,
        accessLevels: projectAccessData?.availableAccessLevels,
        getProjectAccessLevels: fetchProjectAccessLevels,
        isLoading: isProjectAccessLoading
    })), shareFieldsFooterProp) : shareFieldsFooterProp;
    const isOutgoingMailDisabled = outgoingMailStatus?.isEmailEnabled === false;
    const isDisabledDueToEmail = isOutgoingMailDisabled && (additionalTabs?.length ?? 0) === 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (outgoingMailStatus === undefined || isDisabledDueToEmail || complainceStatusHIPAA?.isCompliant === true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRBjl.default), {
        triggerButtonStyle: triggerButtonStyle,
        loading: loadingOutgoingMailStatus || loadingComplainceStatusHipaa,
        error: outgoingMailStatusError || complainceStatusHipaaError,
        emailSettings: outgoingMailStatus,
        hipaaStatus: complainceStatusHIPAA,
        renderCustomTriggerButton: renderCustomTriggerButton,
        ...isSplitShareButtonEnabled && {
            customTriggerButtonIcon: (0, $iyFlq.getAccessLevelIcon)(currentAccessLevel)
        },
        getEmailSettings: fetchEmailSettings,
        getHipaaStatus: fetchHipaaComplianceStatus,
        getUserPermission: fetchUserPermission,
        ...maybeExtendedShareDialogEnabled && {
            getUserRoles: fetchUserRoles
        },
        isAutoOpenDialog: shortcutPressed || shouldAutoOpenPreShareDialog,
        onTriggerButtonClick: props.onTriggerButtonClick,
        shareShortcutTriggerCount: shareShortcutTriggerCount,
        poSpotlightShareButtonId: poSpotlightShareButtonId,
        ...(0, $7jTnu.fg)('plan-timeline-share-tooltip-position') && {
            triggerButtonTooltipPosition: triggerButtonTooltipPosition
        },
        ...(0, $7jTnu.fg)('empanada_nin_covnert_share_to_entrypoint') && {
            placement: props.dialogPlacement
        }
    }), outgoingMailStatus !== undefined && !isDisabledDueToEmail && complainceStatusHIPAA?.isCompliant === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hXgLh.default), {
        triggerButtonAppearance: "default",
        isAutoOpenDialog: isAutoOpen,
        renderCustomTriggerButton: renderCustomTriggerButton,
        ...isSplitShareButtonEnabled && {
            customTriggerButtonIcon: (0, $iyFlq.getAccessLevelIcon)(currentAccessLevel),
            onAccessLevelUpdate: handleAccessLevelUpdate
        },
        shareContentType: shareContentType,
        shareFormTitle: shareFormTitle || getCustomFormTitle(),
        triggerButtonStyle: triggerButtonStyle,
        isBrowseUsersEnabled: hasUserPermission,
        onDialogClose: ()=>{
            setIsAutoOpen(false);
            if (onDialogClose) onDialogClose();
        },
        orgId: orgId,
        workspaceAri: (0, $goBB5.JiraWorkspaceAri).create({
            activationId: activationId,
            siteId: cloudId
        }).toString(),
        additionalTabs: additionalTabs,
        shareIntegrations: isOutgoingMailDisabled ? [] : shareIntegrations,
        isOutgoingMailDisabled: isOutgoingMailDisabled,
        shareFieldsFooter: isOutgoingMailDisabled ? (0, $2QPR8.default)({
            canUserEnableEmail: outgoingMailStatus?.canUserEnableEmail
        }) : shareFieldsFooter,
        maybeExtendedShareDialogEnabled: maybeExtendedShareDialogEnabled,
        ...(0, $7jTnu.fg)('plan-timeline-share-tooltip-position') && {
            triggerButtonTooltipPosition: triggerButtonTooltipPosition
        },
        ...maybeExtendedShareDialogEnabled && {
            userRoles: userRoles,
            userRolesLoading: userRolesLoading,
            accessLevel: projectAccessData?.accessLevel.value
        },
        ...otherProps
    }));
});
var $ee302918f901bf73$export$2e2bcd8739ae039 = $ee302918f901bf73$export$81efca47037f6699;

});
parcelRegister("goBB5", function(module, exports) {
$parcel$export(module.exports, "JiraWorkspaceAri", () => $befc0d413a701cce$export$d4d0794234e3fd53);

var $1JOdS = parcelRequire("1JOdS");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/workspace/manifest.ts
var $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $1JOdS.JiraWorkspaceAriResourceOwner),
    resourceType: (0, $1JOdS.JiraWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/workspace/index.ts
var $befc0d413a701cce$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
};

});
parcelRegister("1JOdS", function(module, exports) {
$parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", () => $1440f3a3433d3385$export$e52ccdf6abac8896);
$parcel$export(module.exports, "JiraWorkspaceAriResourceType", () => $1440f3a3433d3385$export$669cd5f7b3746bb);
// src/jira/workspace/types.ts
var $1440f3a3433d3385$export$e52ccdf6abac8896 = "jira", $1440f3a3433d3385$export$669cd5f7b3746bb = "workspace";

});


parcelRegister("2aY2d", function(module, exports) {
$parcel$export(module.exports, "useProjectContext", () => $8ba7ca521b299ffc$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $8ba7ca521b299ffc$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $8ba7ca521b299ffc$export$a85f6b5857d2176);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $dZRaT = parcelRequire("dZRaT");
const $8ba7ca521b299ffc$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $dZRaT.projectContextResourceWithCache), customContext);
    const updateCache = (0, $eJOHy.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $8ba7ca521b299ffc$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $8ba7ca521b299ffc$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $8ba7ca521b299ffc$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $8ba7ca521b299ffc$export$8f31c2503e1efa93();
    return children(projectContext);
};

});

parcelRegister("cdOxc", function(module, exports) {
$parcel$export(module.exports, "useIsHipaaComplianceService", () => $5ece2855a0ee0b0c$export$dad138577ca71048);

var $eJOHy = parcelRequire("eJOHy");

var $hPZg4 = parcelRequire("hPZg4");

var $jGzN3 = parcelRequire("jGzN3");
const $5ece2855a0ee0b0c$var$getHipaaComplianceStatus = async ()=>(0, $jGzN3.performGetRequest)('/rest/internal/latest/compliance/status/HIPAA');
const $5ece2855a0ee0b0c$export$dad138577ca71048 = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchHipaaComplianceStatus } = (0, $hPZg4.useService)($5ece2855a0ee0b0c$var$getHipaaComplianceStatus);
    const transformedData = (0, $eJOHy.useMemo)(()=>data ? {
            isCompliant: data.isCompliant
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchHipaaComplianceStatus
    ];
};

});
parcelRegister("hPZg4", function(module, exports) {
$parcel$export(module.exports, "useService", () => $ca6dc04f01b0b806$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $ca6dc04f01b0b806$export$c963713a27525aaf);

var $eJOHy = parcelRequire("eJOHy");
const $ca6dc04f01b0b806$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $eJOHy.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $eJOHy.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $ca6dc04f01b0b806$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $eJOHy.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $ca6dc04f01b0b806$export$6de4685a6c88b4e9(request, initialState);
    (0, $eJOHy.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


parcelRegister("7nneX", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bcc003e5e37227a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hPZg4 = parcelRequire("hPZg4");

var $jGzN3 = parcelRequire("jGzN3");
const $1bcc003e5e37227a$var$getEmailSettings = async ()=>(0, $jGzN3.performGetRequest)('/rest/jira-mail-plugin/1.0/outgoingMail/config');
const $1bcc003e5e37227a$export$5f20fafd52370aae = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchEmailSettings } = (0, $hPZg4.useService)($1bcc003e5e37227a$var$getEmailSettings);
    const transformedData = (0, $eJOHy.useMemo)(()=>data ? {
            isEmailEnabled: data.enabled,
            canUserEnableEmail: data.canEditConfig
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchEmailSettings
    ];
};
var $1bcc003e5e37227a$export$2e2bcd8739ae039 = $1bcc003e5e37227a$export$5f20fafd52370aae;

});

parcelRegister("b6fok", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c5470478428dcce$export$2e2bcd8739ae039);

var $hPZg4 = parcelRequire("hPZg4");

var $jGzN3 = parcelRequire("jGzN3");
const $6c5470478428dcce$var$getUserPermission = async ()=>(0, $jGzN3.performGetRequest)('/rest/api/3/mypermissions?permissions=USER_PICKER');
const $6c5470478428dcce$export$ce7974a7294500be = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchUserPermission } = (0, $hPZg4.useService)($6c5470478428dcce$var$getUserPermission);
    return [
        {
            loading: loading,
            error: error,
            data: data?.permissions?.USER_PICKER?.havePermission
        },
        fetchUserPermission
    ];
};
var $6c5470478428dcce$export$2e2bcd8739ae039 = $6c5470478428dcce$export$ce7974a7294500be;

});

parcelRegister("3bA4v", function(module, exports) {
$parcel$export(module.exports, "useProjectAccessLevel", () => $ec8b59e0759085bd$export$e262f937bd216199);

var $eJOHy = parcelRequire("eJOHy");

var $hPZg4 = parcelRequire("hPZg4");

var $jGzN3 = parcelRequire("jGzN3");

var $2aY2d = parcelRequire("2aY2d");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $64uMB = parcelRequire("64uMB");
const $ec8b59e0759085bd$var$getProjectAccessLevel = async (projectId)=>{
    if (!projectId) throw new Error('Project ID is missing while fetching project access level.');
    return (0, $jGzN3.performGetRequest)(`/rest/internal/simplified/1.0/accesslevel/project/${projectId}`);
};
const $ec8b59e0759085bd$var$getProjectAccessLevels = async ()=>{
    return (0, $jGzN3.performGetRequest)('/rest/internal/simplified/1.0/accesslevel?projectType=software');
};
const $ec8b59e0759085bd$var$updateProjectAccessLevel = async ({ projectId: projectId, projectKey: projectKey, accessLevel: accessLevel })=>{
    if (!projectId || !projectKey) throw new Error('Project ID and/or Key is missing while updating project access level.');
    return (0, $jGzN3.performPutRequest)(`/rest/internal/simplified/1.0/projects/${projectId}/summary`, {
        body: JSON.stringify({
            accessLevel: accessLevel,
            key: projectKey
        })
    });
};
const $ec8b59e0759085bd$export$e262f937bd216199 = ()=>{
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { projectId: projectId, projectKey: projectKey } = (0, $eJOHy.useMemo)(()=>({
            projectId: projectContext?.projectId,
            projectKey: projectContext?.projectKey
        }), [
        projectContext
    ]);
    const fetchProjectAccessLevels = (0, $eJOHy.useCallback)(()=>Promise.all([
            $ec8b59e0759085bd$var$getProjectAccessLevel(projectId),
            $ec8b59e0759085bd$var$getProjectAccessLevels()
        ]).then(([accessLevel, availableAccessLevels])=>({
                accessLevel: accessLevel,
                availableAccessLevels: availableAccessLevels
            })), [
        projectId
    ]);
    const sendProjectAccessLevelUpdate = (0, $eJOHy.useCallback)(({ accessLevel: accessLevel })=>$ec8b59e0759085bd$var$updateProjectAccessLevel({
            projectId: projectId,
            projectKey: projectKey,
            accessLevel: accessLevel
        }), [
        projectId,
        projectKey
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $hPZg4.useService)(fetchProjectAccessLevels);
    const { loading: isUpdating, error: updateError, fetch: update } = (0, $hPZg4.useService)(sendProjectAccessLevelUpdate);
    const fetchWithAnalytics = (0, $eJOHy.useCallback)(async ()=>{
        const result = await fetch();
        if (result) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchProjectAccessLevels succeeded', 'shareButton', {
            source: (0, $64uMB.ANALYTICS_SOURCE)
        });
        return result;
    }, [
        fetch,
        createAnalyticsEvent
    ]);
    return {
        loading: loading || isUpdating,
        error: error,
        updateError: updateError,
        data: data,
        fetch: fetchWithAnalytics,
        update: update
    };
};

});
parcelRegister("64uMB", function(module, exports) {
$parcel$export(module.exports, "integrationTypes", () => $5b22545d0f98b1bc$export$a7359bcfb0ca8e98);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $5b22545d0f98b1bc$export$f7109619a5e9e0d6);
const $5b22545d0f98b1bc$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments',
    DEPENDENCIES: 'dependencies',
    INCREMENT: 'increment',
    QUEUE: 'queue'
};
const $5b22545d0f98b1bc$export$f7109619a5e9e0d6 = 'growthShareButton';

});


parcelRegister("exWfC", function(module, exports) {
$parcel$export(module.exports, "useMaybeCanSeeExtendedShareDialog", () => $adacc5db6dab4c63$export$a17587c9d4ad3d50);

var $6zXPf = parcelRequire("6zXPf");

var $kfvK2 = parcelRequire("kfvK2");

var $gZTP9 = parcelRequire("gZTP9");

var $8vyDv = parcelRequire("8vyDv");

var $cblKs = parcelRequire("cblKs");

var $2aY2d = parcelRequire("2aY2d");
const $adacc5db6dab4c63$export$a17587c9d4ad3d50 = ()=>{
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const isProjectAdmin = !!projectContextData?.isProjectAdmin;
    const isTMP = (0, $2aY2d.useIsSimplifiedProject)();
    const appEditions = (0, $8vyDv.useAppEditions)();
    const projectType = projectContextData?.projectType;
    const isSoftware = projectType === 'software' && appEditions?.software !== (0, $cblKs.FREE_EDITION);
    const isBusiness = projectType === 'business' && appEditions?.core !== (0, $cblKs.FREE_EDITION);
    const shouldShowInNav3View = (0, $kfvK2.useIsActiveRoute)(new Set([
        'software-timeline',
        'software-boards',
        'software-backlog',
        'issue'
    ]));
    return ((0, $6zXPf.getWillShowNav4)() || shouldShowInNav3View) && (isSoftware || isBusiness) && isTMP && (isAdmin || isProjectAdmin);
};

});
parcelRegister("8vyDv", function(module, exports) {
$parcel$export(module.exports, "useAppEditions", () => $3e65f3816445db61$export$92ed15881fc090d7);

var $lvKO5 = parcelRequire("lvKO5");
const $3e65f3816445db61$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});


parcelRegister("d7khl", function(module, exports) {
$parcel$export(module.exports, "useUserRole", () => $146d63c5bb157a56$export$77101ee802ae0455);

var $eJOHy = parcelRequire("eJOHy");

var $hPZg4 = parcelRequire("hPZg4");

var $jGzN3 = parcelRequire("jGzN3");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $64uMB = parcelRequire("64uMB");
const $146d63c5bb157a56$var$getUserRolesService = (projectKey)=>{
    if (!projectKey) throw new Error('Project Key is required to fetch user roles');
    return (0, $jGzN3.performGetRequest)(`/rest/api/3/project/${projectKey}/roledetails?excludeConnectAddons=true`);
};
const $146d63c5bb157a56$var$addUserRoleService = ({ projectKey: projectKey, roleId: roleId, groups: groups, users: users })=>{
    if (!projectKey) throw new Error('Project key is required to add user role');
    return (0, $jGzN3.performPostRequest)(`/rest/projectconfig/latest/roles/${projectKey}/${roleId}`, {
        body: JSON.stringify({
            groups: groups,
            users: users
        })
    });
};
const $146d63c5bb157a56$export$77101ee802ae0455 = (projectKey)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { data: data, fetch: fetch, loading: isFetching, error: fetchError } = (0, $hPZg4.useService)((0, $eJOHy.useCallback)(()=>$146d63c5bb157a56$var$getUserRolesService(projectKey), [
        projectKey
    ]));
    const { loading: isAdding, error: addError, fetch: addUserRoleInternal } = (0, $hPZg4.useService)($146d63c5bb157a56$var$addUserRoleService);
    const add = (0, $eJOHy.useCallback)((roleId, { users: users, groups: groups })=>addUserRoleInternal({
            projectKey: projectKey,
            roleId: roleId,
            users: users,
            groups: groups
        }), [
        addUserRoleInternal,
        projectKey
    ]);
    const fetchWithAnalytics = (0, $eJOHy.useCallback)(async ()=>{
        const result = await fetch();
        if (result) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchUserRoles succeeded', 'shareButton', {
            source: (0, $64uMB.ANALYTICS_SOURCE)
        });
        return result;
    }, [
        createAnalyticsEvent,
        fetch
    ]);
    return {
        fetch: fetchWithAnalytics,
        add: add,
        data: data,
        loading: isFetching || isAdding,
        error: fetchError,
        updateError: addError
    };
};

});

parcelRegister("hXobJ", function(module, exports) {
$parcel$export(module.exports, "useIsSplitShareButtonEnabled", () => $c899c8672c6602a8$export$68f9ffc84193c923);

var $epTsa = parcelRequire("epTsa");

var $6zXPf = parcelRequire("6zXPf");

var $kfvK2 = parcelRequire("kfvK2");

var $gZTP9 = parcelRequire("gZTP9");

var $8vyDv = parcelRequire("8vyDv");

var $cblKs = parcelRequire("cblKs");

var $2aY2d = parcelRequire("2aY2d");

var $7jTnu = parcelRequire("7jTnu");
const $c899c8672c6602a8$export$387107a43df52037 = new Set([
    'software-boards',
    'software-backlog',
    'software-timeline'
]);
const $c899c8672c6602a8$export$4921160130561313 = new Set([
    'software-archived-work-items',
    'software-backlog',
    'software-boards',
    'software-calendar',
    'software-code',
    'software-deployments',
    'software-form',
    'software-form-builder',
    'software-form-submit',
    'software-goals',
    'software-incidents',
    'software-issue-navigator',
    'software-list',
    'software-release-notes',
    'software-reports',
    'software-roadmap',
    'software-security',
    'software-summary',
    'software-timeline'
]);
const $c899c8672c6602a8$export$68f9ffc84193c923 = ()=>{
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const isProjectAdmin = !!projectContextData?.isProjectAdmin;
    const isTMP = (0, $2aY2d.useIsSimplifiedProject)();
    const appEditions = (0, $8vyDv.useAppEditions)();
    const projectType = projectContextData?.projectType;
    const isPaidSoftwareEdition = projectType === 'software' && appEditions.software !== (0, $cblKs.FREE_EDITION);
    const isPaidBusinessEdition = projectType === 'business' && appEditions.core !== (0, $cblKs.FREE_EDITION);
    const shouldShowInNav3View = (0, $kfvK2.useIsActiveRoute)($c899c8672c6602a8$export$387107a43df52037);
    const shouldShowInNav4View = (0, $kfvK2.useIsActiveRoute)($c899c8672c6602a8$export$4921160130561313);
    // The two gates above are used to fetch the project access level data needed
    // to render the split share button. We're adding these checks here to ensure
    // that the experiment has a comprehensive kill switch.
    if (!(0, $7jTnu.fg)('jsw-pndr-add-accesslevel-for-project-context') || !(0, $7jTnu.fg)('jira_fetch_accesslevel_for_nav4_share_button')) return false;
    return ((0, $6zXPf.getWillShowNav4)() && shouldShowInNav4View || shouldShowInNav3View) && (isPaidSoftwareEdition || isPaidBusinessEdition) && isTMP && (isAdmin || isProjectAdmin) && (0, $epTsa.expVal)('split_share_button_for_tmp_admins', 'isEnabled', false);
};

});

parcelRegister("iyFlq", function(module, exports) {
$parcel$export(module.exports, "getAccessLevelIcon", () => $757a941e4f6fe995$export$2d7bf7dcda73529c);
$parcel$export(module.exports, "getAccessLevelIconFromIconName", () => $757a941e4f6fe995$export$eeee8fbd5112c762);

var $9QgTI = parcelRequire("9QgTI");

var $ffGm1 = parcelRequire("ffGm1");

var $hxN6p = parcelRequire("hxN6p");


var $7jTnu = parcelRequire("7jTnu");
const $757a941e4f6fe995$export$2d7bf7dcda73529c = (accessLevel)=>{
    switch(accessLevel){
        case 0, $d99e3a570be3e73c$export$333699604c348681:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9QgTI));
        case 0, $d99e3a570be3e73c$export$db9276cbaa3419e6:
            return 0, (/*@__PURE__*/$parcel$interopDefault($hxN6p));
        case 0, $d99e3a570be3e73c$export$d9b46e2d865ef95c:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ffGm1));
        case 0, $d99e3a570be3e73c$export$1ec4bbf2f176ca6:
            return (0, $7jTnu.fg)('fix_handling_of_free_access_level') ? (0, (/*@__PURE__*/$parcel$interopDefault($ffGm1))) : undefined;
        default:
            return undefined;
    }
};
const $757a941e4f6fe995$export$eeee8fbd5112c762 = (icon)=>{
    switch(icon){
        case 'private':
            return $757a941e4f6fe995$export$2d7bf7dcda73529c((0, $d99e3a570be3e73c$export$333699604c348681));
        case 'limited':
            return $757a941e4f6fe995$export$2d7bf7dcda73529c((0, $d99e3a570be3e73c$export$db9276cbaa3419e6));
        case 'open':
            return $757a941e4f6fe995$export$2d7bf7dcda73529c((0, $d99e3a570be3e73c$export$d9b46e2d865ef95c));
        default:
            return undefined;
    }
};

});
parcelRegister("9QgTI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b170729cb10fdaa6c208ecbe5722b466>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72a613e9f42e1e21$var$_react = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72a613e9f42e1e21$var$_baseNew = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72a613e9f42e1e21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72a613e9f42e1e21$var$LockLockedIcon = (props)=>/*#__PURE__*/ $72a613e9f42e1e21$var$_react.default.createElement($72a613e9f42e1e21$var$_baseNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$72a613e9f42e1e21$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $72a613e9f42e1e21$var$_default = module.exports.default = $72a613e9f42e1e21$var$LockLockedIcon;

});

parcelRegister("ffGm1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5c5d989acf678b87189f6f5a97917ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1a91c657233a66e$var$_react = $b1a91c657233a66e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b1a91c657233a66e$var$_baseNew = $b1a91c657233a66e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b1a91c657233a66e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1a91c657233a66e$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $b1a91c657233a66e$var$_react.default.createElement($b1a91c657233a66e$var$_baseNew.default, Object.assign({
        name: "LockUnlockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$b1a91c657233a66e$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $b1a91c657233a66e$var$_default = module.exports.default = $b1a91c657233a66e$var$LockUnlockedIcon;

});

const $d99e3a570be3e73c$export$d9b46e2d865ef95c = 'OPEN';
const $d99e3a570be3e73c$export$db9276cbaa3419e6 = 'LIMITED';
const $d99e3a570be3e73c$export$333699604c348681 = 'PRIVATE';
const $d99e3a570be3e73c$export$1ec4bbf2f176ca6 = 'FREE';


parcelRegister("2QPR8", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ed1344c595e0187$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $iHPvF = parcelRequire("iHPvF");
var $akOEX = parcelRequire("akOEX");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $1xCtM = parcelRequire("1xCtM");
const $8ed1344c595e0187$var$OutgoingMailWarningMessage = ({ canUserEnableEmail: canUserEnableEmail })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return canUserEnableEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akOEX.default), {
            href: "/secure/admin/OutgoingMailServers.jspa"
        }, formatMessage((0, $1xCtM.default).outgoingMailSettingsLink)),
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $1xCtM.default).disabledWarningMessage))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $1xCtM.default).disabledWarningMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $1xCtM.default).nonAdminWarningMessage)));
};
var $8ed1344c595e0187$export$2e2bcd8739ae039 = $8ed1344c595e0187$var$OutgoingMailWarningMessage;

});
parcelRegister("iHPvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c4a865afee94050$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $806LH = parcelRequire("806LH");

var $6J9k6 = parcelRequire("6J9k6");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $9y5qW = parcelRequire("9y5qW");
const $1c4a865afee94050$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_19pk1i6y"
};
const $1c4a865afee94050$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $1c4a865afee94050$var$SectionMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $eJOHy.useState)(false);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        onDismiss?.();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $9y5qW.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $eJOHy.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $eJOHy.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $gt9Am.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            $1c4a865afee94050$var$sectionMessageStyles.container,
            $1c4a865afee94050$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $1c4a865afee94050$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $1c4a865afee94050$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: $1c4a865afee94050$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$1c4a865afee94050$var$SectionMessage.displayName = 'SectionMessage';
var $1c4a865afee94050$export$2e2bcd8739ae039 = $1c4a865afee94050$var$SectionMessage;

});
parcelRegister("9y5qW", function(module, exports) {
$parcel$export(module.exports, "getAppearanceIconStyles", () => $1656794cf4e78acc$export$e9b82d2e21ac0c1f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ejT8C = parcelRequire("ejT8C");

var $k9Gmz = parcelRequire("k9Gmz");

var $1NG86 = parcelRequire("1NG86");

var $i4Iw4 = parcelRequire("i4Iw4");

var $3TFuO = parcelRequire("3TFuO");

var $jkYbX = parcelRequire("jkYbX");

var $eGOwo = parcelRequire("eGOwo");

const $1656794cf4e78acc$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $7bb4c1736002a04a$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $7bb4c1736002a04a$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $7bb4c1736002a04a$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $7bb4c1736002a04a$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1NG86))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $7bb4c1736002a04a$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $7bb4c1736002a04a$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($k9Gmz))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$147899de772240ec)})`
    },
    discoveryUpdated: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $7bb4c1736002a04a$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ejT8C))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$147899de772240ec)})`
    }
};
function $1656794cf4e78acc$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $1656794cf4e78acc$var$appearanceIconSchema[appearance === 'discovery' && (0, $eGOwo.fg)('platform_dst_section_message_discovery_icon') ? 'discoveryUpdated' : appearance] || $1656794cf4e78acc$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("ejT8C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cd9c4605f2f731$var$_react = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a6cd9c4605f2f731$var$_discovery = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("h4COp")));

var $a6cd9c4605f2f731$var$_note = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("94404")));
function $a6cd9c4605f2f731$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cd9c4605f2f731$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $a6cd9c4605f2f731$var$_react.default.createElement($a6cd9c4605f2f731$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $a6cd9c4605f2f731$var$_note.default
    }, props));
$a6cd9c4605f2f731$var$DiscoveryIcon.displayName = 'DiscoveryIconMigration';
var $a6cd9c4605f2f731$var$_default = module.exports.default = $a6cd9c4605f2f731$var$DiscoveryIcon;

});
parcelRegister("h4COp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6e0eaad244db33f$var$_react = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c6e0eaad244db33f$var$_baseNew = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c6e0eaad244db33f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6e0eaad244db33f$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $c6e0eaad244db33f$var$_react.default.createElement($c6e0eaad244db33f$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$c6e0eaad244db33f$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $c6e0eaad244db33f$var$_default = module.exports.default = $c6e0eaad244db33f$var$DiscoveryIcon;

});

parcelRegister("94404", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6997971b5d08dbe2$var$_react = $6997971b5d08dbe2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $6997971b5d08dbe2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6997971b5d08dbe2$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $6997971b5d08dbe2$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$6997971b5d08dbe2$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $6997971b5d08dbe2$var$_default = module.exports.default = $6997971b5d08dbe2$var$EditorNoteIcon;

});


var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';



parcelRegister("akOEX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6330b1bed100d78d$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $6qaBj = parcelRequire("6qaBj");

var $eJ9f5 = parcelRequire("eJ9f5");

var $eGOwo = parcelRequire("eGOwo");

var $lc0OY = parcelRequire("lc0OY");
var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");
const $6330b1bed100d78d$var$stylesOld = {
    common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
const $6330b1bed100d78d$var$styles = {
    common: "_11c82smr",
    anchor: "_k48pi7a9",
    pressable: "_syaz14q2 _k48p1wq8 _bfhk18uv _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $6330b1bed100d78d$var$SectionMessageAction = /*#__PURE__*/ (0, $eJOHy.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }) {
    if (!linkComponent && (0, $eGOwo.fg)('platform_section_message_action_migration')) {
        if (href) {
            if ((0, $eGOwo.fg)('platform_dst_section_message_actions_as_link')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    $6330b1bed100d78d$var$styles.common,
                    $6330b1bed100d78d$var$styles.anchor
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                    testId: testId,
                    onClick: onClick,
                    href: href,
                    target: target,
                    children: children
                })
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
                testId: testId,
                onClick: onClick,
                href: href,
                xcss: (0, $6qaBj.cx)($6330b1bed100d78d$var$stylesOld.common, $6330b1bed100d78d$var$stylesOld.anchor),
                children: children
            });
        }
        if (onClick) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $6qaBj.cx)((0, $eGOwo.fg)('platform_dst_section_message_actions_as_link') ? $6330b1bed100d78d$var$styles.common : $6330b1bed100d78d$var$stylesOld.common, (0, $eGOwo.fg)('platform_dst_section_message_actions_as_link') ? $6330b1bed100d78d$var$styles.pressable : $6330b1bed100d78d$var$stylesOld.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "span",
            testId: testId,
            xcss: (0, $eGOwo.fg)('platform_dst_section_message_actions_as_link') && $6330b1bed100d78d$var$styles.common,
            children: children
        });
    }
    return onClick || href ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: children
    });
});
var $6330b1bed100d78d$export$2e2bcd8739ae039 = $6330b1bed100d78d$var$SectionMessageAction;

});

parcelRegister("1xCtM", function(module, exports) {
$parcel$export(module.exports, "default", () => $08bfab88f0dcd013$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $08bfab88f0dcd013$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    disabledWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message",
        "defaultMessage": "Outgoing mail is not configured."
    },
    adminEnableOutgoingMail: {
        "id": "share-button.pre-share-view.warning-content.admin-enable-outgoing-mail",
        "defaultMessage": "You can configure it here"
    },
    outgoingMail: {
        "id": "share-button.pre-share-view.warning-content.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    nonAdminWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.non-admin-warning-message",
        "defaultMessage": "Please contact your Jira administrator to enable sharing."
    },
    disabledWarningMessageIfHipaa: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message-if-hipaa",
        "defaultMessage": "You cannot share issue as your organization has signed up for HIPAA compliance"
    },
    disabledWarningMessageIfHipaaIssueTermRefresh: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message-if-hipaa-issue-term-refresh",
        "defaultMessage": "You can't share work item as your organization has signed up for HIPAA compliance"
    },
    outgoingMailSettingsLink: {
        "id": "share-button.pre-share-view.warning-content.enable-outgoing-mail-link",
        "defaultMessage": "Set up email sharing"
    }
});

});


parcelRegister("5OUyR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b30798a2cfbf9a11$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b30798a2cfbf9a11$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    shareMainTabTextJwmSummary: {
        "id": "share-button.share-main-tab-text-jwm-summary",
        "defaultMessage": "Share summary"
    },
    shareMainTabTextJwmBoard: {
        "id": "share-button.share-main-tab-text-jwm-board",
        "defaultMessage": "Share board"
    },
    shareMainTabTextJwmList: {
        "id": "share-button.share-main-tab-text-jwm-list",
        "defaultMessage": "Share list"
    },
    shareMainTabTextJwmCalendar: {
        "id": "share-button.share-main-tab-text-jwm-calendar",
        "defaultMessage": "Share calendar"
    },
    shareMainTabTextJwmTimeline: {
        "id": "share-button.share-main-tab-text-jwm-timeline",
        "defaultMessage": "Share timeline"
    },
    shareMainTabTextJwmForm: {
        "id": "share-button.share-main-tab-text-jwm-form",
        "defaultMessage": "Share form"
    },
    shareMainTabTextJwmAttachments: {
        "id": "share-button.share-main-tab-text-jwm-attachments",
        "defaultMessage": "Share attachments"
    }
});

});

parcelRegister("hRBjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $2679ff8e6d46dd26$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $iePme = parcelRequire("iePme");

var $7ep4S = parcelRequire("7ep4S");

var $k71qx = parcelRequire("k71qx");

var $8IeH1 = parcelRequire("8IeH1");

var $cNe2t = parcelRequire("cNe2t");

var $2ZGUP = parcelRequire("2ZGUP");

var $dPMMf = parcelRequire("dPMMf");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $16sa1 = parcelRequire("16sa1");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $hXobJ = parcelRequire("hXobJ");

var $goZAu = parcelRequire("goZAu");

var $9VTyd = parcelRequire("9VTyd");
const $2679ff8e6d46dd26$var$styles = {
    dialogLayout: "_y3gn1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $2679ff8e6d46dd26$var$ConditionalTooltip = ({ children: children, position: position })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $goZAu.default).shareTriggerButtonText),
        ...(0, $7jTnu.fg)('jfp_a11y_team_button_has_verbose_accessible_name') && {
            isScreenReaderAnnouncementDisabled: true
        },
        position: (0, $7jTnu.fg)('plan-timeline-share-tooltip-position') ? position ?? 'top' : 'top'
    }, children);
};
const $2679ff8e6d46dd26$export$412417a0122f041e = /*#__PURE__*/ (0, $eJOHy.memo)(({ triggerButtonStyle: triggerButtonStyle, loading: loading, error: error, emailSettings: emailSettings, hipaaStatus: hipaaStatus, renderCustomTriggerButton: renderCustomTriggerButton, customTriggerButtonIcon: customTriggerButtonIcon, getEmailSettings: getEmailSettings, getHipaaStatus: getHipaaStatus, getUserPermission: getUserPermission, getUserRoles: getUserRoles, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, onTriggerButtonClick: onTriggerButtonClick, shareShortcutTriggerCount: shareShortcutTriggerCount, poSpotlightShareButtonId: poSpotlightShareButtonId, triggerButtonTooltipPosition: triggerButtonTooltipPosition, placement: placement = (0, $7jTnu.fg)('move_share_dialog_to_jira') ? 'bottom-end' : 'left-start' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(isAutoOpenDialog);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isSplitShareButtonEnabled = (0, $hXobJ.useIsSplitShareButtonEnabled)(); // Used to invoke a re-render when isAutoOpenDialog has not changed but the shortcut has been pressed again.
    (0, $eJOHy.useEffect)(()=>{
        setIsOpen(isAutoOpenDialog);
    }, [
        isAutoOpenDialog,
        shareShortcutTriggerCount
    ]);
    const onTriggerClick = (0, $eJOHy.useCallback)((trigger)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'PreShareView Button Clicked',
            actionSubject: 'Share'
        });
        setIsOpen(!isOpen);
        if (!isOpen) {
            getUserPermission();
            getEmailSettings();
            getHipaaStatus();
            (0, $epTsa.expVal)('tmp_secure_project_access_share_dialog', 'isEnabled', false) && getUserRoles?.();
        }
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, trigger);
        if (onTriggerButtonClick) onTriggerButtonClick();
    }, [
        createAnalyticsEvent,
        isOpen,
        onTriggerButtonClick,
        getUserPermission,
        getEmailSettings,
        getHipaaStatus,
        getUserRoles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        onClose: ()=>{
            setIsOpen(false);
            onDialogClose && onDialogClose();
        },
        zIndex: (0, $dPMMf.layers).modal,
        messageId: "share-button.ui.pre-share-view.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, (0, $7jTnu.fg)('jira-warepil-migrate-motion-to-complied') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                xcss: $2679ff8e6d46dd26$var$styles.dialogLayout,
                testId: "share-button.ui.pre-share-view.warning-modal"
            }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                testId: "share-button.ui.pre-share-view.loading",
                size: "medium"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9VTyd.WarningContent), {
                isEmailEnabled: emailSettings?.isEmailEnabled,
                canUserEnableEmail: !!emailSettings?.canUserEnableEmail,
                isUserHIPAA: !!hipaaStatus?.isCompliant
            }), error && // eslint-disable-next-line @atlaskit/design-system/use-heading
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("h1", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $goZAu.default).errorMessage))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2679ff8e6d46dd26$var$DialogLayout, {
                "data-testid": "share-button.ui.pre-share-view.warning-modal"
            }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                testId: "share-button.ui.pre-share-view.loading",
                size: "medium"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9VTyd.WarningContent), {
                isEmailEnabled: emailSettings?.isEmailEnabled,
                canUserEnableEmail: !!emailSettings?.canUserEnableEmail,
                isUserHIPAA: !!hipaaStatus?.isCompliant
            }), error && // eslint-disable-next-line @atlaskit/design-system/use-heading
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("h1", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $goZAu.default).errorMessage)))),
        isOpen: isOpen,
        placement: (0, $7jTnu.fg)('empanada_nin_covnert_share_to_entrypoint') || (0, $7jTnu.fg)('move_share_dialog_to_jira') ? placement : 'left-start',
        trigger: (triggerProps)=>renderCustomTriggerButton ? renderCustomTriggerButton({
                isDisabled: loading,
                isSelected: isOpen,
                onClick: ()=>onTriggerClick('RenderCustomTriggerPreShareView'),
                ...isSplitShareButtonEnabled && {
                    iconBefore: customTriggerButtonIcon
                }
            }, triggerProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2679ff8e6d46dd26$var$ConditionalTooltip, {
                position: (0, $7jTnu.fg)('plan-timeline-share-tooltip-position') ? triggerButtonTooltipPosition : undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
                name: "issue-pre-share-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                testId: "share-button.ui.pre-share-view.button",
                id: poSpotlightShareButtonId,
                isDisabled: loading,
                label: formatMessage((0, $goZAu.default).shareTriggerButtonText),
                ...triggerProps,
                appearance: "default",
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iePme))), {
                        spacing: "spacious",
                        ...(0, $7jTnu.fg)('jfp_a11y_team_button_has_verbose_accessible_name') ? {
                            testId: 'share-button.ui.pre-share-view.share-icon',
                            label: ''
                        } : {
                            label: triggerButtonStyle === 'icon-with-text' ? '' : formatMessage((0, $goZAu.default).shareTriggerButtonText)
                        },
                        color: "var(--ds-icon, #44546F)"
                    }),
                onClick: ()=>onTriggerClick('PreShareView'),
                interactionName: "share-button.pre-share-view"
            })))
    });
});
var $2679ff8e6d46dd26$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $2679ff8e6d46dd26$export$412417a0122f041e;
const $2679ff8e6d46dd26$var$DialogLayout = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iePme", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0eee459540e5ec28215a3b80df0172>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4715f5959b077cc$var$_react = $d4715f5959b077cc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d4715f5959b077cc$var$_baseNew = $d4715f5959b077cc$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d4715f5959b077cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4715f5959b077cc$var$ShareIcon = (props)=>/*#__PURE__*/ $d4715f5959b077cc$var$_react.default.createElement($d4715f5959b077cc$var$_baseNew.default, Object.assign({
        name: "ShareIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$d4715f5959b077cc$var$ShareIcon.displayName = 'ShareIcon';
var $d4715f5959b077cc$var$_default = module.exports.default = $d4715f5959b077cc$var$ShareIcon;

});

parcelRegister("cNe2t", function(module, exports) {
$parcel$export(module.exports, "JiraPopup", () => $63f31f3205cf35fe$export$2da4be1e3f9adef3);

var $eJOHy = parcelRequire("eJOHy");

var $kJsb4 = parcelRequire("kJsb4");

var $SyPNn = parcelRequire("SyPNn");

var $cYafw = parcelRequire("cYafw");
const $63f31f3205cf35fe$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cYafw.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.Popup), rest);
};

});
parcelRegister("cYafw", function(module, exports) {
$parcel$export(module.exports, "ChoreographerPopup", () => $888aaeaeeadda171$export$8ecc19d18d3df807);

var $kJsb4 = parcelRequire("kJsb4");

var $gL5G0 = parcelRequire("gL5G0");
const $888aaeaeeadda171$export$8ecc19d18d3df807 = (0, $gL5G0.withChoreographedToggle)((0, $kJsb4.Popup), 'isOpen', 'content');

});


parcelRegister("goZAu", function(module, exports) {
$parcel$export(module.exports, "default", () => $3edec8e3b2396006$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3edec8e3b2396006$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.pre-share-view.share-trigger-button-text",
        "defaultMessage": "Share"
    },
    errorMessage: {
        "id": "share-button.pre-share-view.error-message",
        "defaultMessage": "Unable to fetch sharing details"
    }
});

});

parcelRegister("9VTyd", function(module, exports) {
$parcel$export(module.exports, "WarningContent", () => $8bf9b4fb054282fc$export$b7eb687edfdfe752);

var $eJOHy = parcelRequire("eJOHy");

var $jkYbX = parcelRequire("jkYbX");

var $hdC3k = parcelRequire("hdC3k");

var $7jTnu = parcelRequire("7jTnu");

var $kDaaB = parcelRequire("kDaaB");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");

var $1xCtM = parcelRequire("1xCtM");
function $8bf9b4fb054282fc$export$b7eb687edfdfe752({ isEmailEnabled: isEmailEnabled, canUserEnableEmail: canUserEnableEmail, isUserHIPAA: isUserHIPAA }) {
    if (isEmailEnabled === false || isUserHIPAA) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa),
        sourceName: "PreShareWarningView"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: "Warning",
        testId: "share-button.ui.pre-share-view.warning-content.warning-icon"
    }), isEmailEnabled === false && // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $1xCtM.default).disabledWarningMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null), canUserEnableEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $1xCtM.default).adminEnableOutgoingMail), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hdC3k.default), {
        href: "/secure/admin/OutgoingMailServers.jspa"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $1xCtM.default).outgoingMail))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $1xCtM.default).nonAdminWarningMessage)), isEmailEnabled !== false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $1xCtM.default).disabledWarningMessageIfHipaaIssueTermRefresh : (0, $1xCtM.default).disabledWarningMessageIfHipaa), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: {
            canUserEnableEmail: canUserEnableEmail,
            isUserHIPAA: isUserHIPAA
        }
    }));
    return null;
}

});
parcelRegister("hdC3k", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c40284cc2b86752$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aBFKZ = parcelRequire("aBFKZ");

var $c9uTK = parcelRequire("c9uTK");
function $9c40284cc2b86752$var$Link(props) {
    const { children: children, ...rest } = props;
    // eslint-disable-next-line react-hooks/react-compiler
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), rest, children);
}
var $9c40284cc2b86752$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('link', {
    onClick: 'clicked'
})($9c40284cc2b86752$var$Link);

});

// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';



parcelRegister("hXgLh", function(module, exports) {
$parcel$export(module.exports, "default", () => $41a0beacb8b41ffa$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $1kFb3 = parcelRequire("1kFb3");

var $lS6OC = parcelRequire("lS6OC");

var $8uUv3 = parcelRequire("8uUv3");

var $7jTnu = parcelRequire("7jTnu");

var $bILK0 = parcelRequire("bILK0");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kEUB1 = parcelRequire("kEUB1");

var $2aY2d = parcelRequire("2aY2d");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $epTsa = parcelRequire("epTsa");

var $bJscI = parcelRequire("bJscI");

var $clti7 = parcelRequire("clti7");

var $hMZQ4 = parcelRequire("hMZQ4");

var $6KHqk = parcelRequire("6KHqk");

var $4iD6p = parcelRequire("4iD6p");

var $9Ag4n = parcelRequire("9Ag4n");

var $exWfC = parcelRequire("exWfC");

var $3bA4v = parcelRequire("3bA4v");

var $P3eqi = parcelRequire("P3eqi");

var $d7khl = parcelRequire("d7khl");

var $64uMB = parcelRequire("64uMB");

var $hXobJ = parcelRequire("hXobJ");
const $41a0beacb8b41ffa$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    projectAccessLevelUpdated: {
        "id": "share-button.ui.share-view.project-access-level-updated",
        "defaultMessage": "Access updated"
    },
    errorUpdateProjectAccessLevel: {
        "id": "share-button.ui.share-view.error-update-project-access-level",
        "defaultMessage": "Error updating project access level"
    },
    errorAddingUsersToRole: {
        "id": "share-button.ui.share-view.error-adding-users-to-role",
        "defaultMessage": "Error adding users to role"
    }
});
const $41a0beacb8b41ffa$export$8e6e223b3e781936 = (0, $bJscI.componentWithFG)('move_share_dialog_to_jira', (0, $8uUv3.ShareDialogContainer), (0, $lS6OC.ShareDialogContainer));
const $41a0beacb8b41ffa$var$ShareButton = ({ objectAri: objectAri, triggerButtonAppearance: triggerButtonAppearance = 'subtle', onTriggerButtonClick: onTriggerButtonClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), integrationMode: integrationMode = 'off', isBrowseUsersEnabled: isBrowseUsersEnabled, isOutgoingMailDisabled: isOutgoingMailDisabled, legacyShareClientConfig: legacyShareClientConfig, shouldAutoDismissFlag: shouldAutoDismissFlag = false, onSubmit: onSubmit, userRoles: userRoles = [], userRolesLoading: userRolesLoading, accessLevel: accessLevel, customTriggerButtonIcon: customTriggerButtonIcon, onAccessLevelUpdate: onAccessLevelUpdate, triggerButtonTooltipPosition: triggerButtonTooltipPosition, ...props })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const maybeExtendedShareDialogEnabled = (0, $exWfC.useMaybeCanSeeExtendedShareDialog)();
    const isExtendedShareDialogEnabled = maybeExtendedShareDialogEnabled && (0, $epTsa.expVal)('tmp_secure_project_access_share_dialog', 'isEnabled', false);
    const isSplitShareButtonEnabled = (0, $hXobJ.useIsSplitShareButtonEnabled)();
    const legacyShareClient = (0, $eJOHy.useMemo)(()=>legacyShareClientConfig && ((0, $7jTnu.fg)('move_share_dialog_to_jira') ? new (0, $hMZQ4.LegacyShareClient)(legacyShareClientConfig) : new (0, $6KHqk.LegacyShareClientOld)(legacyShareClientConfig)), [
        legacyShareClientConfig
    ]);
    const getOriginTracingInstance = (0, $eJOHy.useCallback)(()=>{
        return new (0, $1kFb3.default)({
            product: 'jira'
        });
    }, []);
    const showFlags = (0, $eJOHy.useCallback)((flags)=>{
        if (showFlag) flags.forEach((flag)=>{
            showFlag({
                type: flag.appearance,
                // @ts-expect-error - TS2322 - Type 'MessageDescriptor' is not assignable to type 'MessageDescriptorV2'.
                title: flag.title,
                isAutoDismiss: shouldAutoDismissFlag,
                messageId: `share-button.ui.share-view.showFlag.${typeof flag.title === 'string' ? 'id' : flag.title.id}`,
                messageType: 'transactional'
            });
        });
    }, [
        showFlag,
        shouldAutoDismissFlag
    ]);
    const { data: projectContext, updateCache: updateProjectContext } = (0, $2aY2d.useProjectContext)();
    const { update: updateProjectAccessLevel, updateError: projectAccessLevelError } = (0, $3bA4v.useProjectAccessLevel)();
    const { add: addToUserRole, updateError: useRoleError } = (0, $d7khl.useUserRole)(projectContext?.projectKey);
    (0, $eJOHy.useEffect)(()=>{
        if (projectAccessLevelError) {
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraUsersAndRoles.updateAccessType failed', 'changeAccessButton', {
                source: (0, $64uMB.ANALYTICS_SOURCE),
                projectType: projectContext?.projectType,
                isTmp: true,
                error: projectAccessLevelError
            });
            showFlag({
                type: 'error',
                title: formatMessage($41a0beacb8b41ffa$export$defe85febe8b728c.errorUpdateProjectAccessLevel),
                isAutoDismiss: shouldAutoDismissFlag,
                messageId: 'share-button.ui.share-view.show-flag.error.update-project-access-level',
                messageType: 'transactional'
            });
        }
    }, [
        projectAccessLevelError,
        formatMessage,
        showFlag,
        shouldAutoDismissFlag,
        createAnalyticsEvent,
        projectContext?.projectType
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (useRoleError) {
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraUsersAndRoles.addActorToRole failed', 'roleOption', {
                source: (0, $64uMB.ANALYTICS_SOURCE),
                packageName: '@atlassian/jira-share-button',
                error: useRoleError
            });
            showFlag({
                type: 'error',
                title: formatMessage($41a0beacb8b41ffa$export$defe85febe8b728c.errorAddingUsersToRole),
                isAutoDismiss: shouldAutoDismissFlag,
                messageId: 'share-button.ui.share-view.show-flag.error.adding-users-to-role.1',
                messageType: 'transactional'
            });
        }
    }, [
        useRoleError,
        formatMessage,
        showFlag,
        shouldAutoDismissFlag,
        createAnalyticsEvent
    ]);
    const handleOnSubmit = (0, $eJOHy.useCallback)((data)=>{
        if (isExtendedShareDialogEnabled) {
            const newAccessLevel = data?.projectAccessLevel?.value;
            if (newAccessLevel && newAccessLevel !== accessLevel) // We use `.then()` syntax here instead of changing the entire function to `async` to avoid blocking the user role updates below
            updateProjectAccessLevel({
                accessLevel: newAccessLevel
            }).then((response)=>{
                if (!response) return;
                if ((0, $7jTnu.fg)('move_share_dialog_to_jira')) projectContext && updateProjectContext({
                    ...projectContext,
                    accessLevel: newAccessLevel
                });
                if (isSplitShareButtonEnabled && onAccessLevelUpdate) onAccessLevelUpdate(newAccessLevel);
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'project updated', 'changeAccessButton', {
                    source: (0, $64uMB.ANALYTICS_SOURCE),
                    projectType: projectContext?.projectType,
                    isTmp: true,
                    updatedItem: 'projectAccess',
                    accessLevel: newAccessLevel
                });
                if (!data.users?.length) showFlag({
                    type: 'success',
                    title: formatMessage($41a0beacb8b41ffa$export$defe85febe8b728c.projectAccessLevelUpdated),
                    isAutoDismiss: shouldAutoDismissFlag,
                    messageId: 'share-button.ui.share-view.show-flag.success.project-access-level-updated',
                    messageType: 'transactional'
                });
            });
            if (data.users?.length > 0 && data?.userRole?.value) {
                const { value: roleId, label: roleName } = data.userRole;
                const userIds = data.users.filter((user)=>user.type === 'user').map((user)=>user.id);
                const groupIds = data.users.filter((user)=>user.type === 'group').map((group)=>group.id);
                addToUserRole(roleId, {
                    users: userIds,
                    groups: groupIds
                }).then((response)=>{
                    if (!response) return;
                    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'project updated', 'roleOption', {
                        source: (0, $64uMB.ANALYTICS_SOURCE),
                        roleId: roleId,
                        roleName: roleName,
                        numberOfExistingUsersAdded: userIds.length,
                        numberOfExistingGroupsAdded: groupIds.length,
                        updatedItem: 'projectRole'
                    });
                });
            }
        }
        onSubmit && onSubmit(data);
    }, [
        isExtendedShareDialogEnabled,
        onSubmit,
        accessLevel,
        updateProjectAccessLevel,
        isSplitShareButtonEnabled,
        onAccessLevelUpdate,
        createAnalyticsEvent,
        projectContext,
        updateProjectContext,
        showFlag,
        formatMessage,
        shouldAutoDismissFlag,
        addToUserRole
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($41a0beacb8b41ffa$export$8e6e223b3e781936, {
        shareClient: legacyShareClient,
        cloudId: cloudId,
        loadUserOptions: legacyShareClient && (0, $4iD6p.loadUsers),
        // @ts-expect-error - TS2322 - Type '() => OriginTracing' is not assignable to type 'OriginTracingFactory'.
        originTracingFactory: getOriginTracingInstance,
        shareAri: objectAri || (0, $clti7.createAri)(props.subProductId, cloudId),
        showFlags: showFlags,
        enableSmartUserPicker: !legacyShareClient,
        product: "jira",
        isBrowseUsersDisabled: isBrowseUsersEnabled === false,
        isSubmitShareDisabled: isOutgoingMailDisabled,
        triggerButtonAppearance: triggerButtonAppearance,
        onTriggerButtonClick: onTriggerButtonClick,
        integrationMode: integrationMode,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        onSubmit: handleOnSubmit,
        CustomSubmitButton: isExtendedShareDialogEnabled ? (0, $P3eqi.CustomShareSubmitButton) : undefined,
        additionalUserFields: isExtendedShareDialogEnabled && !(0, $7jTnu.fg)('move_share_dialog_to_jira') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ag4n.UserRole), {
            accessLevel: accessLevel,
            roles: userRoles,
            isLoading: !!userRolesLoading
        }) : undefined,
        customTriggerButtonIcon: customTriggerButtonIcon,
        ...(0, $7jTnu.fg)('plan-timeline-share-tooltip-position') && {
            triggerButtonTooltipPosition: triggerButtonTooltipPosition
        },
        ...props
    });
};
var $41a0beacb8b41ffa$export$2e2bcd8739ae039 = $41a0beacb8b41ffa$var$ShareButton;

});
parcelRegister("lS6OC", function(module, exports) {
$parcel$export(module.exports, "ShareDialogContainer", () => $31cc3a56d6ece013$export$78b28896b43ae5d6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $g8IkM = parcelRequire("g8IkM");

var $LFmXM = parcelRequire("LFmXM");

var $kDaaB = parcelRequire("kDaaB");

var $8GOss = parcelRequire("8GOss");

var $4J0ad = parcelRequire("4J0ad");

var $eGOwo = parcelRequire("eGOwo");

var $6RW0K = parcelRequire("6RW0K");

var $1dYNL = parcelRequire("1dYNL");

var $kb1Mm = parcelRequire("kb1Mm");

var $63G4N = parcelRequire("63G4N");

var $adZfk = parcelRequire("adZfk");

var $fECDH = parcelRequire("fECDH");

var $7ylDQ = parcelRequire("7ylDQ");

var $52eNw = parcelRequire("52eNw");

var $fitAa = parcelRequire("fitAa");

var $bpswd = parcelRequire("bpswd");
const $31cc3a56d6ece013$var$COPY_LINK_EVENT = (0, $63G4N.copyLinkButtonClicked)({
    start: 0
});
const $31cc3a56d6ece013$export$f84bd70098573c5c = {
    disableSharingToEmails: false
};
const $31cc3a56d6ece013$var$memoizedFormatCopyLink = (0, $LFmXM.default)((origin, link)=>origin.addToUrl(link));
function $31cc3a56d6ece013$var$getCurrentPageUrl() {
    return window.location.href;
}
class $31cc3a56d6ece013$export$bc8c417f2da43f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            enableSmartUserPicker: false,
            shareeAction: 'view',
            product: 'confluence'
        };
    }
    constructor(props){
        super(props), this._isMounted = false, this._urlShorteningRequestCounter = 0, this._lastUrlShorteningWasTooSlow = false, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $63G4N.CHANNEL_ID));
        }, this.fetchConfig = ()=>{
            const startTime = Date.now();
            this.setState({
                isFetchingConfig: true
            }, async ()=>{
                try {
                    (0, $fECDH.renderShareDialogExp).start();
                    const config = await this.shareClient.getConfig(this.props.cloudId);
                    if (this._isMounted) this.setState({
                        config: config,
                        isFetchingConfig: false
                    });
                    (0, $fECDH.renderShareDialogExp).success();
                    if ((0, $eGOwo.fg)('jira-warepil-track-sharing-to-email-disabled')) this.createAndFireEvent((0, $63G4N.shareConfigurationLoaded)({
                        disableSharingToEmails: config.disableSharingToEmails,
                        durationMs: Date.now() - startTime
                    }));
                } catch (error) {
                    if (this._isMounted) this.setState({
                        config: $31cc3a56d6ece013$export$f84bd70098573c5c,
                        isFetchingConfig: false
                    });
                    let { ...errObj } = error;
                    if (error instanceof Error) errObj = {
                        ...errObj,
                        className: error.constructor.name
                    };
                    (0, $adZfk.isValidFailedExperience)((0, $fECDH.renderShareDialogExp), errObj);
                    if ((0, $eGOwo.fg)('jira-warepil-track-sharing-to-email-disabled')) this.createAndFireEvent((0, $63G4N.shareConfigurationLoadFailed)({
                        statusCode: error.code || error.status || error.statusCode,
                        durationMs: Date.now() - startTime
                    }));
                }
            });
        }, this.handleSubmitShare = ({ users: users, comment: comment, ...rest })=>{
            const shareLink = this.getFormShareLink();
            const { productId: productId, shareAri: shareAri, shareContentType: shareContentType, shareTitle: shareTitle, shareeAction: shareeAction, workspaceAri: workspaceAri, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled } = this.props;
            const content = {
                ari: shareAri,
                link: shareLink,
                title: shareTitle,
                type: shareContentType,
                workspaceAri: workspaceAri
            };
            const metaData = {
                productId: productId,
                atlOriginId: this.getFormShareOriginTracing().id,
                shareeAction: shareeAction
            };
            this.props.onSubmit?.({
                users: users,
                comment: comment,
                ...rest
            });
            if (isExtendedShareDialogEnabled && users.length === 0) return Promise.resolve();
            return this.shareClient.share(content, (0, $bpswd.optionDataToUsers)(users), metaData, comment).then(()=>{
                if (!this._isMounted) return;
                // renew Origin Tracing Id per share action succeeded
                this.setState((state)=>({
                        shareActionCount: state.shareActionCount + 1
                    }));
            });
        }, this.handleDialogOpen = async ()=>{
            if (this.props.onDialogOpen) this.props.onDialogOpen();
            this.setState({
                currentPageUrl: $31cc3a56d6ece013$var$getCurrentPageUrl()
            }, ()=>{
                this.updateShortCopyLink();
            });
            // always refetch the config when modal is re-opened
            this.fetchConfig();
        }, this.decorateAnalytics = (payload)=>{
            if (payload.type === $31cc3a56d6ece013$var$COPY_LINK_EVENT.type && payload.action === $31cc3a56d6ece013$var$COPY_LINK_EVENT.action && payload.actionSubjectId === $31cc3a56d6ece013$var$COPY_LINK_EVENT.actionSubjectId) {
                const isCopyLinkShortened = !!this.getShortenedCopyLink();
                payload = {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        shortUrl: isCopyLinkShortened
                    }
                };
                if (this.shouldShortenCopyLink() && !isCopyLinkShortened) this._lastUrlShorteningWasTooSlow = true;
            }
            return payload;
        }, // ensure origin is re-generated if the link or the factory changes
        // separate memoization is needed since copy != form
        this.getUniqueCopyLinkOriginTracing = (0, $LFmXM.default)((link, originTracingFactory)=>{
            return originTracingFactory();
        }), // form origin must furthermore be regenerated after each form share
        this.getUniqueFormShareOriginTracing = (0, $LFmXM.default)((link, originTracingFactory, shareCount)=>{
            return originTracingFactory();
        }), this.getUpToDateShortenedCopyLink = (0, $LFmXM.default)((data, originId)=>{
            this._lastUrlShorteningWasTooSlow = false;
            this._urlShorteningRequestCounter++;
            this.createAndFireEvent((0, $63G4N.shortUrlRequested)());
            const start = Date.now();
            return this.urlShortenerClient.shorten({
                ...data,
                originId: originId
            }).then((response)=>{
                this.createAndFireEvent((0, $63G4N.shortUrlGenerated)(start, this._lastUrlShorteningWasTooSlow));
                return response.shortUrl;
            }).catch(()=>{
                this.createAndFireEvent((0, $63G4N.errorEncountered)('urlShortening'));
                return null;
            });
        }, (0, (/*@__PURE__*/$parcel$interopDefault($g8IkM)))), this.getFormShareLink = ()=>{
            const rawLink = this.getRawLink();
            // Check if origin tracing on share link is enabled
            if ((0, $eGOwo.fg)('jira_client_side_error_handled_track_event')) {
                const originTracing = this.getFormShareOriginTracing();
                return $31cc3a56d6ece013$var$memoizedFormatCopyLink(originTracing, rawLink);
            }
            // original share link is used if feature flag is disabled
            return rawLink;
        };
        // v0.4 -> v0.5 .client -> .shareClient
        (0, $8GOss.default)(!props.client, 'elements/share: Breaking change, please update your props!');
        this.shareClient = props.shareClient || new (0, $1dYNL.ShareServiceClient)();
        this.urlShortenerClient = props.urlShortenerClient || new (0, $6RW0K.AtlassianUrlShortenerClient)();
        this.state = {
            shareActionCount: 0,
            config: $31cc3a56d6ece013$export$f84bd70098573c5c,
            isFetchingConfig: false,
            currentPageUrl: $31cc3a56d6ece013$var$getCurrentPageUrl(),
            shortenedCopyLink: null
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    componentDidUpdate(prevProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($g8IkM)))(prevProps.shortLinkData, this.props.shortLinkData)) this.updateShortCopyLink();
    }
    getRawLink() {
        const { shareLink: shareLink } = this.props;
        const { currentPageUrl: currentPageUrl } = this.state;
        return shareLink || currentPageUrl;
    }
    getCopyLinkOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const shareLink = this.getRawLink();
        return this.getUniqueCopyLinkOriginTracing(shareLink, originTracingFactory);
    }
    getFormShareOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const { shareActionCount: shareActionCount } = this.state;
        const shareLink = this.getRawLink();
        return this.getUniqueFormShareOriginTracing(shareLink, originTracingFactory, shareActionCount);
    }
    getFullCopyLink() {
        const { formatCopyLink: formatCopyLink } = this.props;
        const shareLink = this.getRawLink();
        const copyLinkOrigin = this.getCopyLinkOriginTracing();
        return (formatCopyLink || $31cc3a56d6ece013$var$memoizedFormatCopyLink)(copyLinkOrigin, shareLink);
    }
    shouldShortenCopyLink() {
        return !!this.props.shortLinkData || !!this.props.useUrlShortener;
    }
    getShortenedCopyLink() {
        return this.shouldShortenCopyLink() && this.state.shortenedCopyLink || undefined;
    }
    getCopyLink() {
        return this.getShortenedCopyLink() || this.getFullCopyLink();
    }
    updateShortCopyLink() {
        this.setState({
            shortenedCopyLink: null
        });
        const { shortLinkData: shortLinkData } = this.props;
        if (!shortLinkData) return;
        const originId = this.getCopyLinkOriginTracing().id;
        const shortLink = this.getUpToDateShortenedCopyLink(shortLinkData, originId);
        const requestCounter = this._urlShorteningRequestCounter;
        shortLink.then((shortenedCopyLink)=>{
            if (!this._isMounted) return;
            const isRequestOutdated = requestCounter !== this._urlShorteningRequestCounter;
            if (isRequestOutdated) return;
            this.setState({
                shortenedCopyLink: shortenedCopyLink
            });
        });
    }
    render() {
        const { cloudId: cloudId, orgId: orgId, isAutoOpenDialog: isAutoOpenDialog, dialogPlacement: dialogPlacement, loadUserOptions: loadUserOptions, renderCustomTriggerButton: renderCustomTriggerButton, customTriggerButtonIcon: customTriggerButtonIcon, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, shouldCloseOnEscapePress: shouldCloseOnEscapePress, showFlags: showFlags, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, triggerButtonAppearance: triggerButtonAppearance, triggerButtonIcon: triggerButtonIcon, triggerButtonStyle: triggerButtonStyle, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, bottomMessage: bottomMessage, shareeAction: shareeAction, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, onTriggerButtonClick: onTriggerButtonClick, onUserSelectionChange: onUserSelectionChange, shareFieldsFooter: shareFieldsFooter, isCopyDisabled: isCopyDisabled, isPublicLink: isPublicLink, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, shareAri: shareAri, tabIndex: tabIndex, copyTooltipText: copyTooltipText, onDialogClose: onDialogClose, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const { config: config, isFetchingConfig: isFetchingConfig } = this.state;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ylDQ.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $52eNw.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fitAa.ShareDialogWithTrigger), {
                    onTriggerButtonClick: onTriggerButtonClick,
                    isAutoOpenDialog: isAutoOpenDialog,
                    config: config,
                    isFetchingConfig: isFetchingConfig,
                    copyLink: this.getCopyLink(),
                    analyticsDecorator: this.decorateAnalytics,
                    dialogPlacement: dialogPlacement,
                    loadUserOptions: loadUserOptions,
                    onDialogOpen: this.handleDialogOpen,
                    onShareSubmit: this.handleSubmitShare,
                    renderCustomTriggerButton: renderCustomTriggerButton,
                    customTriggerButtonIcon: customTriggerButtonIcon,
                    shareContentType: shareContentType,
                    shareContentSubType: shareContentSubType,
                    shareContentId: shareContentId,
                    shareFormTitle: shareFormTitle,
                    shareFormHelperMessage: shareFormHelperMessage,
                    copyLinkOrigin: this.getCopyLinkOriginTracing(),
                    formShareOrigin: this.getFormShareOriginTracing(),
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress,
                    showFlags: showFlags,
                    enableSmartUserPicker: enableSmartUserPicker,
                    loggedInAccountId: loggedInAccountId,
                    cloudId: cloudId,
                    orgId: orgId,
                    triggerButtonAppearance: triggerButtonAppearance,
                    triggerButtonIcon: triggerButtonIcon,
                    triggerButtonStyle: triggerButtonStyle,
                    triggerButtonTooltipPosition: triggerButtonTooltipPosition,
                    triggerButtonTooltipText: triggerButtonTooltipText,
                    bottomMessage: bottomMessage,
                    submitButtonLabel: shareeAction === 'edit' && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $kb1Mm.messages).inviteTriggerButtonText
                    }),
                    product: product,
                    productAttributes: productAttributes,
                    customHeader: customHeader,
                    customFooter: customFooter,
                    onUserSelectionChange: onUserSelectionChange,
                    shareFieldsFooter: shareFieldsFooter,
                    isCopyDisabled: isCopyDisabled,
                    isPublicLink: isPublicLink,
                    integrationMode: integrationMode,
                    shareIntegrations: shareIntegrations,
                    shareAri: shareAri,
                    tabIndex: tabIndex,
                    copyTooltipText: copyTooltipText,
                    onDialogClose: onDialogClose,
                    isBrowseUsersDisabled: isBrowseUsersDisabled,
                    userPickerOptions: userPickerOptions,
                    additionalTabs: additionalTabs,
                    builtInTabContentWidth: builtInTabContentWidth,
                    isSubmitShareDisabled: isSubmitShareDisabled,
                    additionalUserFields: additionalUserFields,
                    isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                    CustomSubmitButton: CustomSubmitButton
                })
            })
        });
    }
}
const $31cc3a56d6ece013$export$78b28896b43ae5d6 = (0, $4J0ad.default)()($31cc3a56d6ece013$export$bc8c417f2da43f4);

});
parcelRegister("g8IkM", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("6RW0K", function(module, exports) {
$parcel$export(module.exports, "AtlassianUrlShortenerClient", () => $8188663d0abac1ee$export$8fed7002650b52ef);
class $8188663d0abac1ee$export$8fed7002650b52ef {
    async shorten(data) {
        try {
            const response = await fetch('/gateway/api/atl-link/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) throw new Error(`status="${response.status}"`);
            const result = await response.json();
            if (!result.shortUrl) throw new Error('Breach of contract!');
            return result;
        } catch (err) {
            if (err instanceof Error) err.message = `While shortening URL: ${err.message}!`;
            throw err;
        }
    }
}

});

parcelRegister("1dYNL", function(module, exports) {
$parcel$export(module.exports, "ShareServiceClient", () => $4b91c5afa5a23e01$export$ee05f3e1f0248b62);

var $kp3br = parcelRequire("kp3br");
const $4b91c5afa5a23e01$export$a7d7a4246bdd7a12 = 'share';
const $4b91c5afa5a23e01$export$1a440d9a41e6ce3e = 'share/configuration';
const $4b91c5afa5a23e01$export$7745139d0aa6183c = '/gateway/api';
class $4b91c5afa5a23e01$export$ee05f3e1f0248b62 {
    constructor(serviceConfig){
        this.serviceConfig = {
            url: $4b91c5afa5a23e01$export$7745139d0aa6183c,
            ...serviceConfig || {}
        };
    }
    getConfig(cloudId) {
        const options = {
            path: $4b91c5afa5a23e01$export$1a440d9a41e6ce3e,
            queryParams: {
                cloudId: cloudId
            },
            requestInit: {
                method: 'get'
            }
        };
        return (0, $kp3br.utils).requestService(this.serviceConfig, options);
    }
    /**
	 * To send a POST request to the share endpoint in Share service
	 */ share(content, recipients, metadata, comment) {
        return fetch(`${this.serviceConfig.url}/${$4b91c5afa5a23e01$export$a7d7a4246bdd7a12}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            credentials: 'include',
            body: JSON.stringify({
                content: content,
                recipients: recipients,
                metadata: metadata,
                comment: comment
            })
        }).then((response)=>{
            if (response.status === 204) return Promise.resolve();
            else if (response.ok) return response.json();
            else return Promise.reject({
                code: response.status,
                reason: response.statusText,
                body: response.json()
            });
        });
    }
}

});
parcelRegister("kp3br", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("7Eo2D")).AbstractResource);
$parcel$export(module.exports, "utils", () => $6d8672354a8f8023$export$eab97d15b1788b8d);
parcelRequire("cVQsv");
parcelRequire("7Eo2D");

var $cT1cs = parcelRequire("cT1cs");

var $dyzJo = parcelRequire("dyzJo");
const $6d8672354a8f8023$export$eab97d15b1788b8d = $cT1cs;
const $6d8672354a8f8023$export$3b4c04cf7dad0e50 = $dyzJo;

});
parcelRegister("cVQsv", function(module, exports) {
$parcel$export(module.exports, "buildCredentials", () => $f9c5af0d8b1f4531$export$2ac26f1ab7eda637);
const $f9c5af0d8b1f4531$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("7Eo2D", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => $33168f42924c071f$export$4529f10aed0950d4);
class $33168f42924c071f$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("cT1cs", function(module, exports) {
$parcel$export(module.exports, "requestService", () => $8293192fd096fa7a$export$97bfde5a702aaeca);

var $fiPhB = parcelRequire("fiPhB");

var $eGOwo = parcelRequire("eGOwo");

var $4iJGP = parcelRequire("4iJGP");

var $cVQsv = parcelRequire("cVQsv");

var $2Ndb8 = parcelRequire("2Ndb8");
const $8293192fd096fa7a$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $2Ndb8.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2Ndb8.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2Ndb8.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $cVQsv.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $eGOwo.fg)('platform_collab_provider_tracingheaders');
    (0, $4iJGP.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $fiPhB.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $8293192fd096fa7a$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});
parcelRegister("2Ndb8", function(module, exports) {
$parcel$export(module.exports, "defaultRequestServiceOptions", () => $fdc006ca8b04950a$export$160dbda113bfad3b);
$parcel$export(module.exports, "buildUrl", () => $fdc006ca8b04950a$export$b5cd97dee32de81d);
$parcel$export(module.exports, "buildHeaders", () => $fdc006ca8b04950a$export$7d6ed858a91629c3);
const $fdc006ca8b04950a$export$160dbda113bfad3b = {};
const $fdc006ca8b04950a$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $fdc006ca8b04950a$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $fdc006ca8b04950a$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $fdc006ca8b04950a$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $fdc006ca8b04950a$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});


parcelRegister("dyzJo", function(module, exports) {
$parcel$export(module.exports, "requestServiceMultipart", () => $94befa78e14abede$export$8b13532c81e8ac89);

var $hCu6N = parcelRequire("hCu6N");

var $cVQsv = parcelRequire("cVQsv");

var $2Ndb8 = parcelRequire("2Ndb8");

var $eGOwo = parcelRequire("eGOwo");

var $4iJGP = parcelRequire("4iJGP");

var $fiPhB = parcelRequire("fiPhB");
const $94befa78e14abede$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $2Ndb8.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2Ndb8.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2Ndb8.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $cVQsv.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $eGOwo.fg)('platform_collab_provider_tracingheaders');
    (0, $4iJGP.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $fiPhB.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $hCu6N.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $94befa78e14abede$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("hCu6N", function(module, exports) {
$parcel$export(module.exports, "meros", () => $cd3d5734723579c0$export$74e0a034be2368c7);
var $cd3d5734723579c0$var$e = new TextDecoder;
async function $cd3d5734723579c0$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $cd3d5734723579c0$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}

});




parcelRegister("kb1Mm", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8ac2d91862497381$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $8ac2d91862497381$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    formTitle: {
        id: 'fabric.elements.share.form.title',
        defaultMessage: 'Share',
        description: 'Title for Share form.'
    },
    formSend: {
        id: 'fabric.elements.share.form.send',
        defaultMessage: 'Send',
        description: 'Label for Share form submit button.'
    },
    formShare: {
        id: 'fabric.elements.share.form.share',
        defaultMessage: 'Share',
        description: 'Label for Share form submit button.'
    },
    formSendPublic: {
        id: 'fabric.elements.share.form.public.send',
        defaultMessage: 'Send public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formSharePublic: {
        id: 'fabric.elements.share.form.public.share',
        defaultMessage: 'Share public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formRetry: {
        id: 'fabric.elements.share.form.retry',
        defaultMessage: 'Retry',
        description: 'Label for Share from retry button.'
    },
    formNoPermissions: {
        id: 'fabric.elements.share.form.no-permissions',
        defaultMessage: 'You do not have the ability to share.',
        description: 'Copy to show when a user can not share.'
    },
    commentLabel: {
        id: 'fabric.elements.share.form.comment.label',
        defaultMessage: 'Message (optional)',
        description: 'Label for the comment field in the Share form.'
    },
    extendedDialogCommentLabel: {
        id: 'fabric.elements.share.form.extended.dialog.comment.label',
        defaultMessage: 'Message',
        description: 'Label for the comment field in the extended share dialog.'
    },
    commentPlaceholder: {
        id: 'fabric.elements.share.form.comment.placeholder',
        defaultMessage: 'Anything they should know?',
        description: 'Placeholder for the comment field in Share form.'
    },
    // Email disabled (Jira)
    userPickerLabelEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-jira',
        defaultMessage: 'Names or teams',
        description: 'Label for the user picker field in the Share form in Jira with no email option.'
    },
    userPickerPlaceholderEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira',
        defaultMessage: 'e.g. Maria, Team Orange',
        description: 'Placeholder for the user picker field in the Share form in Jira with no email option. These examples should be localized.'
    },
    userPickerRequiredMessageEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira',
        defaultMessage: 'Select at least one person or team',
        description: 'Error message for the user picker field in the Share form in Jira with no email option, when no entries are selected.'
    },
    // Email disabled (Confluence)
    userPickerLabelEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-confluence',
        defaultMessage: 'Names, teams, or groups',
        description: 'Label for the user picker field in the Share form in Confluence with no email option.'
    },
    userPickerRequiredMessageEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence',
        defaultMessage: 'Select at least one person, team, or group',
        description: 'Error message for the user picker field in the Share form in Confluence with no email option, when no entries are selected.'
    },
    // Browse users disabled
    userPickerLabelBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.label.email-only',
        defaultMessage: 'Emails',
        description: 'Label for the user picker field in the Share form when browse user permissions are disabled.'
    },
    userPickerPlaceholderBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-only',
        defaultMessage: 'e.g. maria@company.com',
        description: 'Placeholder for the user picker field in the Share form when browse user permissions are disabled. These examples should be localized.'
    },
    userPickerRequiredMessageBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-only',
        defaultMessage: 'Select at least one email',
        description: 'Error message for the user picker field in the Share form in when browse user permissions are disabled, when no entries are selected.'
    },
    // Generic (Jira)
    userPickerLabelJira: {
        id: 'fabric.elements.share.form.user-picker.label.jira',
        defaultMessage: 'Names, teams, or emails',
        description: 'Label for the user picker field in the Share form in Jira.'
    },
    userPickerPlaceholderJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.jira',
        defaultMessage: 'e.g. Maria, Team Orange, maria@company.com',
        description: 'Placeholder for the user picker field in the Share form in Jira. These examples should be localized.'
    },
    userPickerRequiredMessageJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.jira',
        defaultMessage: 'Select at least one person, team, or email',
        description: 'Error message for the user picker field in the Share form in Jira, when no entries are selected.'
    },
    // Generic (Confluence)
    userPickerLabelConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.confluence',
        defaultMessage: 'Names, teams, groups, or emails',
        description: 'Label for the user picker field in the Share form in Confluence.'
    },
    userPickerPlaceholderConfluence: {
        id: 'fabric.elements.share.form.user-picker.placeholder.confluence',
        defaultMessage: 'e.g. Maria, Team Orange, group-one',
        description: 'Placeholder for the user picker field in the Share form in Confluence. These examples should be localized.'
    },
    userPickerRequiredMessageConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.confluence',
        defaultMessage: 'Select at least one person, team, group, or email',
        description: 'Error message for the user picker field in the Share form in Confluence, when no entries are selected.'
    },
    // Common messages
    userPickerAddMoreMessage: {
        id: 'fabric.elements.share.form.user-picker.add-more',
        defaultMessage: 'Enter more',
        description: 'Message to encourage the user to add more items to user picker in Share form.'
    },
    userPickerRequiredMessage: {
        id: 'fabric.elements.share.form.user-picker.validation.required',
        defaultMessage: 'Select at least one user, group, team or email.',
        description: 'Required error message for the user picker field in Share form.'
    },
    userPickerExistingUserOnlyNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.existingUserOnly',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}".`,
        description: 'Existing user only no options message displayed when the search for users returns empty.'
    },
    userPickerGenericNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.generic',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}". Invite people by using an email address.`,
        description: 'Generic no options message displayed when the search for users returns empty.'
    },
    shareTriggerButtonIconLabel: {
        id: 'fabric.elements.share.trigger.button.icon.label',
        defaultMessage: 'Share icon',
        description: 'Default text for aria-label of the share dialog trigger button icon'
    },
    shareTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.text',
        defaultMessage: 'Share',
        description: 'Default text for the share dialog trigger button'
    },
    shareTriggerButtonTooltipText: {
        id: 'fabric.elements.share.trigger.button.tooltip.text',
        defaultMessage: 'Share',
        description: 'Default text for tooltip on the icon-only share dialog trigger button'
    },
    inviteTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.invite.text',
        defaultMessage: 'Invite',
        description: 'Button label for when the sharee action is set to "edit".'
    },
    copyLinkButtonText: {
        id: 'fabric.elements.share.copylink.button.text',
        defaultMessage: 'Copy link',
        description: 'Default text for the Copy Link button'
    },
    copyPublicLinkButtonText: {
        id: 'fabric.elements.share.copypubliclink.button.text',
        defaultMessage: 'Copy public link',
        description: 'Default text for the Copy Link button when the link is public'
    },
    copiedToClipboardMessage: {
        id: 'fabric.elements.share.copied.to.clipboard.message',
        defaultMessage: 'Link copied to clipboard',
        description: 'Default text for the copied link message'
    },
    infoMessageDefaultConfluence: {
        id: 'fabric.elements.share.form.info.message.no.invite.confluence',
        defaultMessage: 'Recipients will see the name of the page and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Confluence page title and the included message'
    },
    infoMessageDefaultJira: {
        id: 'fabric.elements.share.form.info.message.no.invite.jira',
        defaultMessage: 'Recipients will see the name of the issue and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Jira issue title and the included message'
    },
    infoMessageDefaultJiraIssueTermRefresh: {
        id: 'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh',
        defaultMessage: 'Recipients will see the name of the work item and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Jira issue title and the included message'
    },
    requiredFieldSummary: {
        id: 'fabric.elements.share.form.required-field.summary',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Summary info of required fields asterisk.'
    },
    shareFailureIconLabel: {
        id: 'fabric.elements.share.failure.icon.label',
        defaultMessage: 'Error icon',
        description: 'Default text for the aria-label of the share failure error icon in the tooltip'
    },
    shareFailureMessage: {
        id: 'fabric.elements.share.failure.message',
        defaultMessage: 'Unable to share',
        description: 'Default text for share failure message displayed in the tooltip'
    },
    shareSuccessMessage: {
        id: 'fabric.elements.share.success.message',
        defaultMessage: "{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}",
        description: 'Default text for share success message displayed in a flag'
    },
    shareToIntegrationButtonText: {
        id: 'fabric.elements.share.to.integration.button',
        defaultMessage: 'Share to {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareInIntegrationButtonText: {
        id: 'fabric.elements.share.in.integration.button',
        defaultMessage: 'Share in {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareMainTabTextJira: {
        id: 'fabric.elements.share.main.tab.text.jira',
        defaultMessage: 'Share issue',
        description: 'Text for the main share tab for jira'
    },
    shareMainTabTextConfluence: {
        id: 'fabric.elements.share.main.tab.text.confluence',
        defaultMessage: 'Share page',
        description: 'Text for the main share tab for confluence'
    },
    inviteToConfluence: {
        id: 'fabric.elements.share.invite.to.confluence',
        defaultMessage: 'Invite to Confluence',
        description: 'Text for the byline of the non-licensed users'
    },
    inviteToJira: {
        id: 'fabric.elements.share.invite.to.jira',
        defaultMessage: 'Invite to Jira',
        description: 'Text for the byline of the non-licensed users'
    },
    sharePopupLabel: {
        id: 'fabric.elements.share.popup.label',
        defaultMessage: 'Share',
        description: 'Label of the popup that contains share menu used by assistive technologies'
    },
    slackMenuItemText: {
        id: 'fabric.elements.share.menu.slack.label',
        defaultMessage: 'Slack',
        description: 'Text for the slack menu in share'
    },
    emailMenuItemText: {
        id: 'fabric.elements.share.menu.email.label',
        defaultMessage: 'Email',
        description: 'Text for the email menu in share'
    }
});

});

parcelRegister("63G4N", function(module, exports) {
$parcel$export(module.exports, "CHANNEL_ID", () => $ff890a90d1a7bda5$export$e5fd2b76433ec8a8);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $ff890a90d1a7bda5$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "INTEGRATION_MODAL_SOURCE", () => $ff890a90d1a7bda5$export$8944b0a832f27e18);
$parcel$export(module.exports, "screenEvent", () => $ff890a90d1a7bda5$export$a129deea0412e0d8);
$parcel$export(module.exports, "shareSplitButtonEvent", () => $ff890a90d1a7bda5$export$eab30ffadcd0ab75);
$parcel$export(module.exports, "shareIntegrationButtonEvent", () => $ff890a90d1a7bda5$export$f04d85d45801fef1);
$parcel$export(module.exports, "errorEncountered", () => $ff890a90d1a7bda5$export$afe83ea4a1997503);
$parcel$export(module.exports, "shareTriggerButtonClicked", () => $ff890a90d1a7bda5$export$584e8ee8b04ff145);
$parcel$export(module.exports, "shareTabClicked", () => $ff890a90d1a7bda5$export$544b588ba577a9a6);
$parcel$export(module.exports, "shareMenuItemClicked", () => $ff890a90d1a7bda5$export$69ab8fd7ab99f6db);
$parcel$export(module.exports, "cancelShare", () => $ff890a90d1a7bda5$export$b4731c87331a8174);
$parcel$export(module.exports, "shortUrlRequested", () => $ff890a90d1a7bda5$export$35781a2d50f9fba9);
$parcel$export(module.exports, "shortUrlGenerated", () => $ff890a90d1a7bda5$export$e78d65558f8d859a);
$parcel$export(module.exports, "shareConfigurationLoaded", () => $ff890a90d1a7bda5$export$75ace3c1905ea74c);
$parcel$export(module.exports, "shareConfigurationLoadFailed", () => $ff890a90d1a7bda5$export$cbf264bae587b83d);
$parcel$export(module.exports, "copyLinkButtonClicked", () => $ff890a90d1a7bda5$export$9af471d00b79f9b0);
$parcel$export(module.exports, "formShareSubmitted", () => $ff890a90d1a7bda5$export$e2e6cacbe383cb80);
$parcel$export(module.exports, "jiraPageSharedEvent", () => $ff890a90d1a7bda5$export$7ab6dc9ee5da4a70);

var $bp6ad = parcelRequire("bp6ad");
const $ff890a90d1a7bda5$var$buildAttributes = (attributes = {})=>({
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        ...attributes
    });
const $ff890a90d1a7bda5$var$createEvent = (eventType, source, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        source: source,
        attributes: $ff890a90d1a7bda5$var$buildAttributes(attributes)
    });
const $ff890a90d1a7bda5$var$createScreenEvent = (name, attributes = {})=>({
        eventType: 'screen',
        name: name,
        attributes: $ff890a90d1a7bda5$var$buildAttributes(attributes)
    });
const $ff890a90d1a7bda5$export$e5fd2b76433ec8a8 = 'fabric-elements';
const $ff890a90d1a7bda5$export$f7109619a5e9e0d6 = 'shareModal';
const $ff890a90d1a7bda5$export$8944b0a832f27e18 = 'integrationShareDialog';
const $ff890a90d1a7bda5$export$a129deea0412e0d8 = ({ isPublicLink: isPublicLink = false })=>$ff890a90d1a7bda5$var$createScreenEvent($ff890a90d1a7bda5$export$f7109619a5e9e0d6, {
        isPublicLink: isPublicLink
    });
const $ff890a90d1a7bda5$export$eab30ffadcd0ab75 = ()=>$ff890a90d1a7bda5$var$createEvent('ui', $ff890a90d1a7bda5$export$8944b0a832f27e18, 'clicked', 'button', 'shareSplitButton');
const $ff890a90d1a7bda5$export$f04d85d45801fef1 = (type = '')=>$ff890a90d1a7bda5$var$createEvent('ui', $ff890a90d1a7bda5$export$8944b0a832f27e18, 'clicked', 'button', 'shareToIntegration', {
        integrationType: type.toLowerCase()
    });
const $ff890a90d1a7bda5$export$afe83ea4a1997503 = (actionSubjectId, attributes = {})=>$ff890a90d1a7bda5$var$createEvent('operational', $ff890a90d1a7bda5$export$f7109619a5e9e0d6, 'encountered', 'error', actionSubjectId, {
        ...attributes,
        source: $ff890a90d1a7bda5$export$f7109619a5e9e0d6
    });
const $ff890a90d1a7bda5$export$584e8ee8b04ff145 = ()=>$ff890a90d1a7bda5$var$createEvent('ui', $ff890a90d1a7bda5$export$f7109619a5e9e0d6, 'clicked', 'button', 'share');
const $ff890a90d1a7bda5$export$544b588ba577a9a6 = (subjectId, shareContentType)=>$ff890a90d1a7bda5$var$createEvent('ui', $ff890a90d1a7bda5$export$f7109619a5e9e0d6, 'clicked', 'tab', subjectId || 'shareTab', {
        shareContentType: shareContentType
    });
const $ff890a90d1a7bda5$export$69ab8fd7ab99f6db = (subjectId, shareContentType)=>$ff890a90d1a7bda5$var$createEvent('ui', $ff890a90d1a7bda5$export$f7109619a5e9e0d6, 'clicked', 'menuItem', subjectId || 'shareMenuItem', {
        shareContentType: shareContentType
    });
const $ff890a90d1a7bda5$export$b4731c87331a8174 = (start)=>$ff890a90d1a7bda5$var$createEvent('ui', $ff890a90d1a7bda5$export$f7109619a5e9e0d6, 'pressed', 'keyboardShortcut', 'cancelShare', {
        source: $ff890a90d1a7bda5$export$f7109619a5e9e0d6,
        duration: $ff890a90d1a7bda5$var$duration(start)
    });
const $ff890a90d1a7bda5$export$35781a2d50f9fba9 = ()=>$ff890a90d1a7bda5$var$createEvent('operational', $ff890a90d1a7bda5$export$f7109619a5e9e0d6, 'requested', 'shortUrl', undefined, {
        source: $ff890a90d1a7bda5$export$f7109619a5e9e0d6
    });
const $ff890a90d1a7bda5$export$e78d65558f8d859a = (start, tooSlow)=>$ff890a90d1a7bda5$var$createEvent('operational', $ff890a90d1a7bda5$export$f7109619a5e9e0d6, 'generated', 'shortUrl', undefined, {
        source: $ff890a90d1a7bda5$export$f7109619a5e9e0d6,
        duration: $ff890a90d1a7bda5$var$duration(start),
        tooSlow: tooSlow
    });
const $ff890a90d1a7bda5$export$75ace3c1905ea74c = (attributes)=>$ff890a90d1a7bda5$var$createEvent('track', $ff890a90d1a7bda5$export$f7109619a5e9e0d6, 'loaded', 'shareConfiguration', undefined, {
        source: $ff890a90d1a7bda5$export$f7109619a5e9e0d6,
        ...attributes
    });
const $ff890a90d1a7bda5$export$cbf264bae587b83d = (attributes)=>$ff890a90d1a7bda5$var$createEvent('track', $ff890a90d1a7bda5$export$f7109619a5e9e0d6, 'error', 'shareConfiguration', undefined, {
        source: $ff890a90d1a7bda5$export$f7109619a5e9e0d6,
        ...attributes
    });
const $ff890a90d1a7bda5$export$9af471d00b79f9b0 = ({ start: start, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false, ari: ari })=>$ff890a90d1a7bda5$var$createEvent('ui', $ff890a90d1a7bda5$export$f7109619a5e9e0d6, 'clicked', 'button', 'copyShareLink', {
        source: $ff890a90d1a7bda5$export$f7109619a5e9e0d6,
        duration: $ff890a90d1a7bda5$var$duration(start),
        shortUrl: undefined,
        // unknown at creation, will be filled later
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        isPublicLink: isPublicLink,
        ari: ari,
        // this specific string is needed for marking a successful navigation session
        navdexPointType: 'navigationSessionEnd',
        ...$ff890a90d1a7bda5$var$getOriginTracingAttributes(shareOrigin)
    });
const $ff890a90d1a7bda5$export$e2e6cacbe383cb80 = ({ start: start, data: data, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false })=>{
    const users = $ff890a90d1a7bda5$var$extractIdsByType(data, (0, $bp6ad.isUser));
    const externalUsers = $ff890a90d1a7bda5$var$extractIdsByType(data, (0, $bp6ad.isExternalUser));
    const groups = $ff890a90d1a7bda5$var$extractIdsByType(data, (0, $bp6ad.isGroup));
    const teams = $ff890a90d1a7bda5$var$extractIdsByType(data, (0, $bp6ad.isTeam));
    const teamUserCounts = $ff890a90d1a7bda5$var$extractMemberCountsFromTeams(data, (0, $bp6ad.isTeam));
    const emails = $ff890a90d1a7bda5$var$extractIdsByType(data, (0, $bp6ad.isEmail));
    return $ff890a90d1a7bda5$var$createEvent('ui', $ff890a90d1a7bda5$export$f7109619a5e9e0d6, 'clicked', 'button', 'submitShare', {
        ...$ff890a90d1a7bda5$var$getOriginTracingAttributes(shareOrigin),
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        duration: $ff890a90d1a7bda5$var$duration(start),
        emailCount: emails.length,
        teamCount: teams.length,
        userCount: users.length,
        groupCount: groups.length,
        externalUserCount: externalUsers.length,
        users: users,
        teams: teams,
        teamUserCounts: teamUserCounts,
        groups: groups,
        messageLength: data.comment && data.comment.format === 'plain_text' ? data.comment.value.length : 0,
        isMessageEnabled: true,
        isPublicLink: isPublicLink
    });
};
const $ff890a90d1a7bda5$var$duration = (start)=>Date.now() - start;
const $ff890a90d1a7bda5$var$getOriginTracingAttributes = (origin)=>origin ? origin.toAnalyticsAttributes({
        hasGeneratedId: true
    }) : {};
const $ff890a90d1a7bda5$var$extractIdsByType = (data, checker)=>data.users.filter(checker).map((option)=>option.id);
const $ff890a90d1a7bda5$var$extractMemberCountsFromTeams = (data, checker)=>// teams with zero memberships cannot exist in share, so we use that
    // as the default value for undefined team member counts
    data.users.filter(checker).map((option)=>option.memberCount || 0);
const $ff890a90d1a7bda5$export$7ab6dc9ee5da4a70 = ({ start: start, data: data, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false, productAttributes: productAttributes, loggedInAccountId: loggedInAccountId, source: source = $ff890a90d1a7bda5$export$f7109619a5e9e0d6, actionSubjectId: actionSubjectId = 'submitShare' })=>{
    const users = $ff890a90d1a7bda5$var$extractIdsByType(data, (0, $bp6ad.isUser));
    const externalUsers = $ff890a90d1a7bda5$var$extractIdsByType(data, (0, $bp6ad.isExternalUser));
    const groups = $ff890a90d1a7bda5$var$extractIdsByType(data, (0, $bp6ad.isGroup));
    const teams = $ff890a90d1a7bda5$var$extractIdsByType(data, (0, $bp6ad.isTeam));
    const teamUserCounts = $ff890a90d1a7bda5$var$extractMemberCountsFromTeams(data, (0, $bp6ad.isTeam));
    const emails = $ff890a90d1a7bda5$var$extractIdsByType(data, (0, $bp6ad.isEmail));
    const baseAttributes = {
        duration: $ff890a90d1a7bda5$var$duration(start),
        source: source,
        contentType: shareContentType,
        projectType: productAttributes?.projectType,
        // software, business
        projectStyle: productAttributes?.projectStyle,
        // TEAM_MANAGED_PROJECT, COMPANY_MANAGED_PROJECT
        userLocation: productAttributes?.userLocation,
        // issue:issue, classic-software:rapidboard-board etc.
        isAdmin: productAttributes?.isAdmin,
        isProjectAdmin: productAttributes?.isProjectAdmin,
        ...$ff890a90d1a7bda5$var$getOriginTracingAttributes(shareOrigin),
        contentId: shareContentId,
        isPublicLink: isPublicLink,
        loggedInAccountId: loggedInAccountId,
        shareContentSubType: shareContentSubType,
        externalUsers: externalUsers
    };
    // User/team/group data (only for non-copy-link shares)
    const shareSpecificAttributes = data.users.length > 0 ? {
        users: users,
        userCount: users.length,
        teams: teams,
        teamCount: teams.length,
        teamCounts: teamUserCounts,
        groups: groups,
        groupCount: groups.length,
        emailCount: emails.length
    } : {};
    return $ff890a90d1a7bda5$var$createEvent('track', source, 'shared', 'page', actionSubjectId, {
        ...baseAttributes,
        ...shareSpecificAttributes
    });
};

});
parcelRegister("bp6ad", function(module, exports) {
$parcel$export(module.exports, "isExternalUser", () => $144d288a5555e012$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $144d288a5555e012$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $144d288a5555e012$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $144d288a5555e012$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $144d288a5555e012$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $144d288a5555e012$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $144d288a5555e012$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $144d288a5555e012$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $144d288a5555e012$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $144d288a5555e012$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $144d288a5555e012$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $144d288a5555e012$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $144d288a5555e012$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $144d288a5555e012$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $144d288a5555e012$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $144d288a5555e012$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $144d288a5555e012$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $144d288a5555e012$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $144d288a5555e012$export$5419897287f5f1c7);

var $LFmXM = parcelRequire("LFmXM");


var $sl8jM = parcelRequire("sl8jM");
const $144d288a5555e012$export$f6058dbcb5980cb = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $144d288a5555e012$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $f4e041c5b2b1b75c$export$8436e53e45ffe15b);
const $144d288a5555e012$export$f8c4277cb588611f = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$26bc40b960693765);
const $144d288a5555e012$export$d7976824e9f55785 = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$d460f747b73abb10);
const $144d288a5555e012$export$7fbbfbca30081d0 = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$6662b3461398ef8c);
const $144d288a5555e012$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$eafd0979afa5b224);
const $144d288a5555e012$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $144d288a5555e012$var$isOptionData = (option)=>option.name !== undefined;
const $144d288a5555e012$export$3f993c492bd6c728 = (option)=>{
    if ($144d288a5555e012$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $144d288a5555e012$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $144d288a5555e012$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $144d288a5555e012$export$d2312e68e1f5ad00 = (0, $LFmXM.default)((options)=>options.map($144d288a5555e012$export$3f993c492bd6c728));
const $144d288a5555e012$export$e6fda14a194bcbcc = (0, $LFmXM.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($144d288a5555e012$export$3f993c492bd6c728);
    return $144d288a5555e012$export$3f993c492bd6c728(defaultValue);
});
const $144d288a5555e012$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $144d288a5555e012$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $144d288a5555e012$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $144d288a5555e012$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $144d288a5555e012$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $144d288a5555e012$export$b4f8f1f54acec99b = (optionData)=>{
    if ($144d288a5555e012$export$2e44165f1da65304(optionData) || $144d288a5555e012$export$f8c4277cb588611f(optionData) || $144d288a5555e012$export$d3a8f0b77e9737fc(optionData) || $144d288a5555e012$export$f6058dbcb5980cb(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $144d288a5555e012$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $sl8jM.default);
const $144d288a5555e012$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $144d288a5555e012$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $f4e041c5b2b1b75c$export$8436e53e45ffe15b = 'user';
const $f4e041c5b2b1b75c$export$50042ec1d2e00e63 = 'external_user';
const $f4e041c5b2b1b75c$export$26bc40b960693765 = 'team';
const $f4e041c5b2b1b75c$export$d460f747b73abb10 = 'group';
const $f4e041c5b2b1b75c$export$6662b3461398ef8c = 'email';
const $f4e041c5b2b1b75c$export$eafd0979afa5b224 = 'custom';

parcelRegister("sl8jM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f040ddaa0ef5501e$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $aQK2r = parcelRequire("aQK2r");

var $1Q3jn = parcelRequire("1Q3jn");

var $7QJq6 = parcelRequire("7QJq6");
var $i0xNm = parcelRequire("i0xNm");
var $lEbH4 = parcelRequire("lEbH4");

var $5yteI = parcelRequire("5yteI");

var $gl2vi = parcelRequire("gl2vi");

var $eGOwo = parcelRequire("eGOwo");

var $e9zKl = parcelRequire("e9zKl");


var $c4OV1 = parcelRequire("c4OV1");

var $5nAXq = parcelRequire("5nAXq");

var $ctyCN = parcelRequire("ctyCN");
/**
 * Are we rendering on the client or server?
 */ const $f040ddaa0ef5501e$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $f040ddaa0ef5501e$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
/**
 * The new defaults match the default modifiers of `@atlaskit/popper`.
 *
 * In the future we should investigate using `@atlaskit/popper` instead of
 * consuming `react-popper` directly.
 *
 * Previously the select popup would slide over the trigger to try to stay visible.
 * This behavior could actually cause it to go offscreen.
 *
 * Now it will stay anchored above / below the trigger and cause the
 * clipping parent to scroll if necessary. This aligns with other popups.
 */ const $f040ddaa0ef5501e$var$newDefaultModifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'document'
        }
    },
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
const $f040ddaa0ef5501e$var$defaultPopperProps = {
    modifiers: $f040ddaa0ef5501e$var$modifiers,
    placement: 'bottom-start'
};
const $f040ddaa0ef5501e$var$newDefaultPopperProps = {
    modifiers: $f040ddaa0ef5501e$var$newDefaultModifiers,
    placement: 'bottom-start'
};
const $f040ddaa0ef5501e$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $f040ddaa0ef5501e$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...(0, $eGOwo.fg)('platform_dst_nav4_layering_in_main_slot_fixes') ? $f040ddaa0ef5501e$var$newDefaultPopperProps : $f040ddaa0ef5501e$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $5yteI.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $5nAXq.defaultComponents),
            ...props.components
        };
        if (!(0, $5yteI.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$f040ddaa0ef5501e$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $4eDgu.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7QJq6.Manager), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gl2vi.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lEbH4.Reference), {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ctyCN.NotifyOpenLayerObserver), {
                    isOpen: this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$eaa8c8a70ac22806})`
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $5nAXq.defaultComponents),
            mergedPopperProps: (0, $eGOwo.fg)('platform_dst_nav4_layering_in_main_slot_fixes') ? $f040ddaa0ef5501e$var$newDefaultPopperProps : $f040ddaa0ef5501e$var$defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $4eDgu.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $f040ddaa0ef5501e$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $5nAXq.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const popper = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i0xNm.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $5nAXq.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1Q3jn.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                                    label: getLabel(),
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    styles: (0, $e9zKl.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $aQK2r.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.close();
        };
    }
}

});
parcelRegister("7QJq6", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $5b709f3958b336e6$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $5b709f3958b336e6$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $5b709f3958b336e6$export$d0d38e7dec7a1a61);

var $eJOHy = parcelRequire("eJOHy");
var $5b709f3958b336e6$export$3dbd3405086fec7b = $eJOHy.createContext();
var $5b709f3958b336e6$export$cbabb21c2529b130 = $eJOHy.createContext();
function $5b709f3958b336e6$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eJOHy.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eJOHy.useRef(false);
    $eJOHy.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eJOHy.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eJOHy.createElement($5b709f3958b336e6$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eJOHy.createElement($5b709f3958b336e6$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("i0xNm", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $d1c2711317bcdd69$export$badac9ada3a0bdf9);

var $eJOHy = parcelRequire("eJOHy");

var $7QJq6 = parcelRequire("7QJq6");

var $65sWw = parcelRequire("65sWw");

var $8E4Pq = parcelRequire("8E4Pq");
var $d1c2711317bcdd69$var$NOOP = function NOOP() {
    return void 0;
};
var $d1c2711317bcdd69$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $d1c2711317bcdd69$var$EMPTY_MODIFIERS = [];
function $d1c2711317bcdd69$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $d1c2711317bcdd69$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eJOHy.useContext((0, $7QJq6.ManagerReferenceNodeContext));
    var _React$useState = $eJOHy.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eJOHy.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eJOHy.useEffect(function() {
        (0, $65sWw.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eJOHy.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $8E4Pq.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eJOHy.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $d1c2711317bcdd69$var$NOOP,
            update: update || $d1c2711317bcdd69$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $65sWw.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("65sWw", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $46e9a926da059f7f$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $46e9a926da059f7f$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $46e9a926da059f7f$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $46e9a926da059f7f$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $46e9a926da059f7f$export$700979bc83e7db82);

var $eJOHy = parcelRequire("eJOHy");
var $46e9a926da059f7f$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $46e9a926da059f7f$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $46e9a926da059f7f$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $46e9a926da059f7f$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $46e9a926da059f7f$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $46e9a926da059f7f$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eJOHy.useLayoutEffect : $eJOHy.useEffect;

});

parcelRegister("8E4Pq", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $64b5cdf5dd511d2b$export$f4d5bf230a36dd6e);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $gnxAv = parcelRequire("gnxAv");

var $aVrYR = parcelRequire("aVrYR");

var $65sWw = parcelRequire("65sWw");
var $64b5cdf5dd511d2b$var$EMPTY_MODIFIERS = [];
var $64b5cdf5dd511d2b$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eJOHy.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $64b5cdf5dd511d2b$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eJOHy.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eJOHy.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $aQK2r.flushSync(function() {
                    setState({
                        styles: (0, $65sWw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $65sWw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eJOHy.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($aVrYR)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eJOHy.useRef();
    (0, $65sWw.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $65sWw.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $gnxAv.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("gnxAv", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $bec8d928f7873785$export$8f7491d57c8f97a9);

var $heIbG = parcelRequire("heIbG");

var $bMX9T = parcelRequire("bMX9T");

var $3lXAT = parcelRequire("3lXAT");

var $9rdGq = parcelRequire("9rdGq");

var $9HkoV = parcelRequire("9HkoV");

var $f7Vnd = parcelRequire("f7Vnd");

var $6DBHs = parcelRequire("6DBHs");

var $31C6T = parcelRequire("31C6T");

var $a6oPx = parcelRequire("a6oPx");

var $c2Bzy = parcelRequire("c2Bzy");


var $bec8d928f7873785$export$d34966752335dd47 = [
    (0, $bMX9T.default),
    (0, $3lXAT.default),
    (0, $9rdGq.default),
    (0, $9HkoV.default),
    (0, $f7Vnd.default),
    (0, $6DBHs.default),
    (0, $31C6T.default),
    (0, $a6oPx.default),
    (0, $c2Bzy.default)
];
var $bec8d928f7873785$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $heIbG.popperGenerator)({
    defaultModifiers: $bec8d928f7873785$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("heIbG", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $c8c60531711653f3$export$ed5e13716264f202);

var $elLvv = parcelRequire("elLvv");

var $9J30E = parcelRequire("9J30E");

var $kXPOQ = parcelRequire("kXPOQ");

var $5hADZ = parcelRequire("5hADZ");

var $467x6 = parcelRequire("467x6");

var $bQzW7 = parcelRequire("bQzW7");

var $287ko = parcelRequire("287ko");


var $gg6Qu = parcelRequire("gg6Qu");
var $c8c60531711653f3$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $c8c60531711653f3$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $c8c60531711653f3$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $c8c60531711653f3$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $c8c60531711653f3$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $gg6Qu.isElement)(reference) ? (0, $kXPOQ.default)(reference) : reference.contextElement ? (0, $kXPOQ.default)(reference.contextElement) : [],
                    popper: (0, $kXPOQ.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $467x6.default)((0, $287ko.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$c8c60531711653f3$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $elLvv.default)(reference, (0, $5hADZ.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9J30E.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bQzW7.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$c8c60531711653f3$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $c8c60531711653f3$export$8f7491d57c8f97a9 = /*#__PURE__*/ $c8c60531711653f3$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("elLvv", function(module, exports) {
$parcel$export(module.exports, "default", () => $a727e0cb46add6f0$export$2e2bcd8739ae039);

var $k65dW = parcelRequire("k65dW");

var $g4m1c = parcelRequire("g4m1c");

var $4baem = parcelRequire("4baem");

var $gg6Qu = parcelRequire("gg6Qu");

var $2uwXd = parcelRequire("2uwXd");

var $7gyBU = parcelRequire("7gyBU");

var $9Uhst = parcelRequire("9Uhst");

var $8amqe = parcelRequire("8amqe");
function $a727e0cb46add6f0$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8amqe.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8amqe.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $a727e0cb46add6f0$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $gg6Qu.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $gg6Qu.isHTMLElement)(offsetParent) && $a727e0cb46add6f0$var$isElementScaled(offsetParent);
    var documentElement = (0, $7gyBU.default)(offsetParent);
    var rect = (0, $k65dW.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4baem.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9Uhst.default)(documentElement)) scroll = (0, $g4m1c.default)(offsetParent);
        if ((0, $gg6Qu.isHTMLElement)(offsetParent)) {
            offsets = (0, $k65dW.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2uwXd.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("k65dW", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea186b851f3316f0$export$2e2bcd8739ae039);

var $gg6Qu = parcelRequire("gg6Qu");

var $8amqe = parcelRequire("8amqe");

var $fWmj3 = parcelRequire("fWmj3");

var $2aPrh = parcelRequire("2aPrh");
function $ea186b851f3316f0$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $gg6Qu.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8amqe.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8amqe.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $gg6Qu.isElement)(element) ? (0, $fWmj3.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2aPrh.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("gg6Qu", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $bd63735f7342e30f$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $bd63735f7342e30f$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $bd63735f7342e30f$export$af51f0f06c0f328a);

var $fWmj3 = parcelRequire("fWmj3");
function $bd63735f7342e30f$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fWmj3.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $bd63735f7342e30f$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fWmj3.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $bd63735f7342e30f$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $fWmj3.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("fWmj3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9ad935b388d902f$export$2e2bcd8739ae039);
function $b9ad935b388d902f$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("8amqe", function(module, exports) {
$parcel$export(module.exports, "max", () => $5f20a67c3007211c$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $5f20a67c3007211c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $5f20a67c3007211c$export$2077e0241d6afd3c);
var $5f20a67c3007211c$export$8960430cfd85939f = Math.max;
var $5f20a67c3007211c$export$96ec731ed4dcb222 = Math.min;
var $5f20a67c3007211c$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2aPrh", function(module, exports) {
$parcel$export(module.exports, "default", () => $19546aaa985cfe85$export$2e2bcd8739ae039);

var $jfbGV = parcelRequire("jfbGV");
function $19546aaa985cfe85$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $jfbGV.default)());
}

});
parcelRegister("jfbGV", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0287cade039ed57$export$2e2bcd8739ae039);
function $e0287cade039ed57$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("g4m1c", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb2e196d14a21ebf$export$2e2bcd8739ae039);

var $cOno9 = parcelRequire("cOno9");

var $fWmj3 = parcelRequire("fWmj3");

var $gg6Qu = parcelRequire("gg6Qu");

var $cjw1I = parcelRequire("cjw1I");
function $bb2e196d14a21ebf$export$2e2bcd8739ae039(node) {
    if (node === (0, $fWmj3.default)(node) || !(0, $gg6Qu.isHTMLElement)(node)) return (0, $cOno9.default)(node);
    else return (0, $cjw1I.default)(node);
}

});
parcelRegister("cOno9", function(module, exports) {
$parcel$export(module.exports, "default", () => $953c4c05b181c08e$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");
function $953c4c05b181c08e$export$2e2bcd8739ae039(node) {
    var win = (0, $fWmj3.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("cjw1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f701a3aded86182$export$2e2bcd8739ae039);
function $8f701a3aded86182$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("4baem", function(module, exports) {
$parcel$export(module.exports, "default", () => $30b0201497441060$export$2e2bcd8739ae039);
function $30b0201497441060$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("2uwXd", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d07f21abc9989f4$export$2e2bcd8739ae039);

var $k65dW = parcelRequire("k65dW");

var $7gyBU = parcelRequire("7gyBU");

var $cOno9 = parcelRequire("cOno9");
function $1d07f21abc9989f4$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $k65dW.default)((0, $7gyBU.default)(element)).left + (0, $cOno9.default)(element).scrollLeft;
}

});
parcelRegister("7gyBU", function(module, exports) {
$parcel$export(module.exports, "default", () => $54a4dfebec89ee7e$export$2e2bcd8739ae039);

var $gg6Qu = parcelRequire("gg6Qu");
function $54a4dfebec89ee7e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $gg6Qu.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("9Uhst", function(module, exports) {
$parcel$export(module.exports, "default", () => $7366e2de4224a174$export$2e2bcd8739ae039);

var $gJ1QC = parcelRequire("gJ1QC");
function $7366e2de4224a174$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $gJ1QC.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("gJ1QC", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2d24838526c2191$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");
function $c2d24838526c2191$export$2e2bcd8739ae039(element) {
    return (0, $fWmj3.default)(element).getComputedStyle(element);
}

});



parcelRegister("9J30E", function(module, exports) {
$parcel$export(module.exports, "default", () => $714aa6a5cb9954a0$export$2e2bcd8739ae039);

var $k65dW = parcelRequire("k65dW");
function $714aa6a5cb9954a0$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $k65dW.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("kXPOQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f431837fa9e8ca57$export$2e2bcd8739ae039);

var $2CQVf = parcelRequire("2CQVf");

var $5ewz1 = parcelRequire("5ewz1");

var $fWmj3 = parcelRequire("fWmj3");

var $9Uhst = parcelRequire("9Uhst");
function $f431837fa9e8ca57$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2CQVf.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fWmj3.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9Uhst.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($f431837fa9e8ca57$export$2e2bcd8739ae039((0, $5ewz1.default)(target)));
}

});
parcelRegister("2CQVf", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e982ea2e37d1ae0$export$2e2bcd8739ae039);

var $5ewz1 = parcelRequire("5ewz1");

var $9Uhst = parcelRequire("9Uhst");

var $4baem = parcelRequire("4baem");

var $gg6Qu = parcelRequire("gg6Qu");
function $1e982ea2e37d1ae0$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $4baem.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $gg6Qu.isHTMLElement)(node) && (0, $9Uhst.default)(node)) return node;
    return $1e982ea2e37d1ae0$export$2e2bcd8739ae039((0, $5ewz1.default)(node));
}

});
parcelRegister("5ewz1", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cf7850ed94ba01d$export$2e2bcd8739ae039);

var $4baem = parcelRequire("4baem");

var $7gyBU = parcelRequire("7gyBU");

var $gg6Qu = parcelRequire("gg6Qu");
function $3cf7850ed94ba01d$export$2e2bcd8739ae039(element) {
    if ((0, $4baem.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $gg6Qu.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7gyBU.default)(element) // fallback
    );
}

});



parcelRegister("5hADZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d8af70a4a661074$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");

var $4baem = parcelRequire("4baem");

var $gJ1QC = parcelRequire("gJ1QC");

var $gg6Qu = parcelRequire("gg6Qu");

var $fJU2S = parcelRequire("fJU2S");

var $5ewz1 = parcelRequire("5ewz1");

var $jfbGV = parcelRequire("jfbGV");
function $3d8af70a4a661074$var$getTrueOffsetParent(element) {
    if (!(0, $gg6Qu.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $gJ1QC.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3d8af70a4a661074$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $jfbGV.default)());
    var isIE = /Trident/i.test((0, $jfbGV.default)());
    if (isIE && (0, $gg6Qu.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $gJ1QC.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $5ewz1.default)(element);
    if ((0, $gg6Qu.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $gg6Qu.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $4baem.default)(currentNode)) < 0){
        var css = (0, $gJ1QC.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3d8af70a4a661074$export$2e2bcd8739ae039(element) {
    var window = (0, $fWmj3.default)(element);
    var offsetParent = $3d8af70a4a661074$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fJU2S.default)(offsetParent) && (0, $gJ1QC.default)(offsetParent).position === 'static')offsetParent = $3d8af70a4a661074$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4baem.default)(offsetParent) === 'html' || (0, $4baem.default)(offsetParent) === 'body' && (0, $gJ1QC.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $3d8af70a4a661074$var$getContainingBlock(element) || window;
}

});
parcelRegister("fJU2S", function(module, exports) {
$parcel$export(module.exports, "default", () => $b756886c0c925609$export$2e2bcd8739ae039);

var $4baem = parcelRequire("4baem");
function $b756886c0c925609$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $4baem.default)(element)) >= 0;
}

});


parcelRegister("467x6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fbd90d3076093ac$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");
function $2fbd90d3076093ac$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $2fbd90d3076093ac$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $2fbd90d3076093ac$var$order(modifiers); // order based on phase
    return (0, $1LHyG.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1LHyG", function(module, exports) {
$parcel$export(module.exports, "top", () => $149bf80282ae6f0a$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $149bf80282ae6f0a$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $149bf80282ae6f0a$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $149bf80282ae6f0a$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $149bf80282ae6f0a$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $149bf80282ae6f0a$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $149bf80282ae6f0a$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $149bf80282ae6f0a$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $149bf80282ae6f0a$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $149bf80282ae6f0a$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $149bf80282ae6f0a$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $149bf80282ae6f0a$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $149bf80282ae6f0a$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $149bf80282ae6f0a$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $149bf80282ae6f0a$export$d087d3878fdf71d5);
var $149bf80282ae6f0a$export$1e95b668f3b82d = 'top';
var $149bf80282ae6f0a$export$40e543e69a8b3fbb = 'bottom';
var $149bf80282ae6f0a$export$79ffe56a765070d2 = 'right';
var $149bf80282ae6f0a$export$eabcd2c8791e7bf4 = 'left';
var $149bf80282ae6f0a$export$dfb5619354ba860 = 'auto';
var $149bf80282ae6f0a$export$aec2ce47c367b8c3 = [
    $149bf80282ae6f0a$export$1e95b668f3b82d,
    $149bf80282ae6f0a$export$40e543e69a8b3fbb,
    $149bf80282ae6f0a$export$79ffe56a765070d2,
    $149bf80282ae6f0a$export$eabcd2c8791e7bf4
];
var $149bf80282ae6f0a$export$b3571188c770cc5a = 'start';
var $149bf80282ae6f0a$export$bd5df0f255a350f8 = 'end';
var $149bf80282ae6f0a$export$390fd549c5303b4d = 'clippingParents';
var $149bf80282ae6f0a$export$d7b7311ec04a3e8f = 'viewport';
var $149bf80282ae6f0a$export$ae5ab1c730825774 = 'popper';
var $149bf80282ae6f0a$export$ca50aac9f3ba507f = 'reference';
var $149bf80282ae6f0a$export$368f9a87e87fa4e1 = /*#__PURE__*/ $149bf80282ae6f0a$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $149bf80282ae6f0a$export$b3571188c770cc5a,
        placement + "-" + $149bf80282ae6f0a$export$bd5df0f255a350f8
    ]);
}, []);
var $149bf80282ae6f0a$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($149bf80282ae6f0a$export$aec2ce47c367b8c3, [
    $149bf80282ae6f0a$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $149bf80282ae6f0a$export$b3571188c770cc5a,
        placement + "-" + $149bf80282ae6f0a$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $149bf80282ae6f0a$export$421679a7c3d56e = 'beforeRead';
var $149bf80282ae6f0a$export$aafa59e2e03f2942 = 'read';
var $149bf80282ae6f0a$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $149bf80282ae6f0a$export$c65e99957a05207c = 'beforeMain';
var $149bf80282ae6f0a$export$f22da7240b7add18 = 'main';
var $149bf80282ae6f0a$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $149bf80282ae6f0a$export$8d4d2d70e7d46032 = 'beforeWrite';
var $149bf80282ae6f0a$export$68d8715fc104d294 = 'write';
var $149bf80282ae6f0a$export$70a6e5159acce2e6 = 'afterWrite';
var $149bf80282ae6f0a$export$d087d3878fdf71d5 = [
    $149bf80282ae6f0a$export$421679a7c3d56e,
    $149bf80282ae6f0a$export$aafa59e2e03f2942,
    $149bf80282ae6f0a$export$6964f6c886723980,
    $149bf80282ae6f0a$export$c65e99957a05207c,
    $149bf80282ae6f0a$export$f22da7240b7add18,
    $149bf80282ae6f0a$export$bab79516f2d662fe,
    $149bf80282ae6f0a$export$8d4d2d70e7d46032,
    $149bf80282ae6f0a$export$68d8715fc104d294,
    $149bf80282ae6f0a$export$70a6e5159acce2e6
];

});


parcelRegister("bQzW7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a006d460a409cf5$export$2e2bcd8739ae039);
function $8a006d460a409cf5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("287ko", function(module, exports) {
$parcel$export(module.exports, "default", () => $18d203526ff3d300$export$2e2bcd8739ae039);
function $18d203526ff3d300$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("bMX9T", function(module, exports) {
$parcel$export(module.exports, "default", () => $89521114592bb4c0$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");
var $89521114592bb4c0$var$passive = {
    passive: true
};
function $89521114592bb4c0$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fWmj3.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $89521114592bb4c0$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $89521114592bb4c0$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $89521114592bb4c0$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $89521114592bb4c0$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $89521114592bb4c0$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $89521114592bb4c0$var$effect,
    data: {}
};

});

parcelRegister("3lXAT", function(module, exports) {
$parcel$export(module.exports, "default", () => $27118f602f9fb7ed$export$2e2bcd8739ae039);

var $fl9ah = parcelRequire("fl9ah");
function $27118f602f9fb7ed$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $fl9ah.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $27118f602f9fb7ed$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $27118f602f9fb7ed$var$popperOffsets,
    data: {}
};

});
parcelRegister("fl9ah", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2afed1d882b4807$export$2e2bcd8739ae039);

var $ix6Fe = parcelRequire("ix6Fe");

var $3nitp = parcelRequire("3nitp");

var $aRMwh = parcelRequire("aRMwh");

var $1LHyG = parcelRequire("1LHyG");
function $b2afed1d882b4807$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $ix6Fe.default)(placement) : null;
    var variation = placement ? (0, $3nitp.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1LHyG.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1LHyG.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1LHyG.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1LHyG.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $aRMwh.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1LHyG.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1LHyG.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("ix6Fe", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7e07a637cd667c6$export$2e2bcd8739ae039);

function $d7e07a637cd667c6$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("3nitp", function(module, exports) {
$parcel$export(module.exports, "default", () => $2751d9819e47949e$export$2e2bcd8739ae039);
function $2751d9819e47949e$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("aRMwh", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e947d96e10112da$export$2e2bcd8739ae039);
function $7e947d96e10112da$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("9rdGq", function(module, exports) {
$parcel$export(module.exports, "default", () => $6df13fe20ccb3860$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $5hADZ = parcelRequire("5hADZ");

var $fWmj3 = parcelRequire("fWmj3");

var $7gyBU = parcelRequire("7gyBU");

var $gJ1QC = parcelRequire("gJ1QC");

var $ix6Fe = parcelRequire("ix6Fe");

var $3nitp = parcelRequire("3nitp");

var $8amqe = parcelRequire("8amqe");
var $6df13fe20ccb3860$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $6df13fe20ccb3860$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8amqe.round)(x * dpr) / dpr || 0,
        y: (0, $8amqe.round)(y * dpr) / dpr || 0
    };
}
function $6df13fe20ccb3860$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1LHyG.left);
    var sideY = (0, $1LHyG.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5hADZ.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $fWmj3.default)(popper)) {
            offsetParent = (0, $7gyBU.default)(popper);
            if ((0, $gJ1QC.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1LHyG.top) || (placement === (0, $1LHyG.left) || placement === (0, $1LHyG.right)) && variation === (0, $1LHyG.end)) {
            sideY = (0, $1LHyG.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1LHyG.left) || (placement === (0, $1LHyG.top) || placement === (0, $1LHyG.bottom)) && variation === (0, $1LHyG.end)) {
            sideX = (0, $1LHyG.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $6df13fe20ccb3860$var$unsetSides);
    var _ref4 = roundOffsets === true ? $6df13fe20ccb3860$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $fWmj3.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $6df13fe20ccb3860$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $ix6Fe.default)(state.placement),
        variation: (0, $3nitp.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $6df13fe20ccb3860$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $6df13fe20ccb3860$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6df13fe20ccb3860$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $6df13fe20ccb3860$var$computeStyles,
    data: {}
};

});

parcelRegister("9HkoV", function(module, exports) {
$parcel$export(module.exports, "default", () => $70f7f4679a787bbc$export$2e2bcd8739ae039);

var $4baem = parcelRequire("4baem");

var $gg6Qu = parcelRequire("gg6Qu");
// and applies them to the HTMLElements such as popper and arrow
function $70f7f4679a787bbc$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $gg6Qu.isHTMLElement)(element) || !(0, $4baem.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $70f7f4679a787bbc$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $gg6Qu.isHTMLElement)(element) || !(0, $4baem.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $70f7f4679a787bbc$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $70f7f4679a787bbc$var$applyStyles,
    effect: $70f7f4679a787bbc$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("f7Vnd", function(module, exports) {
$parcel$export(module.exports, "default", () => $b034039cedbbe126$export$2e2bcd8739ae039);

var $ix6Fe = parcelRequire("ix6Fe");

var $1LHyG = parcelRequire("1LHyG");
function $b034039cedbbe126$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $ix6Fe.default)(placement);
    var invertDistance = [
        (0, $1LHyG.left),
        (0, $1LHyG.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1LHyG.left),
        (0, $1LHyG.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $b034039cedbbe126$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1LHyG.placements).reduce(function(acc, placement) {
        acc[placement] = $b034039cedbbe126$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b034039cedbbe126$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $b034039cedbbe126$var$offset
};

});

parcelRegister("6DBHs", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d53a105c719d71f$export$2e2bcd8739ae039);

var $jEhSs = parcelRequire("jEhSs");

var $ix6Fe = parcelRequire("ix6Fe");

var $3nM6l = parcelRequire("3nM6l");

var $2L52j = parcelRequire("2L52j");

var $zvQQI = parcelRequire("zvQQI");

var $1LHyG = parcelRequire("1LHyG");

var $3nitp = parcelRequire("3nitp");
function $4d53a105c719d71f$var$getExpandedFallbackPlacements(placement) {
    if ((0, $ix6Fe.default)(placement) === (0, $1LHyG.auto)) return [];
    var oppositePlacement = (0, $jEhSs.default)(placement);
    return [
        (0, $3nM6l.default)(placement),
        oppositePlacement,
        (0, $3nM6l.default)(oppositePlacement)
    ];
}
function $4d53a105c719d71f$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $ix6Fe.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $jEhSs.default)(preferredPlacement)
    ] : $4d53a105c719d71f$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $ix6Fe.default)(placement) === (0, $1LHyG.auto) ? (0, $zvQQI.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $ix6Fe.default)(placement);
        var isStartVariation = (0, $3nitp.default)(placement) === (0, $1LHyG.start);
        var isVertical = [
            (0, $1LHyG.top),
            (0, $1LHyG.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $2L52j.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1LHyG.right) : (0, $1LHyG.left) : isStartVariation ? (0, $1LHyG.bottom) : (0, $1LHyG.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $jEhSs.default)(mainVariationSide);
        var altVariationSide = (0, $jEhSs.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4d53a105c719d71f$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $4d53a105c719d71f$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("jEhSs", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4df9ecf09fd7b98$export$2e2bcd8739ae039);
var $e4df9ecf09fd7b98$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e4df9ecf09fd7b98$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e4df9ecf09fd7b98$var$hash[matched];
    });
}

});

parcelRegister("3nM6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $2768d4fade00acc0$export$2e2bcd8739ae039);
var $2768d4fade00acc0$var$hash = {
    start: 'end',
    end: 'start'
};
function $2768d4fade00acc0$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2768d4fade00acc0$var$hash[matched];
    });
}

});

parcelRegister("2L52j", function(module, exports) {
$parcel$export(module.exports, "default", () => $2023e0a84dae9603$export$2e2bcd8739ae039);

var $9x9tN = parcelRequire("9x9tN");

var $7gyBU = parcelRequire("7gyBU");

var $k65dW = parcelRequire("k65dW");

var $fl9ah = parcelRequire("fl9ah");

var $in7or = parcelRequire("in7or");

var $1LHyG = parcelRequire("1LHyG");

var $gg6Qu = parcelRequire("gg6Qu");

var $LmsI1 = parcelRequire("LmsI1");

var $dOabu = parcelRequire("dOabu");
function $2023e0a84dae9603$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1LHyG.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1LHyG.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1LHyG.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $LmsI1.default)(typeof padding !== 'number' ? padding : (0, $dOabu.default)(padding, (0, $1LHyG.basePlacements)));
    var altContext = elementContext === (0, $1LHyG.popper) ? (0, $1LHyG.reference) : (0, $1LHyG.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $9x9tN.default)((0, $gg6Qu.isElement)(element) ? element : element.contextElement || (0, $7gyBU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $k65dW.default)(state.elements.reference);
    var popperOffsets = (0, $fl9ah.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $in7or.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1LHyG.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1LHyG.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1LHyG.right),
                (0, $1LHyG.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1LHyG.top),
                (0, $1LHyG.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("9x9tN", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f0e8c9530387084$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $3xt5L = parcelRequire("3xt5L");

var $9oWt3 = parcelRequire("9oWt3");

var $kXPOQ = parcelRequire("kXPOQ");

var $5hADZ = parcelRequire("5hADZ");

var $7gyBU = parcelRequire("7gyBU");

var $gJ1QC = parcelRequire("gJ1QC");

var $gg6Qu = parcelRequire("gg6Qu");

var $k65dW = parcelRequire("k65dW");

var $5ewz1 = parcelRequire("5ewz1");

var $96vJk = parcelRequire("96vJk");

var $4baem = parcelRequire("4baem");

var $in7or = parcelRequire("in7or");

var $8amqe = parcelRequire("8amqe");
function $6f0e8c9530387084$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $k65dW.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $6f0e8c9530387084$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1LHyG.viewport) ? (0, $in7or.default)((0, $3xt5L.default)(element, strategy)) : (0, $gg6Qu.isElement)(clippingParent) ? $6f0e8c9530387084$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $in7or.default)((0, $9oWt3.default)((0, $7gyBU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $6f0e8c9530387084$var$getClippingParents(element) {
    var clippingParents = (0, $kXPOQ.default)((0, $5ewz1.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $gJ1QC.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $gg6Qu.isHTMLElement)(element) ? (0, $5hADZ.default)(element) : element;
    if (!(0, $gg6Qu.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $gg6Qu.isElement)(clippingParent) && (0, $96vJk.default)(clippingParent, clipperElement) && (0, $4baem.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $6f0e8c9530387084$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $6f0e8c9530387084$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $6f0e8c9530387084$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8amqe.max)(rect.top, accRect.top);
        accRect.right = (0, $8amqe.min)(rect.right, accRect.right);
        accRect.bottom = (0, $8amqe.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8amqe.max)(rect.left, accRect.left);
        return accRect;
    }, $6f0e8c9530387084$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("3xt5L", function(module, exports) {
$parcel$export(module.exports, "default", () => $293b0537fae813b9$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");

var $7gyBU = parcelRequire("7gyBU");

var $2uwXd = parcelRequire("2uwXd");

var $2aPrh = parcelRequire("2aPrh");
function $293b0537fae813b9$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fWmj3.default)(element);
    var html = (0, $7gyBU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2aPrh.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2uwXd.default)(element),
        y: y
    };
}

});

parcelRegister("9oWt3", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d83b5603b3586ee$export$2e2bcd8739ae039);

var $7gyBU = parcelRequire("7gyBU");

var $gJ1QC = parcelRequire("gJ1QC");

var $2uwXd = parcelRequire("2uwXd");

var $cOno9 = parcelRequire("cOno9");

var $8amqe = parcelRequire("8amqe");
function $6d83b5603b3586ee$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7gyBU.default)(element);
    var winScroll = (0, $cOno9.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8amqe.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8amqe.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2uwXd.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $gJ1QC.default)(body || html).direction === 'rtl') x += (0, $8amqe.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("96vJk", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a0d498ab041b2ae$export$2e2bcd8739ae039);

var $gg6Qu = parcelRequire("gg6Qu");
function $6a0d498ab041b2ae$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $gg6Qu.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("in7or", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6001c20f097600c$export$2e2bcd8739ae039);
function $d6001c20f097600c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("LmsI1", function(module, exports) {
$parcel$export(module.exports, "default", () => $08e5d065659557f4$export$2e2bcd8739ae039);

var $hiKju = parcelRequire("hiKju");
function $08e5d065659557f4$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $hiKju.default)(), paddingObject);
}

});
parcelRegister("hiKju", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9880af3f66b6790$export$2e2bcd8739ae039);
function $c9880af3f66b6790$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("dOabu", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0d7d8467385dc15$export$2e2bcd8739ae039);
function $a0d7d8467385dc15$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("zvQQI", function(module, exports) {
$parcel$export(module.exports, "default", () => $06abfa066cc434b3$export$2e2bcd8739ae039);

var $3nitp = parcelRequire("3nitp");

var $1LHyG = parcelRequire("1LHyG");

var $2L52j = parcelRequire("2L52j");

var $ix6Fe = parcelRequire("ix6Fe");
function $06abfa066cc434b3$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1LHyG.placements) : _options$allowedAutoP;
    var variation = (0, $3nitp.default)(placement);
    var placements = variation ? flipVariations ? (0, $1LHyG.variationPlacements) : (0, $1LHyG.variationPlacements).filter(function(placement) {
        return (0, $3nitp.default)(placement) === variation;
    }) : (0, $1LHyG.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $2L52j.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $ix6Fe.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("31C6T", function(module, exports) {
$parcel$export(module.exports, "default", () => $233f06fcebd46aab$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $ix6Fe = parcelRequire("ix6Fe");

var $aRMwh = parcelRequire("aRMwh");

var $52Fp0 = parcelRequire("52Fp0");

var $hPHoq = parcelRequire("hPHoq");

var $9J30E = parcelRequire("9J30E");

var $5hADZ = parcelRequire("5hADZ");

var $2L52j = parcelRequire("2L52j");

var $3nitp = parcelRequire("3nitp");

var $hiKju = parcelRequire("hiKju");

var $8amqe = parcelRequire("8amqe");
function $233f06fcebd46aab$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $2L52j.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $ix6Fe.default)(state.placement);
    var variation = (0, $3nitp.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $aRMwh.default)(basePlacement);
    var altAxis = (0, $52Fp0.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1LHyG.top) : (0, $1LHyG.left);
        var altSide = mainAxis === 'y' ? (0, $1LHyG.bottom) : (0, $1LHyG.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1LHyG.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1LHyG.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9J30E.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $hiKju.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $hPHoq.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5hADZ.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $hPHoq.within)(tether ? (0, $8amqe.min)(min, tetherMin) : min, offset, tether ? (0, $8amqe.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1LHyG.top) : (0, $1LHyG.left);
        var _altSide = mainAxis === 'x' ? (0, $1LHyG.bottom) : (0, $1LHyG.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1LHyG.top),
            (0, $1LHyG.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $hPHoq.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $hPHoq.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $233f06fcebd46aab$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $233f06fcebd46aab$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("52Fp0", function(module, exports) {
$parcel$export(module.exports, "default", () => $3abd4144d8cebe00$export$2e2bcd8739ae039);
function $3abd4144d8cebe00$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("hPHoq", function(module, exports) {
$parcel$export(module.exports, "within", () => $cfb8dc0327546b5f$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $cfb8dc0327546b5f$export$86c8af6d3ef0b4a);

var $8amqe = parcelRequire("8amqe");
function $cfb8dc0327546b5f$export$f28d906d67a997f3(min, value, max) {
    return (0, $8amqe.max)(min, (0, $8amqe.min)(value, max));
}
function $cfb8dc0327546b5f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $cfb8dc0327546b5f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("a6oPx", function(module, exports) {
$parcel$export(module.exports, "default", () => $75adb9ab5729b460$export$2e2bcd8739ae039);

var $ix6Fe = parcelRequire("ix6Fe");

var $9J30E = parcelRequire("9J30E");

var $96vJk = parcelRequire("96vJk");

var $5hADZ = parcelRequire("5hADZ");

var $aRMwh = parcelRequire("aRMwh");

var $hPHoq = parcelRequire("hPHoq");

var $LmsI1 = parcelRequire("LmsI1");

var $dOabu = parcelRequire("dOabu");

var $1LHyG = parcelRequire("1LHyG");
var $75adb9ab5729b460$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $LmsI1.default)(typeof padding !== 'number' ? padding : (0, $dOabu.default)(padding, (0, $1LHyG.basePlacements)));
};
function $75adb9ab5729b460$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $ix6Fe.default)(state.placement);
    var axis = (0, $aRMwh.default)(basePlacement);
    var isVertical = [
        (0, $1LHyG.left),
        (0, $1LHyG.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $75adb9ab5729b460$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9J30E.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1LHyG.top) : (0, $1LHyG.left);
    var maxProp = axis === 'y' ? (0, $1LHyG.bottom) : (0, $1LHyG.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5hADZ.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $hPHoq.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $75adb9ab5729b460$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $96vJk.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $75adb9ab5729b460$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $75adb9ab5729b460$var$arrow,
    effect: $75adb9ab5729b460$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("c2Bzy", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c42d10fef006a34$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $2L52j = parcelRequire("2L52j");
function $8c42d10fef006a34$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $8c42d10fef006a34$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1LHyG.top),
        (0, $1LHyG.right),
        (0, $1LHyG.bottom),
        (0, $1LHyG.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $8c42d10fef006a34$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $2L52j.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $2L52j.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $8c42d10fef006a34$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $8c42d10fef006a34$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $8c42d10fef006a34$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $8c42d10fef006a34$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $8c42d10fef006a34$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $8c42d10fef006a34$var$hide
};

});




parcelRegister("lEbH4", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $fc26678a4f3d738c$export$e0be378c32fb70a7);

var $eJOHy = parcelRequire("eJOHy");

var $9Hk5t = parcelRequire("9Hk5t");

var $7QJq6 = parcelRequire("7QJq6");

var $65sWw = parcelRequire("65sWw");
function $fc26678a4f3d738c$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eJOHy.useContext((0, $7QJq6.ManagerReferenceNodeSetterContext));
    var refHandler = $eJOHy.useCallback(function(node) {
        (0, $65sWw.setRef)(innerRef, node);
        (0, $65sWw.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eJOHy.useEffect(function() {
        return function() {
            return (0, $65sWw.setRef)(innerRef, null);
        };
    }, []);
    $eJOHy.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9Hk5t)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $65sWw.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("5yteI", function(module, exports) {
$parcel$export(module.exports, "shallowEqualObjects", () => $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c);
function $40b6ce70abc0b2ca$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $40b6ce70abc0b2ca$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $40b6ce70abc0b2ca$export$967a6b9924a689f7(a, b);
    return $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("5nAXq", function(module, exports) {
$parcel$export(module.exports, "MenuDialog", () => $962253e5722485a0$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $962253e5722485a0$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $962253e5722485a0$export$71abc632aa29e6fe);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dqx2X = parcelRequire("dqx2X");

var $6XEne = parcelRequire("6XEne");

var $6fs4r = parcelRequire("6fs4r");
const $962253e5722485a0$var$menuDialogStyles = null;
const $962253e5722485a0$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $hcewu.default)([
            "_2rko12b0 _1pby16oo _bfhk1bhr _16qseva7"
        ]),
        children: children
    });
});
// ==============================
// Custom Components
// ==============================
const $962253e5722485a0$var$dropdownStyles = null;
const $962253e5722485a0$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqx2X))), {
            color: "currentColor",
            label: ""
        })
    });
const $962253e5722485a0$var$controlStyles = null;
const $962253e5722485a0$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: innerRef,
        className: (0, $hcewu.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Control, {
            ...props,
            innerProps: innerProps
        })
    });
const $962253e5722485a0$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Control, {
            ...props
        })
    });
// NOTE `props` intentionally omitted from `Fragment`
const $962253e5722485a0$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        children: children
    });
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
const $962253e5722485a0$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).ClearIndicator, {
        ...props
    });
const $962253e5722485a0$var$MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).MultiValueRemove, {
        ...props
    });
const $962253e5722485a0$export$71abc632aa29e6fe = {
    Control: $962253e5722485a0$var$Control,
    DropdownIndicator: $962253e5722485a0$var$DropdownIndicator,
    Menu: $962253e5722485a0$var$Menu,
    ClearIndicator: $962253e5722485a0$var$ClearIndicator,
    MultiValueRemove: $962253e5722485a0$var$MultiValueRemove
};

});
parcelRegister("dqx2X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2d61a8b9264c17f51d6b1ce92a21fc9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c675677f12a1926$var$_react = $9c675677f12a1926$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9c675677f12a1926$var$_search = $9c675677f12a1926$var$_interopRequireDefault((parcelRequire("dt3aG")));

var $9c675677f12a1926$var$_search2 = $9c675677f12a1926$var$_interopRequireDefault((parcelRequire("dPkHp")));
function $9c675677f12a1926$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c675677f12a1926$var$SearchIcon = (props)=>/*#__PURE__*/ $9c675677f12a1926$var$_react.default.createElement($9c675677f12a1926$var$_search.default, Object.assign({
        name: "SearchIcon",
        LEGACY_fallbackIcon: $9c675677f12a1926$var$_search2.default
    }, props));
$9c675677f12a1926$var$SearchIcon.displayName = 'SearchIconMigration';
var $9c675677f12a1926$var$_default = module.exports.default = $9c675677f12a1926$var$SearchIcon;

});
parcelRegister("dPkHp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a110182f06b4ad6b$var$_react = $a110182f06b4ad6b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $a110182f06b4ad6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a110182f06b4ad6b$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $a110182f06b4ad6b$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props));
$a110182f06b4ad6b$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $a110182f06b4ad6b$var$_default = module.exports.default = $a110182f06b4ad6b$var$EditorSearchIcon;

});



parcelRegister("ctyCN", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $5efc0b15e3dedaed$export$17baa7c95b6ba1b8);

var $5NYi5 = parcelRequire("5NYi5");
function $5efc0b15e3dedaed$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore error TS2353: Object literal may only specify known properties, and &#39;onClose&#39; does not exist in type &#39;{ isOpen?: boolean | undefined; }&#39;.
    (0, $5NYi5.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});




parcelRegister("adZfk", function(module, exports) {
$parcel$export(module.exports, "isValidFailedExperience", () => $103d0832a6180074$export$883079293b9cad76);
const $103d0832a6180074$var$ignoredErrorStatusCode = [
    401,
    403,
    429
];
const $103d0832a6180074$export$883079293b9cad76 = (experience, // the type for error is 'any' because consumers of the share config can pass in custom error objects
error)=>{
    const errorStatusCode = error.code || error.status || error.statusCode;
    if ($103d0832a6180074$var$ignoredErrorStatusCode.includes(parseInt(errorStatusCode))) {
        experience.abort({
            metadata: {
                error: error
            }
        });
        return;
    }
    experience.failure({
        metadata: {
            error: error
        }
    });
};

});

parcelRegister("fECDH", function(module, exports) {
$parcel$export(module.exports, "renderShareDialogExp", () => $fdf032407173dc3e$export$99c0383421ae57eb);
$parcel$export(module.exports, "shareSubmitExp", () => $fdf032407173dc3e$export$31627ee726f40567);

var $aRnO1 = parcelRequire("aRnO1");
var $2pMzV = parcelRequire("2pMzV");
const $fdf032407173dc3e$export$99c0383421ae57eb = new (0, $2pMzV.UFOExperience)('render-share-dialog', {
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $fdf032407173dc3e$export$31627ee726f40567 = new (0, $2pMzV.UFOExperience)('share-submit-action', {
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});

});
parcelRegister("aRnO1", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $a0f874ab7df0b90c$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $a0f874ab7df0b90c$export$cc26007c03242fff);
var $a0f874ab7df0b90c$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $a0f874ab7df0b90c$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("2pMzV", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $eb40b99b73192801$export$c00d22927c60484a);

var $aSYAD = parcelRequire("aSYAD");
class $eb40b99b73192801$export$c00d22927c60484a extends (0, $aSYAD.UFOAbstractExperience) {
}

});
parcelRegister("aSYAD", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $fb5df3e7e01c2259$export$d31c89db257648c);

var $aXKmr = parcelRequire("aXKmr");


var $6uX6b = parcelRequire("6uX6b");

var $jJiQE = parcelRequire("jJiQE");

var $5hbWe = parcelRequire("5hbWe");

var $ccWvh = parcelRequire("ccWvh");

var $aP4V0 = parcelRequire("aP4V0");

var $2Ilzg = parcelRequire("2Ilzg");

var $g0oDq = parcelRequire("g0oDq");

var $8OSL8 = parcelRequire("8OSL8");

var $aRnO1 = parcelRequire("aRnO1");
const $fb5df3e7e01c2259$var$getPageVisibleState = ()=>{
    return !(0, $2Ilzg.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $ccWvh.PageVisibleState).VISIBLE : (0, $ccWvh.PageVisibleState).HIDDEN;
};
const $fb5df3e7e01c2259$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $aP4V0.roundPerfNow)();
};
class $fb5df3e7e01c2259$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $g0oDq.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $ccWvh.PageVisibleState).MIXED;
            (0, $5hbWe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $fb5df3e7e01c2259$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $aRnO1.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $jJiQE.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $8OSL8.canTransition)(this.state, newState)) {
            (0, $jJiQE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $g0oDq.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $aXKmr.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.unsubscribeEvent)((0, $ccWvh.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $jJiQE.ufolog)('this.parent', this.parent);
                (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $jJiQE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $jJiQE.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $g0oDq.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $fb5df3e7e01c2259$var$getPageVisibleState();
            (0, $5hbWe.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $jJiQE.ufolog)('subscribed', this.id);
                (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.subscribeEvent)((0, $ccWvh.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $ccWvh.FMP_MARK) && name !== (0, $ccWvh.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $jJiQE.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $g0oDq.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $ccWvh.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $ccWvh.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $jJiQE.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $5hbWe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $jJiQE.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $4e1f4772088a5f3c$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $4e1f4772088a5f3c$export$2295b861f318254a = '0.1.5';

parcelRegister("6uX6b", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $aa71c8960fce0a9f$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $aa71c8960fce0a9f$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $aa71c8960fce0a9f$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $aa71c8960fce0a9f$export$7c957416596ca127);

var $jJiQE = parcelRequire("jJiQE");

var $ccWvh = parcelRequire("ccWvh");
const $aa71c8960fce0a9f$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $aa71c8960fce0a9f$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $aa71c8960fce0a9f$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $aa71c8960fce0a9f$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $jJiQE.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $aa71c8960fce0a9f$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $aa71c8960fce0a9f$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $aa71c8960fce0a9f$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("jJiQE", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $3c943c12e74b5b78$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $3c943c12e74b5b78$export$d53d07b6034c4560);
class $3c943c12e74b5b78$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($3c943c12e74b5b78$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($3c943c12e74b5b78$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $3c943c12e74b5b78$export$4ab84f6f04f6566d = new $3c943c12e74b5b78$var$UFOLogger();
const $3c943c12e74b5b78$export$b4958caff08a0960 = (...args)=>{
    $3c943c12e74b5b78$export$4ab84f6f04f6566d.log(...args);
};
const $3c943c12e74b5b78$export$d53d07b6034c4560 = (...args)=>{
    $3c943c12e74b5b78$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("ccWvh", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $eeff76e3a75af2a8$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $eeff76e3a75af2a8$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $eeff76e3a75af2a8$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $eeff76e3a75af2a8$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $eeff76e3a75af2a8$export$837e0f79a8056912);
var $eeff76e3a75af2a8$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $eeff76e3a75af2a8$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $eeff76e3a75af2a8$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $eeff76e3a75af2a8$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $eeff76e3a75af2a8$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $eeff76e3a75af2a8$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $eeff76e3a75af2a8$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $eeff76e3a75af2a8$export$9f2bf58999404c75 = 'fmp';
const $eeff76e3a75af2a8$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("5hbWe", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $d460cc96d513760c$export$13e680397ec8f3eb);

var $2Ilzg = parcelRequire("2Ilzg");
class $d460cc96d513760c$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $2Ilzg.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $d460cc96d513760c$export$13e680397ec8f3eb = new $d460cc96d513760c$var$VisibilityChangeObserver();

});
parcelRegister("2Ilzg", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $5b8b2c70c6400f35$export$15e172712955e18f);
const $5b8b2c70c6400f35$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("aP4V0", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $53acaf7fbb090f6e$export$5f490af6b2b115cf);
const $53acaf7fbb090f6e$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("g0oDq", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $7c8f0df3a7880bc0$export$81b70111112841a0);
const $7c8f0df3a7880bc0$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("8OSL8", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $ac48b2b50e1c5998$export$178881f329fdb81f);

var $g0oDq = parcelRequire("g0oDq");
const $ac48b2b50e1c5998$var$UFOStateAvailableTransitions = {
    [(0, $g0oDq.UFOExperienceState).NOT_STARTED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).STARTED.id]: [
        (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id,
        (0, $g0oDq.UFOExperienceState).BLOCKED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $g0oDq.UFOExperienceState).BLOCKED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).BLOCKED.id]: [
        (0, $g0oDq.UFOExperienceState).RECOVERED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).RECOVERED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).SUCCEEDED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).FAILED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).ABORTED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ]
};
const $ac48b2b50e1c5998$export$178881f329fdb81f = (state1, state2)=>{
    return $ac48b2b50e1c5998$var$UFOStateAvailableTransitions[state1.id] && $ac48b2b50e1c5998$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});




parcelRegister("7ylDQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $44c06d5eef945c31$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");

var $63G4N = parcelRequire("63G4N");
// ErrorBoundary does not support in functional component
// eslint-disable-next-line @repo/internal/react/no-class-components
class $44c06d5eef945c31$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch(error) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) createAnalyticsEvent((0, $63G4N.errorEncountered)(undefined, {
            message: error.message,
            errorClass: error.name
        })).fire((0, $63G4N.CHANNEL_ID));
        this.setState({
            hasError: true
        });
    }
    render() {
        const { hasError: hasError } = this.state;
        if (hasError) // Silently fail.
        return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
var $44c06d5eef945c31$export$2e2bcd8739ae039 = (0, $4J0ad.default)()($44c06d5eef945c31$var$ErrorBoundary);

});

parcelRegister("52eNw", function(module, exports) {
$parcel$export(module.exports, "default", () => $09e39d4b35072b03$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");

var $lu4wm = parcelRequire("lu4wm");
const $09e39d4b35072b03$var$MessagesIntlProvider = ({ intl: intl, children: children })=>{
    const mergedMessages = (0, $eJOHy.useMemo)(()=>{
        return {
            ...intl.messages,
            ...(0, $lu4wm.getMessagesForLocale)(intl.locale)
        };
    }, [
        intl.messages,
        intl.locale
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: intl.locale,
        messages: mergedMessages,
        defaultLocale: "en-US",
        children: children
    });
};
var $09e39d4b35072b03$export$2e2bcd8739ae039 = (0, $6YFG2.default)($09e39d4b35072b03$var$MessagesIntlProvider);

});
parcelRegister("lu4wm", function(module, exports) {
$parcel$export(module.exports, "getMessagesForLocale", () => $ff1ebded08083359$export$d0a3169680473b6c);
// Cannot import from `../i18n` because there is `../i18n.tsx` file there.
/* eslint-disable @atlassian/tangerine/import/no-dangling-index */ 
var $bkRUt = parcelRequire("bkRUt");
var $9SX9L = parcelRequire("9SX9L");
var $9lERR = parcelRequire("9lERR");
var $77fHE = parcelRequire("77fHE");
var $6StPO = parcelRequire("6StPO");
var $aAbet = parcelRequire("aAbet");
var $a7DPA = parcelRequire("a7DPA");
var $1gaRJ = parcelRequire("1gaRJ");
var $4tj41 = parcelRequire("4tj41");
var $f4QSQ = parcelRequire("f4QSQ");
var $3YJTA = parcelRequire("3YJTA");
var $bLBTm = parcelRequire("bLBTm");
var $eyWna = parcelRequire("eyWna");
var $9kc19 = parcelRequire("9kc19");
var $7ZsZJ = parcelRequire("7ZsZJ");
var $4Ed6p = parcelRequire("4Ed6p");
var $8VZ83 = parcelRequire("8VZ83");
var $8CyCd = parcelRequire("8CyCd");
var $l56YV = parcelRequire("l56YV");
var $bPDN4 = parcelRequire("bPDN4");
var $hTLsU = parcelRequire("hTLsU");
var $drDe0 = parcelRequire("drDe0");
var $5aykq = parcelRequire("5aykq");
var $356A0 = parcelRequire("356A0");
var $h9cNZ = parcelRequire("h9cNZ");
const $ff1ebded08083359$var$localesMessagesMap = {
    cs: $bkRUt.default,
    da: $9SX9L.default,
    de: $9lERR.default,
    en: $77fHE.default,
    en_GB: $6StPO.default,
    en_ZZ: $aAbet.default,
    es: $a7DPA.default,
    et: $1gaRJ.default,
    fi: $4tj41.default,
    fr: $f4QSQ.default,
    hu: $3YJTA.default,
    is: $bLBTm.default,
    it: $eyWna.default,
    ja: $9kc19.default,
    ko: $7ZsZJ.default,
    nb: $4Ed6p.default,
    nl: $8VZ83.default,
    pl: $8CyCd.default,
    pt_BR: $l56YV.default,
    'pt-BR': (0, $l56YV.default),
    pt_PT: $bPDN4.default,
    'pt-PT': (0, $bPDN4.default),
    ro: $hTLsU.default,
    ru: $drDe0.default,
    sk: $5aykq.default,
    sv: $356A0.default,
    zh: $h9cNZ.default
};
const $ff1ebded08083359$export$d0a3169680473b6c = (locale)=>{
    let messages = $ff1ebded08083359$var$localesMessagesMap[locale];
    if (!messages) {
        const parentLocale = locale.split(/[-_]/)[0];
        messages = $ff1ebded08083359$var$localesMessagesMap[parentLocale];
    }
    if (!messages) messages = (0, $77fHE.default);
    return messages;
};

});
parcelRegister("bkRUt", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a3dab8adb950bc5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fFl4H = parcelRequire("fFl4H");
var $6a3dab8adb950bc5$export$2e2bcd8739ae039 = (0, $fFl4H.default);

});
parcelRegister("fFl4H", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4d75b9354018c90$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $b4d75b9354018c90$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Odkaz zkop\xedrov\xe1n do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Zkop\xedrovat odkaz",
    'fabric.elements.share.copypubliclink.button.text': "Kop\xedrovat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Nelze sd\xedlet",
    'fabric.elements.share.form.comment.label': "Zpr\xe1va (voliteln\xe1)",
    'fabric.elements.share.form.comment.placeholder': "N\u011Bco, co by m\u011Bli v\u011Bd\u011Bt?",
    'fabric.elements.share.form.extended.dialog.comment.label': "Zpr\xe1va",
    'fabric.elements.share.form.info.message.no.invite.confluence': "P\u0159\xedjemci uvid\xed n\xe1zev str\xe1nky a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.info.message.no.invite.jira': "P\u0159\xedjemci uvid\xed n\xe1zev po\u017Eadavku a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "P\u0159\xedjemci uvid\xed n\xe1zev po\u017Eadavku a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.no-permissions': "Nem\xe1te mo\u017Enost sd\xedlet.",
    'fabric.elements.share.form.public.send': "Odeslat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.public.share': "Sd\xedlet ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.required-field.summary': "Povinn\xe1 pole jsou ozna\u010Dena hv\u011Bzdi\u010Dkou.",
    'fabric.elements.share.form.retry': 'Zkusit znovu',
    'fabric.elements.share.form.send': 'Odeslat',
    'fabric.elements.share.form.share': "Sd\xedlet",
    'fabric.elements.share.form.title': "Sd\xedlet",
    'fabric.elements.share.form.user-picker.add-more': "Zadejte v\xedce",
    'fabric.elements.share.form.user-picker.label.confluence': "Jm\xe9na, t\xfdmy, skupiny nebo e-maily",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Jm\xe9na, t\xfdmy nebo skupiny",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Jm\xe9na nebo t\xfdmy",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-maily',
    'fabric.elements.share.form.user-picker.label.jira': "Jm\xe9na, t\xfdmy nebo e-maily",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky. Pozv\u011Bte lidi pomoc\xed jejich e-mailov\xe9 adresy.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "nap\u0159. Marie, T\xfdm pomeran\u010D, skupina-jedna",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "nap\u0159. Marie, T\xfdm pomeran\u010D",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "nap\u0159. marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.placeholder.jira': "nap\u0159. Marie, T\xfdm pomeran\u010D, marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte alespo\u0148 jednoho u\u017Eivatele, skupinu, t\xfdm nebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm, skupinu nebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo skupinu",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Vyberte alespo\u0148 jednu osobu nebo t\xfdm",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Vyberte alespo\u0148 jeden e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo e-mail",
    'fabric.elements.share.in.integration.button': "Sd\xedlet v: {integrationName}",
    'fabric.elements.share.invite.to.confluence': 'Pozvat do Confluence',
    'fabric.elements.share.invite.to.jira': 'Pozvat do Jira',
    'fabric.elements.share.main.tab.text.confluence': "Sd\xedlet str\xe1nku",
    'fabric.elements.share.main.tab.text.jira': "Sd\xedlet po\u017Eadavek",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Sd\xedlet",
    'fabric.elements.share.success.message': "{object, select,blogpost {P\u0159\xedsp\u011Bvek na blogu byl sd\xedlen}board {Board byl sd\xedlen}calendar {Kalend\xe1\u0159 byl sd\xedlen}draft {Koncept byl sd\xedlen}filter {Filtr byl sd\xedlen}issue {Po\u017Eadavek byl sd\xedlen}summary {Souhrn byl sd\xedlen}list {Seznam byl sd\xedlen}timeline {\u010Casov\xe1 osa byla sd\xedlena}form {Formul\xe1\u0159 byl sd\xedlen}media {Multim\xe9dia byla sd\xedlena}page {Str\xe1nka byla sd\xedlena}project {Projekt byl sd\xedlen}pullrequest {Pull request byl sd\xedlen}question {Ot\xe1zka byla sd\xedlena}report {Sestava byla sd\xedlena}repository {Repozit\xe1\u0159 byl sd\xedlen}request {\u017D\xe1dost byla sd\xedlena}roadmap {\u010Casov\xe1 osa byla sd\xedlena}site {Web byl sd\xedlen}space {Prostor byl sd\xedlen}other {Odkaz byl sd\xedlen}}",
    'fabric.elements.share.to.integration.button': "Sd\xedlet ve slu\u017Eb\u011B {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona sd\xedlen\xed",
    'fabric.elements.share.trigger.button.invite.text': 'Pozvat',
    'fabric.elements.share.trigger.button.text': "Sd\xedlet",
    'fabric.elements.share.trigger.button.tooltip.text': "Sd\xedlet"
};

});


parcelRegister("9SX9L", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a28cd9e94e46549$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $kenDy = parcelRequire("kenDy");
var $0a28cd9e94e46549$export$2e2bcd8739ae039 = (0, $kenDy.default);

});
parcelRegister("kenDy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b48645ca238b1e1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $4b48645ca238b1e1$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link er kopieret til udklipsholder',
    'fabric.elements.share.copylink.button.text': 'Kopier link',
    'fabric.elements.share.copypubliclink.button.text': "Kopi\xe9r offentligt link",
    'fabric.elements.share.failure.icon.label': 'Fejlikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Besked (valgfrit)',
    'fabric.elements.share.form.comment.placeholder': "Er der noget, de b\xf8r vide?",
    'fabric.elements.share.form.extended.dialog.comment.label': 'Besked',
    'fabric.elements.share.form.info.message.no.invite.confluence': "Modtagere vil se navnet p\xe5 siden og din besked",
    'fabric.elements.share.form.info.message.no.invite.jira': "Modtagere vil se navnet p\xe5 sagen og din meddelelse",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Modtagere f\xe5r vist navnet p\xe5 sagen og din besked",
    'fabric.elements.share.form.no-permissions': 'Du kan ikke dele.',
    'fabric.elements.share.form.public.send': 'Send offentligt link',
    'fabric.elements.share.form.public.share': 'Del offentligt link',
    'fabric.elements.share.form.required-field.summary': "P\xe5kr\xe6vede felter er markeret med en stjerne",
    'fabric.elements.share.form.retry': "Pr\xf8v igen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Indtast mere',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navne, teams, grupper eller e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navne, teams eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navne eller teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Navne, teams eller e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finde nogen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finde nogen resultater for "{inputValue}". Invit\xe9r personer via e-mailadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'f.eks. Maria, Team Orange, gruppe et',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "V\xe6lg mindst \xe9n bruger, \xe9n gruppe, \xe9t team eller \xe9n e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe6lg mindst en person, et team, en gruppe eller en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe6lg mindst en person, et team eller en gruppe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe6lg mindst en person eller et team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe6lg mindst en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe6lg mindst en person, et team eller en e-mail",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sag',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogindl\xe6g delt}board {Tavle delt}calendar {Kalender delt}draft {Udkast delt}filter {Filter delt}issue {Sag delt}summary {Oversigt delt}list {Liste delt}timeline {Tidslinje delt}form {Formular delt}media {Medier delt}page {Side delt}project {Projekt delt}pullrequest {Pullanmodning delt}question {Sp\xf8rgsm\xe5l delt}report {Rapport delt}repository {Lager delt}request {Anmodning delt}roadmap {Tidslinje delt}site {Websted delt}space {Omr\xe5de delt}other {Link delt}}",
    'fabric.elements.share.to.integration.button': 'Del med {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Del ikon',
    'fabric.elements.share.trigger.button.invite.text': "Invit\xe9r",
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});


parcelRegister("9lERR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b79fd85bd52b3ee7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $22wFp = parcelRequire("22wFp");
var $b79fd85bd52b3ee7$export$2e2bcd8739ae039 = (0, $22wFp.default);

});
parcelRegister("22wFp", function(module, exports) {
$parcel$export(module.exports, "default", () => $48f609a9746d06cd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $48f609a9746d06cd$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link in Zwischenablage kopiert',
    'fabric.elements.share.copylink.button.text': 'Link kopieren',
    'fabric.elements.share.copypubliclink.button.text': "\xd6ffentlichen Link kopieren",
    'fabric.elements.share.failure.icon.label': 'Fehler-Symbol',
    'fabric.elements.share.failure.message': "Teilen nicht m\xf6glich",
    'fabric.elements.share.form.comment.label': 'Nachricht (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Irgendetwas Wissenswertes?',
    'fabric.elements.share.form.extended.dialog.comment.label': 'Nachricht',
    'fabric.elements.share.form.info.message.no.invite.confluence': "Empf\xe4nger sehen den Namen der Seite und Ihre Nachricht",
    'fabric.elements.share.form.info.message.no.invite.jira': "Empf\xe4nger sehen den Namen des Vorgangs und Ihre Nachricht",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Empf\xe4nger sehen den Namen des Vorgangs und Ihre Nachricht",
    'fabric.elements.share.form.no-permissions': "Sie k\xf6nnen keine Elemente teilen.",
    'fabric.elements.share.form.public.send': "\xd6ffentlichen Link senden",
    'fabric.elements.share.form.public.share': "\xd6ffentlichen Link teilen",
    'fabric.elements.share.form.required-field.summary': 'Pflichtfelder sind mit einem Sternchen markiert.',
    'fabric.elements.share.form.retry': 'Erneut versuchen',
    'fabric.elements.share.form.send': 'Senden',
    'fabric.elements.share.form.share': 'Teilen',
    'fabric.elements.share.form.title': 'Teilen',
    'fabric.elements.share.form.user-picker.add-more': 'Weitere eingeben',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, Teams, Gruppen oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, Teams oder Gruppen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen oder Teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, Teams oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden. Laden Sie Personen mittels E-Mail-Adresse ein.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "z.\xa0B. Maria, Team Orange, Gruppe eins",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "z.\xa0B. Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "z.\xa0B. maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "z.\xa0B. Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "W\xe4hlen Sie mindestens einen Benutzer, eine Gruppe, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "W\xe4hlen Sie mindestens eine Person, ein Team, eine Gruppe oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine Gruppe aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "W\xe4hlen Sie mindestens eine Person oder ein Team aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "W\xe4hlen Sie mindestens eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.in.integration.button': 'In {integrationName} teilen',
    'fabric.elements.share.invite.to.confluence': 'Zu Confluence einladen',
    'fabric.elements.share.invite.to.jira': 'Zu Jira einladen',
    'fabric.elements.share.main.tab.text.confluence': 'Seite teilen',
    'fabric.elements.share.main.tab.text.jira': 'Vorgang teilen',
    'fabric.elements.share.menu.email.label': 'E-Mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Teilen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost geteilt}board {Board geteilt}calendar {Kalender geteilt}draft {Entwurf geteilt}filter {Filter geteilt}issue {Vorgang geteilt}summary {Zusammenfassung geteilt}list {Liste geteilt}timeline {Zeitleiste geteilt}form {Formular geteilt}media {Medien geteilt}page {Seite geteilt}project {Projekt geteilt}pullrequest {Pull-Anfrage geteilt}question {Frage geteilt}report {Bericht geteilt}repository {Repository geteilt}request {Anfrage geteilt}roadmap {Zeitleiste geteilt}site {Site geteilt}space {Bereich geteilt}other {Link geteilt}}',
    'fabric.elements.share.to.integration.button': 'Mit {integrationName} teilen',
    'fabric.elements.share.trigger.button.icon.label': 'Teilen-Symbol',
    'fabric.elements.share.trigger.button.invite.text': 'Einladen',
    'fabric.elements.share.trigger.button.text': 'Teilen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Teilen'
};

});


parcelRegister("77fHE", function(module, exports) {
$parcel$export(module.exports, "default", () => $23b085d4c29a785e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $cMdpe = parcelRequire("cMdpe");
var $23b085d4c29a785e$export$2e2bcd8739ae039 = (0, $cMdpe.default);

});
parcelRegister("cMdpe", function(module, exports) {
$parcel$export(module.exports, "default", () => $e584639346b7383d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $e584639346b7383d$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.extended.dialog.comment.label': 'Message',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Recipients will see the name of the work item and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});


parcelRegister("6StPO", function(module, exports) {
$parcel$export(module.exports, "default", () => $c182025fcd342c79$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $dQ2HE = parcelRequire("dQ2HE");
var $c182025fcd342c79$export$2e2bcd8739ae039 = (0, $dQ2HE.default);

});
parcelRegister("dQ2HE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b50a057f58c46de$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $6b50a057f58c46de$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.extended.dialog.comment.label': 'Message',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Recipients will see the name of the work item and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});


parcelRegister("aAbet", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e427620ae6d9e64$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $a9gb8 = parcelRequire("a9gb8");
var $3e427620ae6d9e64$export$2e2bcd8739ae039 = (0, $a9gb8.default);

});
parcelRegister("a9gb8", function(module, exports) {
$parcel$export(module.exports, "default", () => $035aa433cb737901$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $035aa433cb737901$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u2063\u2062Link copied to clipboard\x8f\u200D\x8f\u2061\u206B\u206A\u200D\u206E\x8f\x8d\x8f\u206C\u206A\u206C\x90\u200C\x9d\u206F\x81\x90\u206C\u206B\u2061\u206A\x8d\x8d\u206A\x90\u206C\x8d\u2060\u2061\u2063\u2064",
    'fabric.elements.share.copylink.button.text': "\u2063\u2062Copy link\x8d\u206C\x8f\u206E\u206A\u200D\u206E\x9d\x90\u061C\u2061\x8d\u206E\x90\u206D\x8d\u2061\u200C\u206F\x8d\u2061\x8d\u206A\x81\x81\u206B\u206E\u200C\x9d\u2060\u206F\x81\u2063\u2064",
    'fabric.elements.share.copypubliclink.button.text': "\u2063\u2062Copy public link\u2061\x81\u200C\u206F\u200D\u206D\x9d\u2061\x8f\u206C\u206D\x8f\u2061\x81\x81\u206A\u206A\x90\u206E\u2060\u061C\u2060\u206F\u206E\u206B\u206D\u200C\u061C\u200C\x9d\x9d\x9d\u2063\u2064",
    'fabric.elements.share.failure.icon.label': "\u2063\u2062Error icon\u200D\u061C\u206C\u206E\u206F\u2061\u206E\u206F\x8f\x90\u2060\u061C\x90\u061C\u200D\u200C\u206A\u206A\u200C\u200C\u206E\u206F\x90\u200D\u2061\u206B\u206A\u2060\x8f\u200C\x90\u206E\u2063\u2064",
    'fabric.elements.share.failure.message': "\u2063\u2062Unable to share\x8f\u206A\u206E\x90\u200D\x90\u2061\x90\u206A\x8d\u206D\x8d\x9d\u2060\x90\x9d\u206C\u2061\u206C\x9d\x8d\u206C\u206C\u206B\x9d\x8d\u206B\x9d\u200C\x81\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.comment.label': "\u2063\u2062Message (optional)\x8d\u200D\u206F\x8d\u206B\x90\u2060\u2061\u206D\u206E\u206F\u2061\u2060\x8f\u206C\u206E\u206B\x81\u200C\x90\u206D\u206C\x8d\u2060\u061C\u2060\u2060\x81\x8f\u200D\u200D\u206F\u2063\u2064",
    'fabric.elements.share.form.comment.placeholder': "\u2063\u2062Anything they should know?\u2060\u206F\x81\u061C\x8d\u2061\u2061\u200D\u206B\u206B\u206F\u206A\x81\u2061\u200C\u2060\x8d\x90\u206E\x90\u206E\x81\u206D\u200D\x8f\u206C\u206E\u206A\u206C\u2060\u206A\u206D\u2063\u2064",
    'fabric.elements.share.form.extended.dialog.comment.label': "\u2063\u2062Message\x81\u061C\u206E\u206E\u206F\x8f\x81\u061C\u206B\x81\x9d\u206C\u061C\x90\u206B\u200C\x9d\u2061\u200D\u206D\u206A\x8d\u2061\u200C\u200D\u206D\u206A\x8d\u061C\u206A\x8d\u061C\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u2063\u2062Recipients will see the name of the page and your message\u206F\u2060\x81\x90\u200C\u200C\x81\x90\u061C\u2060\x8d\u200C\x81\u206A\u2061\u061C\u206E\x8f\u2060\u206D\u206D\x8f\u200C\u200C\x9d\u206D\u200C\u2060\x8f\x8f\u206A\u200C\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u2063\u2062Recipients will see the name of the issue and your message\x81\u206C\u206C\x8d\u206F\u200D\u206B\u200D\u2060\u061C\u2061\x81\u206D\x8d\u206A\x8d\x90\u206B\x8d\u206A\x8f\x8d\u206D\u206E\u206D\x9d\u200D\u206C\u206E\x9d\u206F\u2060\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u2063\u2062Recipients will see the name of the work item and your message\u061C\u206B\u200D\u206B\u206D\u2060\u200D\u200C\u200C\x90\x8f\u206D\u2060\u200C\x8f\u206E\u206B\x9d\x9d\u206E\x8f\u2060\x90\u206F\u2060\x9d\u206D\u2060\u206F\x81\u206B\u206B\u2063\u2064",
    'fabric.elements.share.form.no-permissions': "\u2063\u2062You do not have the ability to share.\x8f\u206B\u206F\x8f\u061C\u206B\u206D\x81\u206C\u206F\u206F\u206C\u2060\u206E\u200D\u200D\x81\x81\u200D\u206B\x8d\u206E\x9d\u206C\x8f\u206A\u2061\u2060\u2061\x90\u206D\u206E\u2063\u2064",
    'fabric.elements.share.form.public.send': "\u2063\u2062Send public link\u206E\u206B\x8d\u206D\u206E\u206C\u2060\u206F\u206B\u206F\u061C\u2060\x8d\x9d\u200D\u206F\u2060\u2061\u206E\x81\u061C\u206F\u206D\x8d\x8f\u200C\x8d\x81\u206D\u2061\u206B\u2060\u2063\u2064",
    'fabric.elements.share.form.public.share': "\u2063\u2062Share public link\u2060\u2061\x90\u200D\u206A\u206A\u200D\u206F\u200D\x8f\u206B\u200C\u2060\u206C\u061C\u200D\u206C\u200C\u206F\x9d\u206F\x8d\u200D\x81\x9d\u206D\u2061\u2061\u206D\u2061\u061C\u206E\u2063\u2064",
    'fabric.elements.share.form.required-field.summary': "\u2063\u2062Required fields are marked with an asterisk\x8d\x8d\u200D\u206C\u2060\u206F\u206A\x9d\u206F\u200D\x90\x9d\u206A\u206D\x9d\u206B\u206C\u200C\x90\x81\x81\u206C\u2061\u200C\u200C\u2060\u200D\u061C\u206B\x9d\u206B\x9d\u2063\u2064",
    'fabric.elements.share.form.retry': "\u2063\u2062Retry\u200C\u206B\u206F\u206D\u200C\x9d\u206C\u2061\u061C\u200C\u206C\u206C\u206A\u206C\u206C\x8d\x90\u206A\x9d\x8d\u206C\u206A\u200C\x81\x8f\x8f\u2061\u2061\u206F\x90\u200C\x8d\u2063\u2064",
    'fabric.elements.share.form.send': "\u2063\u2062Send\x90\u200D\u206D\u200C\x8f\u2060\u2060\u200D\u061C\u200D\x8d\u200C\u206D\u206F\u200D\u206E\u206B\u206D\u2061\u206F\x9d\u206F\u206F\u206F\u061C\u206A\u206D\u206A\x8d\x8d\u2060\u061C\u2063\u2064",
    'fabric.elements.share.form.share': "\u2063\u2062Share\u2060\x8f\u200C\u200D\x9d\x9d\u206A\u206D\u206B\u206C\x81\x90\x8d\u2060\x8f\x8f\u206C\u200C\u206A\u200C\u061C\u2060\u061C\x8f\u061C\x8f\u206D\u206E\x8f\x8f\u200C\x81\u2063\u2064",
    'fabric.elements.share.form.title': "\u2063\u2062Share\u206E\u206B\u2060\u206E\x9d\u206C\x8d\u061C\x90\x9d\u206A\u206B\u206D\u206F\u200C\u206F\u200D\x9d\u061C\u200D\u206E\u2060\u206E\x81\u206F\u061C\x8d\x81\x8f\u2061\u206B\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.add-more': "\u2063\u2062Enter more\u2060\x9d\u2060\x81\u2061\u200D\u206B\u206F\u206E\x8d\x8d\u206B\u200C\u061C\u061C\u200C\x9d\u200D\u2060\x8d\x9d\u206C\x8f\u206A\x8f\u206B\x8d\x9d\u061C\u206C\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.confluence': "\u2063\u2062Names, teams, groups, or emails\u206F\x9d\u206F\u206D\x81\u2061\x90\u200D\u206E\u2060\x90\x8f\x81\x8d\u2061\u206D\u200D\u206D\u200D\u206A\x9d\x81\u206F\u206C\u061C\x90\u200C\u200D\x81\x8d\u206E\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u2063\u2062Names, teams, or groups\u206A\x8d\x8f\u206F\x90\u206E\u200D\u206E\u2060\u061C\u206F\u206C\x8d\x8d\x9d\u200C\x90\u206F\x9d\u061C\u206C\x90\x90\u206B\u2060\u061C\u2060\u206E\x8d\u2061\x8f\u206A\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u2063\u2062Names or teams\x8d\u206B\u206C\u206D\u206E\x90\x9d\u200C\u206A\x90\x90\u206D\u200D\u206F\u200D\x8f\u061C\u061C\u206F\u206F\u061C\u206E\u206F\u206B\u2060\u061C\u2060\u200D\u2061\x9d\x8d\x90\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-only': "\u2063\u2062Emails\x81\u061C\x9d\u206C\x8f\u206A\u200C\u206A\u206F\u2060\u206B\x9d\u206F\x90\x9d\x9d\u206A\u061C\x8f\u206B\u206F\u206E\x8f\u061C\x9d\u206C\u206E\u206F\u2060\u206C\x8f\u206C\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.jira': "\u2063\u2062Names, teams, or emails\u200C\u2061\u206D\u206B\u200C\u061C\u206F\u061C\u2060\u200C\x8f\x8f\u2061\u206D\x81\u206B\x8f\u061C\u200D\x8d\x8f\u2061\u206E\u061C\u206D\x81\u2060\u061C\u2060\u206B\u206F\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}".\u206D\x8f\x8f\u2061\u206D\u200C\x81\x9d\u206D\x90\x8f\u200C\u206E\u206F\u206B\x8f\u061C\u2061\u2061\u206F\u2061\x81\x9d\u2060\x90\u2060\u206B\x9d\u200D\u206D\u200D\u206A\u2063\u2064',
    'fabric.elements.share.form.user-picker.no-options.generic': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.\x8d\u2061\u061C\x8f\x9d\u206E\u061C\u200D\u2060\u206A\u206A\x9d\u061C\x9d\x8f\x90\u2060\u2060\u2061\u206E\u061C\u206F\u206C\x90\u2061\u2060\u206D\u200D\u206B\x8f\x90\u200D\u2063\u2064',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u2063\u2062e.g. Maria, Team Orange, group-one\u200D\u206D\x81\u2061\u200D\u2060\u206B\u061C\x90\x8f\u206C\u206E\u206A\x8f\x8f\u061C\u206E\u200D\x90\x8d\x8d\x90\u206C\x90\u2061\u206C\x9d\u206F\x90\u206F\u206C\x9d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u2063\u2062e.g. Maria, Team Orange\x81\u206E\u206C\x81\u061C\x9d\u2061\u206A\u206F\x9d\x90\u206C\u200C\x90\u2061\u200D\u206D\x90\u206F\x81\x81\u061C\u206C\u206C\u206C\x8d\u061C\x8d\u206F\u061C\u206A\u061C\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u2063\u2062e.g. maria@company.com\x8d\u206B\u206A\u061C\x9d\u206B\x81\u2060\u206B\x9d\u206B\u206C\u206B\u200C\u206C\u200D\u206C\u206F\u061C\u206B\x90\u206A\x8f\u2060\u200D\u061C\u206F\u206E\u200C\x8f\u061C\x8d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u2063\u2062e.g. Maria, Team Orange, maria@company.com\x8f\x8d\u206A\u200C\u2061\u061C\u206D\x81\u2061\x8d\u206A\x8d\u200D\x8d\u206A\u206D\u2061\u2061\u061C\u200C\x9d\u200C\u206C\u200D\u206A\x8f\u206C\u2060\u206D\u206B\x9d\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required': "\u2063\u2062Select at least one user, group, team or email.\x81\u206E\u206A\x81\u206F\u2061\x8f\x9d\x9d\u206D\u2061\u061C\u206B\u206F\x9d\u200C\u200D\u206D\u206B\x81\x81\u206A\u206F\u200C\x8d\x90\x81\u206B\u2060\u061C\x9d\u206B\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u2063\u2062Select at least one person, team, group, or email\u206B\x81\u206E\x9d\u206D\x90\u200D\x9d\u200C\u206D\x9d\u2060\u206B\x8d\x8f\u206C\u206C\u2061\u206D\u206F\x8d\x90\u200C\x90\u200D\u206F\u200C\u206A\u206D\u2061\u2060\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u2063\u2062Select at least one person, team, or group\x8d\u206C\u206F\u061C\x90\u206D\x9d\u206D\u206A\u200C\u206E\x8f\u2060\u206D\x81\u206A\x8d\u206A\x9d\x9d\u2060\u200C\u206A\x8f\u200C\x9d\x9d\u206E\u2061\x8d\x81\x8f\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u2063\u2062Select at least one person or team\u206A\u206F\u200D\x8f\u206D\u206F\u206B\x90\u206C\x81\u206E\u2060\u200D\u2061\x81\u206A\x8d\u206E\u206F\x8f\x9d\x8f\x8f\u2060\x9d\x81\x81\u206A\u206C\x81\u200C\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u2063\u2062Select at least one email\x8f\u206F\u206D\x81\u200D\u206B\u206B\x8d\u206D\x8d\u200C\x8d\x9d\u200C\u206F\u200D\u200D\u2060\u2061\u206F\u061C\x8d\u206F\x90\u200D\u2061\u206A\x8d\x90\u200C\x8f\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u2063\u2062Select at least one person, team, or email\u2060\x9d\u2060\u206A\x90\u200C\u200C\u061C\u206C\u200D\x8d\u200D\u200D\u2060\u200C\u206C\u206A\u206D\u206D\u206E\u200D\u200D\x90\u061C\u200C\u2060\u206A\u206B\u2061\u206A\u2060\x8f\u2063\u2064",
    'fabric.elements.share.in.integration.button': "\u2063\u2062Share in {integrationName}\u2060\u061C\x90\u206A\u2061\u206C\u206D\u2061\u206D\x90\x8f\x8f\u200C\u206B\u206A\x9d\u206C\u2061\u061C\u200C\x90\u206E\u206A\u206F\u206C\x81\u200C\x8f\u206C\u200C\x81\u206D\u2063\u2064",
    'fabric.elements.share.invite.to.confluence': "\u2063\u2062Invite to Confluence\u206A\u206E\x8f\u2061\x8f\u206D\u206B\x9d\u206A\x9d\x8f\u206F\u061C\u200D\u206B\u206A\u200D\x9d\u2060\u206D\u200D\x8f\u2061\x8d\u2060\u2061\u206E\x81\u206C\u061C\u200D\u200D\u2063\u2064",
    'fabric.elements.share.invite.to.jira': "\u2063\u2062Invite to Jira\u061C\x8f\u2060\u2061\x8f\u206F\x8d\x81\x9d\x81\u206C\u2060\u200C\u206E\u206E\u061C\x90\u2060\u206E\u2060\u200D\x8d\x81\u206B\u206F\x8d\u200D\u206B\u2061\x9d\u206C\x8f\u2063\u2064",
    'fabric.elements.share.main.tab.text.confluence': "\u2063\u2062Share page\x81\u206A\u206F\u206D\u206C\u206C\x8f\x8f\x8f\x8d\x8f\x8f\u206A\u206C\u206F\x9d\u200C\x8f\u200D\u200C\u200D\u2060\x8d\u206B\x8f\u2061\u061C\u206E\x81\u200C\x8d\u206E\u2063\u2064",
    'fabric.elements.share.main.tab.text.jira': "\u2063\u2062Share issue\x9d\x9d\x8f\x9d\u061C\u206D\u200D\u206E\x90\x81\u200D\x9d\x81\x90\x8f\u206C\u061C\u200D\x9d\x9d\u206C\x9d\u206F\u2061\u2060\u2060\u206A\u206E\u061C\x81\u200D\x8f\u2063\u2064",
    'fabric.elements.share.menu.email.label': "\u2063\u2062Email\u206E\x90\u200D\u206B\u2061\u206C\u061C\u206A\u206A\u200C\u200C\x8f\u061C\x8f\u200C\u200C\u206C\u206D\u200C\u206A\x8f\x81\u206F\u2061\x8d\u2061\u206E\u2061\u206E\u206C\u206A\u206A\u2063\u2064",
    'fabric.elements.share.menu.slack.label': "\u2063\u2062Slack\u206B\u200C\u206B\x8f\u061C\u206D\x9d\u061C\x8f\u200D\u2060\u200D\x81\x90\u206C\u206F\u200C\x81\u2061\x9d\x8f\u206F\u200D\x8f\u206E\u200C\x8f\x81\u206C\u2060\x8d\u2060\u2063\u2064",
    'fabric.elements.share.popup.label': "\u2063\u2062Share\u206D\x9d\u206D\u206B\u206C\u200D\u200C\u206C\x8f\u206C\x90\x81\x81\x8d\x90\x8f\u206B\u206A\u2061\u200C\u206F\u206A\u200C\u206E\x9d\x8d\u206E\u200C\u200D\u200D\x81\u206C\u2063\u2064",
    'fabric.elements.share.success.message': "\u2063\u2062{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}\x8f\x8f\u206A\x81\x9d\u206F\u061C\u206F\u206A\u200C\u206C\u206F\u206F\x8d\x8d\u206C\u206C\x8d\u206C\u206D\u206C\u206A\u206E\u2060\u200D\x90\u061C\x90\x81\u206E\u206D\x9d\u2063\u2064",
    'fabric.elements.share.to.integration.button': "\u2063\u2062Share to {integrationName}\x9d\u206D\u200C\x9d\x8d\u206C\u206E\u206E\u206D\u206A\u2061\u200C\u2060\u206F\x90\u2061\x8d\u2061\u2061\u2060\x9d\u200D\x90\u200D\u206A\x9d\u061C\u200C\x9d\u206B\u2061\x8f\u2063\u2064",
    'fabric.elements.share.trigger.button.icon.label': "\u2063\u2062Share icon\x81\x90\u200C\x9d\u206C\u200D\x8f\x8f\u206E\x9d\u206F\u206B\x8f\u206F\x9d\x8d\x8d\u061C\u200D\x9d\x8f\u206C\u206F\u200D\u206D\u061C\x90\u206A\u200C\u206A\u206B\u2061\u2063\u2064",
    'fabric.elements.share.trigger.button.invite.text': "\u2063\u2062Invite\u2061\u200D\u206A\u206B\x9d\u206D\x8f\u200D\u206F\x81\u2060\u206B\u206B\x8f\x8f\u206E\u061C\u2061\x8f\u200C\u206E\x81\u2060\u061C\u061C\x9d\u206E\u061C\x9d\u206D\u206A\u061C\u2063\u2064",
    'fabric.elements.share.trigger.button.text': "\u2063\u2062Share\u206B\u206A\x81\x8d\x8d\x9d\x8f\u200C\u206D\u206D\x9d\u2061\x81\x81\u200D\u206F\u200C\u206C\u200D\x90\u206A\u206B\u206F\u061C\u061C\u206E\x9d\u2061\u200D\x90\x81\u206B\u2063\u2064",
    'fabric.elements.share.trigger.button.tooltip.text': "\u2063\u2062Share\u200C\u206F\u2061\u206A\x90\u200C\u061C\u200C\x8f\u200C\u206A\u206F\u206D\u2060\u061C\u2061\u206D\u206F\u206E\u206D\x8d\u200C\x90\u200C\u200D\u206A\u206E\x8d\u206A\u200C\u206C\u206A\u2063\u2064"
};

});


parcelRegister("a7DPA", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb58cffa808ae1a9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $l5E9a = parcelRequire("l5E9a");
var $fb58cffa808ae1a9$export$2e2bcd8739ae039 = (0, $l5E9a.default);

});
parcelRegister("l5E9a", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f8495242e3959ef$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $7f8495242e3959ef$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Enlace copiado en el portapapeles',
    'fabric.elements.share.copylink.button.text': 'Copiar enlace',
    'fabric.elements.share.copypubliclink.button.text': "Copiar enlace p\xfablico",
    'fabric.elements.share.failure.icon.label': 'Icono de error',
    'fabric.elements.share.failure.message': 'No se puede compartir',
    'fabric.elements.share.form.comment.label': 'Mensaje (opcional)',
    'fabric.elements.share.form.comment.placeholder': "\xbfHay algo que haya que saber?",
    'fabric.elements.share.form.extended.dialog.comment.label': 'Mensaje',
    'fabric.elements.share.form.info.message.no.invite.confluence': "Los destinatarios ver\xe1n el nombre de la p\xe1gina y tu mensaje",
    'fabric.elements.share.form.info.message.no.invite.jira': "Los destinatarios ver\xe1n el nombre de la incidencia y tu mensaje",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Los destinatarios ver\xe1n el nombre de la actividad y tu mensaje",
    'fabric.elements.share.form.no-permissions': 'No puedes compartir.',
    'fabric.elements.share.form.public.send': "Enviar enlace p\xfablico",
    'fabric.elements.share.form.public.share': "Compartir enlace p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Los campos obligatorios est\xe1n marcados con un asterisco",
    'fabric.elements.share.form.retry': 'Reintentar',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartir',
    'fabric.elements.share.form.title': 'Compartir',
    'fabric.elements.share.form.user-picker.add-more': "Introduce m\xe1s cosas",
    'fabric.elements.share.form.user-picker.label.confluence': "Nombres, equipos, grupos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nombres, equipos o grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nombres o equipos',
    'fabric.elements.share.form.user-picker.label.email-only': "Correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.jira': "Nombres, equipos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'No hemos encontrado ning\xfan resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'No hemos encontrado ning\xfan resultado para "{inputValue}". Invita a la gente mediante una direcci\xf3n de correo electr\xf3nico.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "p.\xa0ej. Mar\xeda, equipo naranja, grupo uno",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "p.\xa0ej. Mar\xeda, equipo naranja",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "p.\xa0ej. maria@empresa.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "p.\xa0ej. Mar\xeda, equipo naranja, maria@empresa.com",
    'fabric.elements.share.form.user-picker.validation.required': "Selecciona al menos un usuario, grupo, equipo o correo electr\xf3nico.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecciona al menos una persona, equipo, grupo o correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecciona al menos una persona, equipo o grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecciona al menos una persona o equipo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecciona al menos un correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecciona al menos una persona, equipo o correo electr\xf3nico",
    'fabric.elements.share.in.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invitar a Confluence',
    'fabric.elements.share.invite.to.jira': 'Invitar a Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartir p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartir incidencia',
    'fabric.elements.share.menu.email.label': "Correo electr\xf3nico",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartir',
    'fabric.elements.share.success.message': "{object, select,blogpost {Entrada de blog compartida}board {Tablero compartido}calendar {Calendario compartido}draft {Borrador compartido}filter {Filtro compartido}issue {Incidencia compartida}summary {Resumen compartido}list {Lista compartida}timeline {Cronograma compartido}form {Formulario compartido}media {Recursos multimedia compartidos}page {P\xe1gina compartida}project {Proyecto compartido}pullrequest {Solicitud de incorporaci\xf3n de cambios compartida}question {Pregunta compartida}report {Informe compartido}repository {Repositorio compartido}request {Solicitud compartida}roadmap {Cronograma compartido}site {Sitio compartido}space {Espacio compartido}other {Enlace compartido}}",
    'fabric.elements.share.to.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icono de compartir',
    'fabric.elements.share.trigger.button.invite.text': 'Invitar',
    'fabric.elements.share.trigger.button.text': 'Compartir',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartir'
};

});


parcelRegister("1gaRJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $00f598baf020c035$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Estonian
var $00f598baf020c035$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link kopeeritud l\xf5ikelauale",
    'fabric.elements.share.copylink.button.text': 'Kopeeri link',
    'fabric.elements.share.failure.icon.label': 'Vea ikoon',
    'fabric.elements.share.failure.message': 'Jagamine nurjus',
    'fabric.elements.share.form.comment.placeholder': "S\xf5numi lisamine",
    'fabric.elements.share.form.retry': 'Proovi uuesti',
    'fabric.elements.share.form.send': 'Saada',
    'fabric.elements.share.form.title': 'Jaga',
    'fabric.elements.share.form.user-picker.add-more': 'Sisesta veel',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}". Kutsu inimesi e-posti aadressi alusel.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sisesta nimi v\xf5i meeskond",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sisestage nimi, r\xfchm, meeskond v\xf5i meil",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Sisestage nimi, tiim v\xf5i meil",
    'fabric.elements.share.form.user-picker.validation.required': "Valige v\xe4hemalt \xfcks kasutaja, r\xfchm, meeskond v\xf5i meil.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Valige v\xe4hemalt \xfcks kasutaja, tiim v\xf5i meil.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogipostitus jagatud} board {T\xf6\xf6laud jagatud} calendar {Kalender jagatud} draft {Mustand jagatud} filter {Filter jagatud} issue {Probleem jagatud} media {Meediafail jagatud} page {Leht jagatud} project {Projekt jagatud} pullrequest {T\xf5mbekutse jagatud} question {K\xfcsimus jagatud} report {Raport jagatud} repository {Koodihoidla jagatud} request {Taotlus jagatud} roadmap {T\xf6\xf6plaan jagatud} site {Sait jagatud} space {Ruum jagatud} other {Link jagatud}}",
    'fabric.elements.share.trigger.button.icon.label': 'Jagamisikoon',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaga',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaga'
};

});

parcelRegister("4tj41", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf82b8b3cc823286$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $O1KV5 = parcelRequire("O1KV5");
var $cf82b8b3cc823286$export$2e2bcd8739ae039 = (0, $O1KV5.default);

});
parcelRegister("O1KV5", function(module, exports) {
$parcel$export(module.exports, "default", () => $91e83130c60b7d34$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $91e83130c60b7d34$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Linkki kopioitu leikep\xf6yd\xe4lle",
    'fabric.elements.share.copylink.button.text': 'Kopioi linkki',
    'fabric.elements.share.copypubliclink.button.text': 'Kopioi julkinen linkki',
    'fabric.elements.share.failure.icon.label': 'Virhekuvake',
    'fabric.elements.share.failure.message': 'Ei voitu jakaa',
    'fabric.elements.share.form.comment.label': 'Viesti (valinnainen)',
    'fabric.elements.share.form.comment.placeholder': "Mit\xe4 muiden tulisi tiet\xe4\xe4?",
    'fabric.elements.share.form.extended.dialog.comment.label': 'Viesti',
    'fabric.elements.share.form.info.message.no.invite.confluence': "Vastaanottajat n\xe4kev\xe4t sivun nimen ja viestisi",
    'fabric.elements.share.form.info.message.no.invite.jira': "Vastaanottajat n\xe4kev\xe4t asian nimen ja viestisi",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Vastaanottajat n\xe4kev\xe4t ty\xf6teht\xe4v\xe4n nimen ja viestisi",
    'fabric.elements.share.form.no-permissions': 'Sinulla ei ole jakamisoikeutta.',
    'fabric.elements.share.form.public.send': "L\xe4het\xe4 julkinen linkki",
    'fabric.elements.share.form.public.share': 'Jaa julkinen linkki',
    'fabric.elements.share.form.required-field.summary': "Pakolliset kent\xe4t on merkitty t\xe4hdell\xe4",
    'fabric.elements.share.form.retry': "Yrit\xe4 uudelleen",
    'fabric.elements.share.form.send': "L\xe4het\xe4",
    'fabric.elements.share.form.share': 'Jaa',
    'fabric.elements.share.form.title': 'Jaa',
    'fabric.elements.share.form.user-picker.add-more': "Sy\xf6t\xe4 lis\xe4\xe4",
    'fabric.elements.share.form.user-picker.label.confluence': "Nimet, tiimit, ryhm\xe4t tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nimet, tiimit tai ryhm\xe4t",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nimet tai tiimit',
    'fabric.elements.share.form.user-picker.label.email-only': "S\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.jira': "Nimet, tiimit tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}". Kutsu henkil\xf6it\xe4 s\xe4hk\xf6postiosoitteen avulla.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "esim. Maria, Oranssi tiimi, ykk\xf6sryhm\xe4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'esim. Maria, Oranssi tiimi',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'esim. maria@yritys.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'esim. Maria, Oranssi tiimi, maria@yritys.com',
    'fabric.elements.share.form.user-picker.validation.required': "Valitse v\xe4hint\xe4\xe4n yksi k\xe4ytt\xe4j\xe4, ryhm\xe4, tiimi tai s\xe4hk\xf6postiosoite.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi, ryhm\xe4 tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai ryhm\xe4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6 tai tiimi",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Valitse v\xe4hint\xe4\xe4n yksi s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.in.integration.button': 'Jaa sovelluksessa {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Kutsu Confluenceen',
    'fabric.elements.share.invite.to.jira': 'Kutsu Jiraan',
    'fabric.elements.share.main.tab.text.confluence': 'Jaa sivu',
    'fabric.elements.share.main.tab.text.jira': 'Jaa asia',
    'fabric.elements.share.menu.email.label': "S\xe4hk\xf6posti",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Jaa',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogijulkaisu jaettu}board {Taulu jaettu}calendar {Kalenteri jaettu}draft {Luonnos jaettu}filter {Suodatin jaettu}issue {Asia jaettu}summary {Yhteenveto jaettu}list {Luettelo jaettu}timeline {Aikajana jaettu}form {Lomake jaettu}media {Media jaettu}page {Sivu jaettu}project {Projekti jaettu}pullrequest {Pull-pyynt\xf6 jaettu}question {Kysymys jaettu}report {Raportti jaettu}repository {S\xe4il\xf6 jaettu}request {Pyynt\xf6 jaettu}roadmap {Aikajana jaettu}site {Sivusto jaettu}space {Ty\xf6tila jaettu}other {Linkki jaettu}}",
    'fabric.elements.share.to.integration.button': 'Jaa kohteeseen {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Jaa kuvake',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaa',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaa'
};

});


parcelRegister("f4QSQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dd4680a1a5484b7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $4ASRD = parcelRequire("4ASRD");
var $2dd4680a1a5484b7$export$2e2bcd8739ae039 = (0, $4ASRD.default);

});
parcelRegister("4ASRD", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c6030f1945ad9df$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $5c6030f1945ad9df$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Lien copi\xe9 dans le presse-papier",
    'fabric.elements.share.copylink.button.text': 'Copier le lien',
    'fabric.elements.share.copypubliclink.button.text': 'Copier le lien public',
    'fabric.elements.share.failure.icon.label': "Ic\xf4ne d'erreur",
    'fabric.elements.share.failure.message': 'Partage impossible',
    'fabric.elements.share.form.comment.label': 'Message (facultatif)',
    'fabric.elements.share.form.comment.placeholder': "D'autres choses \xe0 savoir\xa0?",
    'fabric.elements.share.form.extended.dialog.comment.label': 'Message',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Les destinataires verront le nom de la page et votre message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Les destinataires verront le nom du ticket et votre message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Les destinataires verront le nom du ticket et votre message',
    'fabric.elements.share.form.no-permissions': 'Vous ne pouvez pas partager ce contenu.',
    'fabric.elements.share.form.public.send': 'Envoyer le lien public',
    'fabric.elements.share.form.public.share': 'Partager un lien public',
    'fabric.elements.share.form.required-field.summary': "Les champs obligatoires sont marqu\xe9s d'un ast\xe9risque",
    'fabric.elements.share.form.retry': "R\xe9essayer",
    'fabric.elements.share.form.send': 'Envoyer',
    'fabric.elements.share.form.share': 'Partager',
    'fabric.elements.share.form.title': 'Partager',
    'fabric.elements.share.form.user-picker.add-more': "Saisir plus d\u2019\xe9l\xe9ments",
    'fabric.elements.share.form.user-picker.label.confluence': "Noms, \xe9quipes, groupes ou e-mails",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Noms, \xe9quipes ou groupes",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Noms ou \xe9quipes",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': "Noms, \xe9quipes ou e-mails",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb. Invitez des personnes \xe0 l'aide d'une adresse e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "Par exemple, Maria, \xe9quipe Orange, groupe-1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "Par exemple, Maria, \xe9quipe Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'Par exemple, maria@entreprise.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "Par exemple, Maria, \xe9quipe Orange, maria@entreprise.com",
    'fabric.elements.share.form.user-picker.validation.required': "S\xe9lectionnez au moins un utilisateur, un groupe, une \xe9quipe ou une adresse e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe, un groupe ou un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un groupe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "S\xe9lectionnez au moins une personne ou \xe9quipe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "S\xe9lectionnez au moins un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un e-mail",
    'fabric.elements.share.in.integration.button': 'Partager dans {integrationName}',
    'fabric.elements.share.invite.to.confluence': "Inviter \xe0 rejoindre Confluence",
    'fabric.elements.share.invite.to.jira': "Inviter \xe0 rejoindre Jira",
    'fabric.elements.share.main.tab.text.confluence': 'Partager la page',
    'fabric.elements.share.main.tab.text.jira': 'Partager le ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Partager',
    'fabric.elements.share.success.message': "{object, select,blogpost {Billet de blog partag\xe9}board {Tableau partag\xe9}calendar {Calendrier partag\xe9}draft {Brouillon partag\xe9}filter {Filtre partag\xe9}issue {Ticket partag\xe9}summary {R\xe9sum\xe9 partag\xe9}list {Liste partag\xe9e}timeline {Chronologie partag\xe9e}form {Formulaire partag\xe9}media {M\xe9dia partag\xe9}page {Page partag\xe9e}project {Projet partag\xe9}pullrequest {Pull request partag\xe9e}question {Question partag\xe9e}report {Rapport partag\xe9}repository {D\xe9p\xf4t partag\xe9}request {Demande partag\xe9e}roadmap {Chronologie partag\xe9e}site {Site partag\xe9}space {Espace partag\xe9}other {Lien partag\xe9}}",
    'fabric.elements.share.to.integration.button': 'Partager avec {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Ic\xf4ne de partage",
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Partager',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partager'
};

});


parcelRegister("3YJTA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7fc54854eeb29b4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $n62cD = parcelRequire("n62cD");
var $b7fc54854eeb29b4$export$2e2bcd8739ae039 = (0, $n62cD.default);

});
parcelRegister("n62cD", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e23d285a3f3cd50$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $5e23d285a3f3cd50$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Hivatkoz\xe1s \xe1tm\xe1solva a v\xe1g\xf3lapra",
    'fabric.elements.share.copylink.button.text': "Hivatkoz\xe1s m\xe1sol\xe1sa",
    'fabric.elements.share.copypubliclink.button.text': "Publikus link m\xe1sol\xe1sa",
    'fabric.elements.share.failure.icon.label': 'Hiba ikon',
    'fabric.elements.share.failure.message': 'Nem lehet megosztani',
    'fabric.elements.share.form.comment.label': "\xdczenet (nem k\xf6telez\u0151)",
    'fabric.elements.share.form.comment.placeholder': "Van b\xe1rmi, amit \xe9rdemes tudni?",
    'fabric.elements.share.form.extended.dialog.comment.label': "\xdczenet",
    'fabric.elements.share.form.info.message.no.invite.confluence': "A c\xedmzettek l\xe1tj\xe1k az oldal nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.info.message.no.invite.jira': "A c\xedmzettek l\xe1tj\xe1k az \xfcgy nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "A c\xedmzettek l\xe1tj\xe1k az \xfcgy nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.no-permissions': "Nincs lehet\u0151s\xe9ged a megoszt\xe1sra.",
    'fabric.elements.share.form.public.send': "Publikus link k\xfcld\xe9se",
    'fabric.elements.share.form.public.share': "Nyilv\xe1nos link megoszt\xe1sa",
    'fabric.elements.share.form.required-field.summary': "A k\xf6telez\u0151 mez\u0151k csillaggal vannak megjel\xf6lve",
    'fabric.elements.share.form.retry': "\xdajra",
    'fabric.elements.share.form.send': "K\xfcld\xe9s",
    'fabric.elements.share.form.share': "Megoszt\xe1s",
    'fabric.elements.share.form.title': "Megoszt\xe1s",
    'fabric.elements.share.form.user-picker.add-more': "Tov\xe1bbiak megad\xe1sa",
    'fabric.elements.share.form.user-picker.label.confluence': "Nevek, csapatok, csoportok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nevek, csapatok vagy csoportok',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nevek vagy csapatok',
    'fabric.elements.share.form.user-picker.label.email-only': "E-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.jira': "Nevek, csapatok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D. H\xedvj meg embereket az e-mail-c\xedm\xfck alapj\xe1n.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "pl. M\xe1ria, Narancs csapat, egyes-csoport",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "pl. M\xe1ria, Narancs csapat",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'pl. maria@vallalat.hu',
    'fabric.elements.share.form.user-picker.placeholder.jira': "pl. M\xe1ria, Narancs csapat, maria@vallalat.hu",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe1lassz ki legal\xe1bb egy felhaszn\xe1l\xf3t, csoportot, csapatot vagy e-mail-c\xedmet.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot, csoportot vagy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy csoportot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt vagy csapatot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe1lassz ki legal\xe1bb egy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy e-mail-c\xedmet",
    'fabric.elements.share.in.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Megh\xedv\xe1s a Confluence-be",
    'fabric.elements.share.invite.to.jira': "Megh\xedv\xe1s a Jir\xe1ba",
    'fabric.elements.share.main.tab.text.confluence': "Oldal megoszt\xe1sa",
    'fabric.elements.share.main.tab.text.jira': "\xdcgy megoszt\xe1sa",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Megoszt\xe1s",
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogposzt megosztva}board {T\xe1bla megosztva}calendar {Napt\xe1r megosztva}draft {Piszkozat megosztva}filter {Sz\u0171r\u0151 megosztva}issue {\xdcgy megosztva}summary {\xd6sszefoglal\xf3 megosztva}list {Lista megosztva}timeline {Id\u0151vonal megosztva}form {\u0170rlap megosztva}media {M\xe9dia megosztva}page {Oldal megosztva}project {Projekt megosztva}pullrequest {Pull-k\xe9relem megosztva}question {K\xe9rd\xe9s megosztva}report {Jelent\xe9s megosztva}repository {Adatt\xe1r megosztva}request {K\xe9relem megosztva}roadmap {Id\u0151vonal megosztva}site {Webhely megosztva}space {Munkat\xe9r megosztva}other {Link megosztva}}",
    'fabric.elements.share.to.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikon megoszt\xe1sa",
    'fabric.elements.share.trigger.button.invite.text': "Megh\xedv\xe1s",
    'fabric.elements.share.trigger.button.text': "Megoszt\xe1s",
    'fabric.elements.share.trigger.button.tooltip.text': "Megoszt\xe1s"
};

});


parcelRegister("bLBTm", function(module, exports) {
$parcel$export(module.exports, "default", () => $171766006708c023$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Icelandic
var $171766006708c023$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': 'Deila',
    'fabric.elements.share.form.send': 'Senda ',
    'fabric.elements.share.form.retry': 'Reyna aftur',
    'fabric.elements.share.form.comment.placeholder': "B\xe6ta vi\xf0 skilabo\xf0um",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sl\xe1\xf0u inn nafn, teymi e\xf0a t\xf6lvup\xf3stur",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sl\xe1\xf0u inn nafn e\xf0a teymi",
    'fabric.elements.share.form.user-picker.add-more': "F\xe6ra inn fleiri ",
    'fabric.elements.share.form.user-picker.validation.required': "Veldu a\xf0 minnsta kosti einn notanda, teymi e\xf0a netfang.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "\xde\xfa getur a\xf0eins bo\xf0i\xf0 f\xf3lki sem eru me\xf0 {domains} netf\xf6ng. Haf\xf0u samband vi\xf0 stj\xf3rnanda s\xed\xf0unnar \xfeinnar til a\xf0 bj\xf3\xf0a \xf6\xf0ru f\xf3lki.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Ekki fundust neinar ni\xf0urst\xf6\xf0ur fyrir \u201E{inputValue}\u201C. Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota netf\xf6ng.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Engar ni\xf0urst\xf6\xf0ur fundust fyrir "{inputValue}". Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota t\xf6lvup\xf3stfang.',
    'fabric.elements.share.trigger.button.icon.label': "Deilingart\xe1kn",
    'fabric.elements.share.trigger.button.text': 'Deila',
    'fabric.elements.share.trigger.button.tooltip.text': 'Deila',
    'fabric.elements.share.trigger.button.invite.text': "Bo\xf0i\xf0",
    'fabric.elements.share.copylink.button.icon.label': "\u201EAfrita tengil\u201C-t\xe1kn",
    'fabric.elements.share.copylink.button.text': 'Afrita tengil',
    'fabric.elements.share.copied.to.clipboard.icon.label': "T\xe1kn sem s\xfdnir a\xf0 tengilinn hafi veri\xf0 afrita\xf0ur me\xf0 g\xf3\xf0um \xe1rangri",
    'fabric.elements.share.copied.to.clipboard.message': "Tengill afrita\xf0ur \xe1 klippibor\xf0",
    'fabric.elements.share.form.capabilities.info.message': "Bo\xf0skorti\xf0 \xfeitt ver\xf0ur sent til stj\xf3rnanda til sam\xfeykkis",
    'fabric.elements.share.failure.icon.label': "Villut\xe1kn",
    'fabric.elements.share.failure.message': "Ekki er h\xe6gt a\xf0 deila",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} tafla {Board shared} dagatal {Calendar shared} uppkast {Draft shared} s\xeda {Filter shared} m\xe1lefni {Issue shared} mi\xf0ill {Media shared} s\xed\xf0a {Page shared} verkefni {Project shared} togbei\xf0ni {Pull Request shared} spurning {Question shared} sk\xfdrsla {Report shared} Gagnageymsla {Repository shared} bei\xf0ni {Request shared} vegv\xedsir {Roadmap shared} s\xed\xf0a {Site shared} sv\xe6\xf0i {Space shared} anna\xf0 {Link Shared}}",
    'fabric.elements.share.admin.notified.message': "Stj\xf3rnanda hefur veri\xf0 tilkynnt"
};

});

parcelRegister("eyWna", function(module, exports) {
$parcel$export(module.exports, "default", () => $26484165af9b02bf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $bXch0 = parcelRequire("bXch0");
var $26484165af9b02bf$export$2e2bcd8739ae039 = (0, $bXch0.default);

});
parcelRegister("bXch0", function(module, exports) {
$parcel$export(module.exports, "default", () => $93d89a5a0e374042$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $93d89a5a0e374042$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copiato negli appunti',
    'fabric.elements.share.copylink.button.text': 'Copia link',
    'fabric.elements.share.copypubliclink.button.text': 'Copia link pubblico',
    'fabric.elements.share.failure.icon.label': 'Icona Errore',
    'fabric.elements.share.failure.message': 'Impossibile effettuare la condivisione',
    'fabric.elements.share.form.comment.label': 'Messaggio (opzionale)',
    'fabric.elements.share.form.comment.placeholder': 'Vuoi comunicare loro qualcosa?',
    'fabric.elements.share.form.extended.dialog.comment.label': 'Messaggio',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'I destinatari vedranno il nome della pagina e il tuo messaggio',
    'fabric.elements.share.form.info.message.no.invite.jira': 'I destinatari vedranno il nome del ticket e il tuo messaggio',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'I destinatari vedranno il nome del ticket e il tuo messaggio',
    'fabric.elements.share.form.no-permissions': 'Non puoi eseguire condivisioni.',
    'fabric.elements.share.form.public.send': 'Invia link pubblico',
    'fabric.elements.share.form.public.share': 'Condividi link pubblico',
    'fabric.elements.share.form.required-field.summary': 'I campi obbligatori sono contrassegnati da un asterisco',
    'fabric.elements.share.form.retry': 'Riprova',
    'fabric.elements.share.form.send': 'Invia',
    'fabric.elements.share.form.share': 'Condividi',
    'fabric.elements.share.form.title': 'Condividi',
    'fabric.elements.share.form.user-picker.add-more': 'Inerisci altri elementi',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomi, team, gruppi o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomi, team o gruppi',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomi o team',
    'fabric.elements.share.form.user-picker.label.email-only': 'Indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomi, team o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nessun risultato trovato per \u201C{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nessun risultato trovato per \u201C{inputValue}\u201D. Invita le persone inserendo il loro indirizzo e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'ad esempio Maria, Team Arancione, gruppo uno',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'ad esempio Maria, Team Arancione',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'ad esempio maria@azienda.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'ad esempio Maria, Team Arancione, maria@azienda.com',
    'fabric.elements.share.form.user-picker.validation.required': "Seleziona almeno un utente, un gruppo, un team o un'e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Seleziona almeno una persona, un team, un gruppo o un indirizzo e-mail.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Seleziona almeno una persona, un team o un gruppo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Seleziona almeno una persona o un team.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Seleziona almeno un indirizzo e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Seleziona almeno una persona, un team o un indirizzo e-mail',
    'fabric.elements.share.in.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invita in Confluence',
    'fabric.elements.share.invite.to.jira': 'Invita in Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Condividi pagina',
    'fabric.elements.share.main.tab.text.jira': 'Condividi ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Condividi',
    'fabric.elements.share.success.message': '{object, select,blogpost {Post del blog condiviso}board {Board condivisa}calendar {Calendario condiviso}draft {Bozza condivisa}filter {Filtro condiviso}issue {Ticket condiviso}summary {Riepilogo condiviso}list {Elenco condiviso}timeline {Timeline condivisa}form {Modulo condiviso}media {Elemento multimediale condiviso}page {Pagina condiviso}project {Progetto condiviso}pullrequest {Pull request condivisa}question {Domanda condivisa}report {Report condiviso}repository {Repository condiviso}request {Richiesta condivisa}roadmap {Timeline condivisa}site {Sito condiviso}space {Spazio condiviso}other {Link condiviso}}',
    'fabric.elements.share.to.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icona Condividi',
    'fabric.elements.share.trigger.button.invite.text': 'Invita',
    'fabric.elements.share.trigger.button.text': 'Condividi',
    'fabric.elements.share.trigger.button.tooltip.text': 'Condividi'
};

});


parcelRegister("9kc19", function(module, exports) {
$parcel$export(module.exports, "default", () => $a57b8fd8410df636$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $3yraH = parcelRequire("3yraH");
var $a57b8fd8410df636$export$2e2bcd8739ae039 = (0, $3yraH.default);

});
parcelRegister("3yraH", function(module, exports) {
$parcel$export(module.exports, "default", () => $02069a9141dc7993$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $02069a9141dc7993$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F",
    'fabric.elements.share.copylink.button.text': "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.copypubliclink.button.text': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.failure.icon.label': "\u30A8\u30E9\u30FC \u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.failure.message': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093",
    'fabric.elements.share.form.comment.label': "\u30E1\u30C3\u30BB\u30FC\u30B8 (\u30AA\u30D7\u30B7\u30E7\u30F3)",
    'fabric.elements.share.form.comment.placeholder': "\u5171\u6709\u5148\u306E\u30E6\u30FC\u30B6\u30FC\u3078\u306E\u30B3\u30E1\u30F3\u30C8\u304C\u3042\u308B\u5834\u5408\u306F\u3053\u3053\u306B\u66F8\u304D\u8FBC\u307F\u307E\u3059\u3002",
    'fabric.elements.share.form.extended.dialog.comment.label': "\u30E1\u30C3\u30BB\u30FC\u30B8",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u53D7\u4FE1\u8005\u306B\u30DA\u30FC\u30B8\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u53D7\u4FE1\u8005\u306B\u8AB2\u984C\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u53D7\u4FE1\u8005\u306B\u4F5C\u696D\u9805\u76EE\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.no-permissions': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u3002",
    'fabric.elements.share.form.public.send': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u9001\u4FE1",
    'fabric.elements.share.form.public.share': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u5171\u6709",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u9808\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u306F\u30A2\u30B9\u30BF\u30EA\u30B9\u30AF\u304C\u4ED8\u3044\u3066\u3044\u307E\u3059",
    'fabric.elements.share.form.retry': "\u518D\u8A66\u884C",
    'fabric.elements.share.form.send': "\u9001\u4FE1",
    'fabric.elements.share.form.share': "\u5171\u6709",
    'fabric.elements.share.form.title': "\u5171\u6709",
    'fabric.elements.share.form.user-picker.add-more': "\u3055\u3089\u306B\u8FFD\u52A0",
    'fabric.elements.share.form.user-picker.label.confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u540D\u524D\u307E\u305F\u306F\u30C1\u30FC\u30E0",
    'fabric.elements.share.form.user-picker.label.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.jira': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u4F7F\u7528\u3057\u3066\u30E6\u30FC\u30B6\u30FC\u3092\u62DB\u5F85\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001\u30B0\u30EB\u30FC\u30D7\u30EF\u30F3",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B: sato@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001sato@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u30E6\u30FC\u30B6\u30FC\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u30C1\u30FC\u30E0\u3001\u30E1\u30FC\u30EB\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u30E6\u30FC\u30B6\u30FC\u307E\u305F\u306F\u30C1\u30FC\u30E0\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.in.integration.button': "{integrationName} \u3067\u5171\u6709",
    'fabric.elements.share.invite.to.confluence': "Confluence \u306B\u62DB\u5F85",
    'fabric.elements.share.invite.to.jira': "Jira \u306B\u62DB\u5F85",
    'fabric.elements.share.main.tab.text.confluence': "\u30DA\u30FC\u30B8\u3092\u5171\u6709",
    'fabric.elements.share.main.tab.text.jira': "\u8AB2\u984C\u3092\u5171\u6709",
    'fabric.elements.share.menu.email.label': "\u30E1\u30FC\u30EB",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u6709",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u30D6\u30ED\u30B0\u6295\u7A3F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}board {\u30DC\u30FC\u30C9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}calendar {\u30AB\u30EC\u30F3\u30C0\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}draft {\u4E0B\u66F8\u304D\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}filter {\u30D5\u30A3\u30EB\u30BF\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}issue {\u8AB2\u984C\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}summary {\u8981\u7D04\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}list {\u30EA\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}timeline {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}form {\u30D5\u30A9\u30FC\u30E0\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}media {\u30E1\u30C7\u30A3\u30A2\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}page {\u30DA\u30FC\u30B8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}project {\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}pullrequest {\u30D7\u30EB \u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}question {\u8CEA\u554F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}report {\u30EC\u30DD\u30FC\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}repository {\u30EA\u30DD\u30B8\u30C8\u30EA\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}request {\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}roadmap {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}site {\u30B5\u30A4\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}space {\u30B9\u30DA\u30FC\u30B9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}other {\u30EA\u30F3\u30AF\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}}",
    'fabric.elements.share.to.integration.button': "{integrationName} \u3068\u5171\u6709",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u6709\u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.trigger.button.invite.text': "\u62DB\u5F85",
    'fabric.elements.share.trigger.button.text': "\u5171\u6709",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u6709"
};

});


parcelRegister("7ZsZJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $380b899fa7b43571$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $h0KK6 = parcelRequire("h0KK6");
var $380b899fa7b43571$export$2e2bcd8739ae039 = (0, $h0KK6.default);

});
parcelRegister("h0KK6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c1167eef5cd2587$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $2c1167eef5cd2587$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\uB9C1\uD06C\uB97C \uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uD568",
    'fabric.elements.share.copylink.button.text': "\uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.copypubliclink.button.text': "\uACF5\uAC1C \uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.failure.icon.label': "\uC624\uB958 \uC544\uC774\uCF58",
    'fabric.elements.share.failure.message': "\uACF5\uC720\uD560 \uC218 \uC5C6\uC74C",
    'fabric.elements.share.form.comment.label': "\uBA54\uC2DC\uC9C0(\uC120\uD0DD \uC0AC\uD56D)",
    'fabric.elements.share.form.comment.placeholder': "\uC0AC\uC6A9\uC790\uAC00 \uC54C\uC544\uC57C \uD560 \uB0B4\uC6A9\uC774 \uC788\uC2B5\uB2C8\uAE4C?",
    'fabric.elements.share.form.extended.dialog.comment.label': "\uBA54\uC2DC\uC9C0",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\uC218\uC2E0\uC790\uAC00 \uD398\uC774\uC9C0 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.info.message.no.invite.jira': "\uC218\uC2E0\uC790\uAC00 \uC774\uC288 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\uC218\uC2E0\uC790\uAC00 \uC5C5\uBB34 \uD56D\uBAA9 \uC774\uB984 \uBC0F \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.no-permissions': "\uACF5\uC720\uD560 \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'fabric.elements.share.form.public.send': "\uACF5\uAC1C \uB9C1\uD06C \uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.public.share': "\uACF5\uAC1C \uB9C1\uD06C \uACF5\uC720",
    'fabric.elements.share.form.required-field.summary': "\uD544\uC218 \uD544\uB4DC\uB294 \uBCC4\uD45C\uB85C \uD45C\uC2DC\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.retry': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'fabric.elements.share.form.send': "\uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.share': "\uACF5\uC720",
    'fabric.elements.share.form.title': "\uACF5\uC720",
    'fabric.elements.share.form.user-picker.add-more': "\uB354 \uC785\uB825\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.label.confluence': "\uC774\uB984, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\uC774\uB984, \uD300 \uB610\uB294 \uADF8\uB8F9",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\uC774\uB984 \uB610\uB294 \uD300",
    'fabric.elements.share.form.user-picker.label.email-only': "\uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.jira': "\uC774\uB984, \uD300 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4. \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC0AC\uC6A9\uC790\uB97C \uCD08\uB300\uD558\uC138\uC694.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\uC608: Maria, Team Orange, group-one",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\uC608: Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\uC608: maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\uC608: Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\uC0AC\uC6A9\uC790, \uADF8\uB8F9, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\uC0AC\uC6A9\uC790, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uADF8\uB8F9\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\uC0AC\uC6A9\uC790 \uB610\uB294 \uD300\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.in.integration.button': "{integrationName}\uC5D0\uC11C \uACF5\uC720",
    'fabric.elements.share.invite.to.confluence': "Confluence\uC5D0 \uCD08\uB300",
    'fabric.elements.share.invite.to.jira': "Jira\uC5D0 \uCD08\uB300",
    'fabric.elements.share.main.tab.text.confluence': "\uD398\uC774\uC9C0 \uACF5\uC720",
    'fabric.elements.share.main.tab.text.jira': "\uC774\uC288 \uACF5\uC720",
    'fabric.elements.share.menu.email.label': "\uC774\uBA54\uC77C",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\uACF5\uC720",
    'fabric.elements.share.success.message': "{object, select,blogpost {\uACF5\uC720\uD55C \uBE14\uB85C\uADF8 \uAC8C\uC2DC\uBB3C}board {\uACF5\uC720\uD55C \uBCF4\uB4DC}calendar {\uACF5\uC720\uD55C \uCE98\uB9B0\uB354}draft {\uACF5\uC720\uD55C \uCD08\uC548}filter {\uACF5\uC720\uD55C \uD544\uD130}issue {\uACF5\uC720\uD55C \uC774\uC288}summary {\uACF5\uC720\uD55C \uC694\uC57D}list {\uACF5\uC720\uD55C \uBAA9\uB85D}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}form {\uACF5\uC720\uD55C \uC591\uC2DD}media {\uACF5\uC720\uD55C \uBBF8\uB514\uC5B4}page {\uACF5\uC720\uD55C \uD398\uC774\uC9C0}project {\uACF5\uC720\uD55C \uD504\uB85C\uC81D\uD2B8}pullrequest {\uACF5\uC720\uD55C \uD480\uB9AC\uD018\uC2A4\uD2B8}question {\uACF5\uC720\uD55C \uC9C8\uBB38}report {\uACF5\uC720\uD55C \uBCF4\uACE0\uC11C}repository {\uACF5\uC720\uD55C \uB9AC\uD3EC\uC9C0\uD1A0\uB9AC}request {\uACF5\uC720\uD55C \uC694\uCCAD}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}site {\uACF5\uC720\uD55C \uC0AC\uC774\uD2B8}space {\uACF5\uC720\uD55C \uC2A4\uD398\uC774\uC2A4}other {\uACF5\uC720\uD55C \uB9C1\uD06C}}",
    'fabric.elements.share.to.integration.button': "{integrationName}\uC5D0 \uACF5\uC720",
    'fabric.elements.share.trigger.button.icon.label': "\uACF5\uC720 \uC544\uC774\uCF58",
    'fabric.elements.share.trigger.button.invite.text': "\uCD08\uB300",
    'fabric.elements.share.trigger.button.text': "\uACF5\uC720",
    'fabric.elements.share.trigger.button.tooltip.text': "\uACF5\uC720"
};

});


parcelRegister("4Ed6p", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4bc689e4ee85aeb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $hga1W = parcelRequire("hga1W");
var $d4bc689e4ee85aeb$export$2e2bcd8739ae039 = (0, $hga1W.default);

});
parcelRegister("hga1W", function(module, exports) {
$parcel$export(module.exports, "default", () => $afe0ea6fed689ced$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $afe0ea6fed689ced$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Kobling er kopiert til utklippstavlen',
    'fabric.elements.share.copylink.button.text': 'Kopier kobling',
    'fabric.elements.share.copypubliclink.button.text': 'Kopier offentlig tilgjengelig kobling',
    'fabric.elements.share.failure.icon.label': 'Feil-ikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Melding (valgfritt)',
    'fabric.elements.share.form.comment.placeholder': "Er det noe mottakerne b\xf8r vite om dette?",
    'fabric.elements.share.form.extended.dialog.comment.label': 'Melding',
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottakerne vil se navnet p\xe5 siden og meldingen",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottakerne vil se navnet p\xe5 saken og meldingen",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Mottakerne vil se navnet p\xe5 arbeidsoppgaven og meldingen",
    'fabric.elements.share.form.no-permissions': "Du har ikke muligheten til \xe5 dele.",
    'fabric.elements.share.form.public.send': 'Send offentlig tilgjengelig kobling',
    'fabric.elements.share.form.public.share': 'Del offentlig kobling',
    'fabric.elements.share.form.required-field.summary': 'Obligatoriske felt er merket med stjerne',
    'fabric.elements.share.form.retry': "Pr\xf8v igjen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Legg til mer',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navn, team, grupper eller e-poster',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-poster',
    'fabric.elements.share.form.user-picker.label.jira': 'Navn, team eller e-poster',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finne noen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finne noen resultater for "{inputValue}". Inviter personer ved \xe5 bruke en e-postadresse.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "f.eks. Maria, oransje team, gruppe \xe9n",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, oransje team',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, oransje team, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "Velg minst \xe9n bruker, gruppe eller e-post eller minst ett team.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Velg minst \xe9n person, gruppe eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Velg minst \xe9n person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Velg minst \xe9n e-postadresse",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sak',
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginnlegg er delt}board {Tavle er delt}calendar {Kalender er delt}draft {Utkast er delt}filter {Filter er delt}issue {Sak er delt}summary {Sammendrag er delt}list {Liste er delt}timeline {Tidslinje er delt}form {Skjema er delt}media {Medier er delt}page {Side er delt}project {Prosjekt er delt}pullrequest {Pull-foresp\xf8rsel er delt}question {Sp\xf8rsm\xe5l er delt}report {Rapport er delt}repository {Repositorium er delt}request {Foresp\xf8rsel er delt}roadmap {Veikart er delt}site {Nettsted er delt}space {Omr\xe5de er delt}other {Kobling er delt}}",
    'fabric.elements.share.to.integration.button': 'Del til {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dele-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});


parcelRegister("8VZ83", function(module, exports) {
$parcel$export(module.exports, "default", () => $206bef931ca26fc1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $gRcKF = parcelRequire("gRcKF");
var $206bef931ca26fc1$export$2e2bcd8739ae039 = (0, $gRcKF.default);

});
parcelRegister("gRcKF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f23e1ef945b347c0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $f23e1ef945b347c0$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link naar klembord gekopieerd',
    'fabric.elements.share.copylink.button.text': "Link kopi\xebren",
    'fabric.elements.share.copypubliclink.button.text': "Openbare link kopi\xebren",
    'fabric.elements.share.failure.icon.label': "Pictogram 'Fout'",
    'fabric.elements.share.failure.message': 'Kan niet delen',
    'fabric.elements.share.form.comment.label': 'Bericht (optioneel)',
    'fabric.elements.share.form.comment.placeholder': 'Is er iets ze moet weten?',
    'fabric.elements.share.form.extended.dialog.comment.label': 'Bericht',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Ontvangers zien de naam van de pagina en je bericht',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Ontvangers zien de naam van de issue en je bericht',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Ontvangers zien de naam van het werkitem en je bericht',
    'fabric.elements.share.form.no-permissions': 'Je kunt niet delen.',
    'fabric.elements.share.form.public.send': 'Openbare link verzenden',
    'fabric.elements.share.form.public.share': 'Openbare link delen',
    'fabric.elements.share.form.required-field.summary': 'Verplichte velden zijn aangeduid met een asterisk',
    'fabric.elements.share.form.retry': 'Opnieuw proberen',
    'fabric.elements.share.form.send': 'Verzenden',
    'fabric.elements.share.form.share': 'Delen',
    'fabric.elements.share.form.title': 'Delen',
    'fabric.elements.share.form.user-picker.add-more': 'Meer invoeren',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, teams, groepen of e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, teams of groepen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen of teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, teams of e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Geen resultaten gevonden voor ''{inputValue}'.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Geen resultaten gevonden voor ''{inputValue}'. Nodig personen uit door hun e-mailadres in te voeren.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'bijv. Maria, team Oranje, groep-een',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'bijv. Maria, team Oranje',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'bijv. Maria, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'bijv. Maria, team Oranje, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecteer minimaal \xe9\xe9n gebruiker, groep, team of e-mailadres.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecteer minimaal \xe9\xe9n persoon, team, groep of e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Selecteer minimaal \xe9\xe9n persoon, team of groep",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Selecteer minimaal \xe9\xe9n persoon of team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecteer minimaal \xe9\xe9n e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecteer minimaal \xe9\xe9n persoon, team of e-mailadres",
    'fabric.elements.share.in.integration.button': 'Delen in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Uitnodigen voor Confluence',
    'fabric.elements.share.invite.to.jira': 'Uitnodigen voor Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Pagina delen',
    'fabric.elements.share.main.tab.text.jira': 'Issue delen',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Delen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost gedeeld}board {Bord gedeeld}calendar {Agenda gedeeld}draft {Concept gedeeld}filter {Filter gedeeld}issue {Issue gedeeld}summary {Samenvatting gedeeld}list {Lijst gedeeld}timeline {Tijdlijn gedeeld}form {Formulier gedeeld}media {Media gedeeld}page {Pagina gedeeld}project {Project gedeeld}pullrequest {Pull-request gedeeld}question {Vraag gedeeld}report {Rapport gedeeld}repository {Repository gedeeld}request {Aanvraag gedeeld}roadmap {Tijdlijn gedeeld}site {Site gedeeld}space {Space gedeeld}other {Link gedeeld}}',
    'fabric.elements.share.to.integration.button': 'Delen met {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram 'Delen'",
    'fabric.elements.share.trigger.button.invite.text': 'Uitnodigen',
    'fabric.elements.share.trigger.button.text': 'Delen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Delen'
};

});


parcelRegister("8CyCd", function(module, exports) {
$parcel$export(module.exports, "default", () => $69d4af760d6d0052$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $a8Rg3 = parcelRequire("a8Rg3");
var $69d4af760d6d0052$export$2e2bcd8739ae039 = (0, $a8Rg3.default);

});
parcelRegister("a8Rg3", function(module, exports) {
$parcel$export(module.exports, "default", () => $af21c8dd2a96111a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $af21c8dd2a96111a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0141\u0105cze skopiowano do schowka",
    'fabric.elements.share.copylink.button.text': "Kopiuj \u0142\u0105cze",
    'fabric.elements.share.copypubliclink.button.text': "Kopiuj \u0142\u0105cze publiczne",
    'fabric.elements.share.failure.icon.label': "Ikona b\u0142\u0119du",
    'fabric.elements.share.failure.message': "Nie mo\u017Cna udost\u0119pni\u0107",
    'fabric.elements.share.form.comment.label': "Wiadomo\u015B\u0107 (opcjonalnie)",
    'fabric.elements.share.form.comment.placeholder': "Czy jest co\u015B, o czym powinni wiedzie\u0107?",
    'fabric.elements.share.form.extended.dialog.comment.label': "Wiadomo\u015B\u0107",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Odbiorcy zobacz\u0105 nazw\u0119 strony i Tw\xf3j komunikat",
    'fabric.elements.share.form.info.message.no.invite.jira': "Odbiorcy zobacz\u0105 nazw\u0119 zg\u0142oszenia i Tw\xf3j komunikat",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Odbiorcy zobacz\u0105 nazw\u0119 zg\u0142oszenia i\xa0Tw\xf3j komunikat.",
    'fabric.elements.share.form.no-permissions': "Nie mo\u017Cesz udost\u0119pnia\u0107.",
    'fabric.elements.share.form.public.send': "Wy\u015Blij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.public.share': "Udost\u0119pnij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.required-field.summary': "Pola wymagane s\u0105 oznaczone gwiazdk\u0105",
    'fabric.elements.share.form.retry': "Spr\xf3buj ponownie",
    'fabric.elements.share.form.send': "Wy\u015Blij",
    'fabric.elements.share.form.share': "Udost\u0119pnij",
    'fabric.elements.share.form.title': "Udost\u0119pnij",
    'fabric.elements.share.form.user-picker.add-more': "Wprowad\u017A wi\u0119cej",
    'fabric.elements.share.form.user-picker.label.confluence': "Nazwy, zespo\u0142y, grupy lub adresy e-mail",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nazwy, zespo\u0142y lub grupy",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Nazwy lub zespo\u0142y",
    'fabric.elements.share.form.user-picker.label.email-only': 'Adresy e-mail',
    'fabric.elements.share.form.user-picker.label.jira': "Nazwy, zespo\u0142y lub adresy e-mail",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D. Zapro\u015B u\u017Cytkownik\xf3w, podaj\u0105c adres e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, grupa 1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'np. maria@firma.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, maria@firma.com",
    'fabric.elements.share.form.user-picker.validation.required': "Wybierz co najmniej jednego u\u017Cytkownika, jedn\u0105 grup\u0119 albo jeden zesp\xf3\u0142 lub adres e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142, jedn\u0105 grup\u0119 lub jeden adres e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jedn\u0105 grup\u0119",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Wybierz co najmniej jedn\u0105 osob\u0119 lub jeden zesp\xf3\u0142",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Wybierz co najmniej jeden adres e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jeden adres e-mail",
    'fabric.elements.share.in.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Zapro\u015B do\xa0Confluence",
    'fabric.elements.share.invite.to.jira': "Zapro\u015B do\xa0systemu Jira",
    'fabric.elements.share.main.tab.text.confluence': "Udost\u0119pnij stron\u0119",
    'fabric.elements.share.main.tab.text.jira': "Udost\u0119pnij zg\u0142oszenie",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Udost\u0119pnij",
    'fabric.elements.share.success.message': "{object, select,blogpost {Udost\u0119pniono wpis na blogu}board {Udost\u0119pniono tablic\u0119}calendar {Udost\u0119pniono kalendarz}draft {Udost\u0119pniono wersj\u0119 robocz\u0105}filter {Udost\u0119pniono filtr}issue {Udost\u0119pniono zg\u0142oszenie}summary {Udost\u0119pniono podsumowanie}list {Udost\u0119pniono list\u0119}timeline {Udost\u0119pniono o\u015B czasu}form {Udost\u0119pniono formularz}media {Udost\u0119pniono multimedia}page {Udost\u0119pniono stron\u0119}project {Udost\u0119pniono projekt}pullrequest {Udost\u0119pniono pull request}question {Udost\u0119pniono pytanie}report {Udost\u0119pniono raport}repository {Udost\u0119pniono repozytorium}request {Udost\u0119pniono wniosek}roadmap {Udost\u0119pniono o\u015B czasu}site {Udost\u0119pniono witryn\u0119}space {Udost\u0119pniono przestrze\u0144}other {Udost\u0119pniono \u0142\u0105cze}}",
    'fabric.elements.share.to.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona udost\u0119pniania",
    'fabric.elements.share.trigger.button.invite.text': "Zapro\u015B",
    'fabric.elements.share.trigger.button.text': "Udost\u0119pnij",
    'fabric.elements.share.trigger.button.tooltip.text': "Udost\u0119pnij"
};

});


parcelRegister("l56YV", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b14f0b95a88dbfa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $g5yQP = parcelRequire("g5yQP");
var $8b14f0b95a88dbfa$export$2e2bcd8739ae039 = (0, $g5yQP.default);

});
parcelRegister("g5yQP", function(module, exports) {
$parcel$export(module.exports, "default", () => $4018951cd6d7909c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $4018951cd6d7909c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link copiado para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': 'Copiar link',
    'fabric.elements.share.copypubliclink.button.text': "Copiar link p\xfablico",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o foi poss\xedvel compartilhar",
    'fabric.elements.share.form.comment.label': 'Mensagem (opcional)',
    'fabric.elements.share.form.comment.placeholder': "H\xe1 algo que eles deveriam saber?",
    'fabric.elements.share.form.extended.dialog.comment.label': 'Mensagem',
    'fabric.elements.share.form.info.message.no.invite.confluence': "Os destinat\xe1rios v\xe3o ver o nome da p\xe1gina e sua mensagem",
    'fabric.elements.share.form.info.message.no.invite.jira': "Os destinat\xe1rios v\xe3o ver o nome do item e sua mensagem",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Os destinat\xe1rios v\xe3o ver o nome do ticket e a mensagem",
    'fabric.elements.share.form.no-permissions': "Voc\xea n\xe3o est\xe1 apto a compartilhar.",
    'fabric.elements.share.form.public.send': "Enviar link p\xfablico",
    'fabric.elements.share.form.public.share': "Compartilhar link p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Os campos obrigat\xf3rios est\xe3o marcados com um asterisco",
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartilhar',
    'fabric.elements.share.form.title': 'Compartilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Insira mais itens',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomes, equipes, grupos ou e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomes, equipes ou grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomes ou equipes',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomes, equipes ou e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o encontramos nenhum resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o encontramos nenhum resultado para "{inputValue}". Convide pessoas usando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'por exemplo, Maria, equipe laranja, grupo um',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'por exemplo, Maria, equipe laranja',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'por exemplo, maria@empresa.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'por exemplo, Maria, equipe laranja, maria@empresa.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecione ao menos um usu\xe1rio, grupo, equipe ou e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Selecione pelo menos uma pessoa, equipe, grupo ou e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecione pelo menos uma pessoa, equipe ou grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecione pelo menos uma pessoa ou equipe',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Selecione pelo menos um e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Selecione pelo menos uma pessoa, equipe ou e-mail',
    'fabric.elements.share.in.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Convidar para o Confluence',
    'fabric.elements.share.invite.to.jira': 'Convidar para o Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartilhar p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartilhar item',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartilhar',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blog compartilhado}board {Quadro compartilhado}calendar {Calend\xe1rio compartilhado}draft {Rascunho compartilhado}filter {Filtro compartilhado}issue {Item compartilhado}summary {Resumo compartilhado}list {Lista compartilhada}timeline {Cronograma compartilhado}form {Formul\xe1rio compartilhado}media {M\xeddia compartilhada}page {P\xe1gina compartilhada}project {Projeto compartilhado}pullrequest {Pull request compartilhada}question {Pergunta compartilhada}report {Relat\xf3rio compartilhado}repository {Reposit\xf3rio compartilhado}request {Solicita\xe7\xe3o compartilhada}roadmap {Cronograma compartilhado}site {Site compartilhado}space {Espa\xe7o compartilhado}other {Link compartilhado}}",
    'fabric.elements.share.to.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "\xcdcone de compartilhamento",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Compartilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartilhar'
};

});


parcelRegister("bPDN4", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1974a8d0cbafe1f$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Portugal)
var $c1974a8d0cbafe1f$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Liga\xe7\xe3o copiada para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': "Copiar liga\xe7\xe3o",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o \xe9 poss\xedvel partilhar",
    'fabric.elements.share.form.comment.placeholder': 'Adicionar uma mensagem',
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.title': 'Partilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Introduza mais',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}". Convite pessoas adicionando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': 'Introduza o nome ou equipa',
    'fabric.elements.share.form.user-picker.placeholder.generic': 'Introduza o nome, grupo, equipa ou e-mail',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'Introduza o nome, a equipa ou o e-mail',
    'fabric.elements.share.form.user-picker.validation.required': 'Selecione, pelo menos, um utilizador, grupo, equipa ou e-mail.',
    'fabric.elements.share.form.user-picker.validation.required.jira': 'Selecione, pelo menos, um utilizador, equipa ou e-mail.',
    'fabric.elements.share.success.message': "{object, select, blogpost {Publica\xe7\xe3o do blogue partilhada} board {Quadro partilhado} calendar {Calend\xe1rio partilhado} draft {Rascunho partilhado} filter {Filtro partilhado} issue {Problema partilhado} media {Multim\xe9dia partilhado} page {P\xe1gina partilhada} project {Projeto partilhado} pullrequest {Pedidos Pull partilhados} question {Pergunta partilhada} report {Relat\xf3rio partilhado} repository {Reposit\xf3rio partilhado} request {Pedido partilhado} roadmap {Roteiro partilhado} site {Site partilhado} space {Espa\xe7o partilhado} other {Liga\xe7\xe3o partilhada}}",
    'fabric.elements.share.trigger.button.icon.label': "Partilhar \xedcone",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Partilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partilhar'
};

});

parcelRegister("hTLsU", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e912581cb1810d9$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Romanian
var $4e912581cb1810d9$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': "Partaja\u021Bi",
    'fabric.elements.share.form.send': "Trimite\u021Bi",
    'fabric.elements.share.form.retry': "Re\xeencerca\u021Bi",
    'fabric.elements.share.form.comment.placeholder': "Ad\u0103uga\u021Bi un mesaj",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Introduce\u021Bi nume, echip\u0103 sau e-mail",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Introduce\u021Bi nume sau echip\u0103",
    'fabric.elements.share.form.user-picker.add-more': "Introduce\u021Bi mai multe",
    'fabric.elements.share.form.user-picker.validation.required': "Selecta\u021Bi cel pu\u021Bin un utilizator, echip\u0103 sau e-mail.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "Pute\u021Bi invita persoane nu mai cu adrese de e-mail {domains}. Contacta\u021Bi administratorul site-ului pentru a invita alte persoane.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nu am g\u0103sit niciun rezultat pentru \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Nu am g\u0103sit niciun rezultat pentru "{inputValue}". Invit\u0103 persoane utiliz\xe2nd o adres\u0103 de e-mail.',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram\u0103 partajare",
    'fabric.elements.share.trigger.button.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.tooltip.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.invite.text': "Invita\u021Bi",
    'fabric.elements.share.copylink.button.icon.label': "Pictogram\u0103 copiere link",
    'fabric.elements.share.copylink.button.text': "Copia\u021Bi link",
    'fabric.elements.share.copied.to.clipboard.icon.label': "Pictogram\u0103 copiere linkuri cu succes",
    'fabric.elements.share.copied.to.clipboard.message': "Link copiat \xeen clipboard",
    'fabric.elements.share.form.capabilities.info.message': "Invita\u021Bia dvs. va fi transmis\u0103 unui administrator pentru aprobare",
    'fabric.elements.share.failure.icon.label': "Pictogram\u0103 eroare",
    'fabric.elements.share.failure.message': 'Nu se poate partaja',
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} panou {Board shared} calendar {Calendar shared} schi\u021B\u0103{Draft shared} filtru {Filter shared} problem\u0103 {Issue shared} media {Media shared} pagin\u0103 {Page shared} proiect {Project shared} pullrequest {Pull Request shared} \xeentrebare {Question shared} raport {Report shared} depozit {Repository shared} solicitare {Request shared} planificare {Roadmap shared} site {Site shared} spa\u021Biu {Space shared} altele {Link Shared}}",
    'fabric.elements.share.admin.notified.message': 'Administratorul dvs. a fost notificat'
};

});

parcelRegister("drDe0", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f4e6d20daa85395$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $5MQBz = parcelRequire("5MQBz");
var $1f4e6d20daa85395$export$2e2bcd8739ae039 = (0, $5MQBz.default);

});
parcelRegister("5MQBz", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c6cc38ccc6f89cd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $5c6cc38ccc6f89cd$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0421\u0441\u044B\u043B\u043A\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
    'fabric.elements.share.copylink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.copypubliclink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.failure.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \u043E\u0448\u0438\u0431\u043A\u0438",
    'fabric.elements.share.failure.message': "\u041D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.comment.label': "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
    'fabric.elements.share.form.comment.placeholder': "\u0427\u0442\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0437\u043D\u0430\u0442\u044C?",
    'fabric.elements.share.form.extended.dialog.comment.label': "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.no-permissions': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0431\u0449\u0438\u0439 \u0434\u043E\u0441\u0442\u0443\u043F.",
    'fabric.elements.share.form.public.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.form.public.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0441\u044B\u043B\u043A\u043E\u0439 \u043E\u0431\u0449\u0435\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430",
    'fabric.elements.share.form.required-field.summary': "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u044B \u0437\u0432\u0435\u0437\u0434\u043E\u0447\u043A\u043E\u0439",
    'fabric.elements.share.form.retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
    'fabric.elements.share.form.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
    'fabric.elements.share.form.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.title': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.user-picker.add-more': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439",
    'fabric.elements.share.form.user-picker.label.confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B, \u0433\u0440\u0443\u043F\u043F\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u0418\u043C\u0435\u043D\u0430 \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
    'fabric.elements.share.form.user-picker.label.email-only': "\u0410\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.jira': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb. \u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, \u0433\u0440\u0443\u043F\u043F\u0430-\u043E\u0434\u0438\u043D",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B 1\xa0\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0433\u0440\u0443\u043F\u043F\u0443, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443, \u0433\u0440\u0443\u043F\u043F\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.in.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.invite.to.confluence': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Confluence",
    'fabric.elements.share.invite.to.jira': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435\u0439",
    'fabric.elements.share.main.tab.text.jira': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0437\u0430\u0434\u0430\u0447\u0435\u0439",
    'fabric.elements.share.menu.email.label': "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0438\u0441\u0438 \u0432 \u0431\u043B\u043E\u0433\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}board {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0434\u043E\u0441\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}calendar {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}draft {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}filter {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u0438\u043B\u044C\u0442\u0440\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}issue {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u0434\u0430\u0447\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}summary {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0442\u0435\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}list {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u043F\u0438\u0441\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}timeline {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}form {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u043E\u0440\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}media {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0435\u0434\u0438\u0430\u0444\u0430\u0439\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}page {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}project {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}pullrequest {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 pull \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}question {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u043E\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}report {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043E\u0442\u0447\u0435\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}repository {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0440\u0438\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}request {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}roadmap {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}site {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0430\u0439\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}space {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}other {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0441\u044B\u043B\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}}",
    'fabric.elements.share.to.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \xab\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F\xbb",
    'fabric.elements.share.trigger.button.invite.text': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C",
    'fabric.elements.share.trigger.button.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.trigger.button.tooltip.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F"
};

});


parcelRegister("5aykq", function(module, exports) {
$parcel$export(module.exports, "default", () => $bed34ce2403621b5$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $bed34ce2403621b5$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Prepojenie sa skop\xedrovalo do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Kop\xedrova\u0165 prepojenie",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Zdie\u013Eanie nie je mo\u017En\xe9",
    'fabric.elements.share.form.comment.placeholder': "Prida\u0165 spr\xe1vu",
    'fabric.elements.share.form.retry': "Opakova\u0165",
    'fabric.elements.share.form.send': "Odosla\u0165",
    'fabric.elements.share.form.title': "Zdie\u013Eanie",
    'fabric.elements.share.form.user-picker.add-more': "Zadajte \u010Fal\u0161ie polo\u017Eky",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C. Pozvite \u013Eud\xed pomocou e-mailovej adresy.",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Zadajte meno alebo t\xedm",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Zadajte meno, skupinu, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Zadajte meno, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, skupinu, t\xedm alebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, t\xedm alebo e-mail.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogov\xfd pr\xedspevok sa zdie\u013Eal} board {N\xe1stenka sa zdie\u013Eala} calendar {Kalend\xe1r sa zdie\u013Eal} draft {Koncept sa zdie\u013Eal} filter {Filter sa zdie\u013Eal} issue {Probl\xe9m sa zdie\u013Eal} media {Medi\xe1lny s\xfabor sa zdie\u013Eal} page {Str\xe1nka sa zdie\u013Eala} project {Projekt sa zdie\u013Eal} pullrequest {Po\u017Eiadavka na stiahnutie a pos\xfadenie sa zdie\u013Eala} question {Ot\xe1zka sa zdie\u013Eala} report {Zostava sa zdie\u013Eala} repository {Repozit\xe1r sa zdie\u013Eal} request {\u017Diados\u0165 sa zdie\u013Eala} roadmap {Pl\xe1n sa zdie\u013Eal} site {Web sa zdie\u013Eal} space {Priestor sa zdie\u013Eal} other {Prepojenie sa zdie\u013Ealo}}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona zdie\u013Eania",
    'fabric.elements.share.trigger.button.invite.text': "Pozva\u0165",
    'fabric.elements.share.trigger.button.text': "Zdie\u013Ea\u0165",
    'fabric.elements.share.trigger.button.tooltip.text': "Zdie\u013Eanie"
};

});

parcelRegister("356A0", function(module, exports) {
$parcel$export(module.exports, "default", () => $af9188ce71fb34f4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $epISd = parcelRequire("epISd");
var $af9188ce71fb34f4$export$2e2bcd8739ae039 = (0, $epISd.default);

});
parcelRegister("epISd", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a387f7999a0f8da$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $0a387f7999a0f8da$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "L\xe4nk kopierad till urklipp",
    'fabric.elements.share.copylink.button.text': "Kopiera l\xe4nk",
    'fabric.elements.share.copypubliclink.button.text': "Kopiera offentlig l\xe4nk",
    'fabric.elements.share.failure.icon.label': 'Fel-ikon',
    'fabric.elements.share.failure.message': 'Det gick inte att dela',
    'fabric.elements.share.form.comment.label': 'Meddelande (valfritt)',
    'fabric.elements.share.form.comment.placeholder': "Finns det n\xe5got de beh\xf6ver veta?",
    'fabric.elements.share.form.extended.dialog.comment.label': 'Meddelande',
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottagare ser namnet p\xe5 sidan och ditt meddelande",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottagare ser namnet p\xe5 \xe4rendet och ditt meddelande",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Mottagare ser namnet p\xe5 arbetsuppgiften och ditt meddelande",
    'fabric.elements.share.form.no-permissions': "Du har inte m\xf6jlighet att dela.",
    'fabric.elements.share.form.public.send': "Skicka offentlig l\xe4nk",
    'fabric.elements.share.form.public.share': "Dela offentlig l\xe4nk",
    'fabric.elements.share.form.required-field.summary': "Obligatoriska f\xe4lt \xe4r markerade med en asterisk",
    'fabric.elements.share.form.retry': "F\xf6rs\xf6k igen",
    'fabric.elements.share.form.send': 'Skicka',
    'fabric.elements.share.form.share': 'Dela',
    'fabric.elements.share.form.title': 'Dela',
    'fabric.elements.share.form.user-picker.add-more': 'Ange fler',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namn, team, grupper eller e-postadresser',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-postadresser',
    'fabric.elements.share.form.user-picker.label.jira': 'Namn, team eller e-postadresser',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}". Bjud in personer genom att anv\xe4nda e-postadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 't.ex. Maria, Team Orange, grupp-ett',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 't.ex. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': "t.ex. maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.placeholder.jira': "t.ex. Maria, Team Orange, maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe4lj minst en anv\xe4ndare, en grupp, ett team eller en e-postadress.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe4lj minst en person, ett team, en grupp eller en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe4lj minst en person, ett team eller en grupp",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe4lj minst en person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe4lj minst en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe4lj minst en person, ett team eller en e-postadress",
    'fabric.elements.share.in.integration.button': 'Dela i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Bjud in till Confluence',
    'fabric.elements.share.invite.to.jira': 'Bjud in till Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Dela sida',
    'fabric.elements.share.main.tab.text.jira': "Dela \xe4rende",
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Dela',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginl\xe4gg har delats}board {Tavla har delats}calendar {Kalender har delats}draft {Utkast har delats}filter {Filter har delats}issue {\xc4rende har delats}summary {Sammanfattning har delats}list {Lista har delats}timeline {Tidslinje har delats}form {Formul\xe4r har delats}media {Media har delats}page {Sida har delats}project {Projekt har delats}pullrequest {Pull request har delats}question {Fr\xe5ga har delats}report {Rapport har delats}repository {Lagringsplats har delats}request {F\xf6rfr\xe5gan har delats}roadmap {Tidslinje har delats}site {Webbplats har delats}space {Utrymme har delats}other {L\xe4nk har delats}}",
    'fabric.elements.share.to.integration.button': 'Dela till {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dela-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Bjud In',
    'fabric.elements.share.trigger.button.text': 'Dela',
    'fabric.elements.share.trigger.button.tooltip.text': 'Dela'
};

});


parcelRegister("h9cNZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6e5dc22145f2c1b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $1hiPu = parcelRequire("1hiPu");
var $c6e5dc22145f2c1b$export$2e2bcd8739ae039 = (0, $1hiPu.default);

});
parcelRegister("1hiPu", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4bfe4de3efab45d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $b4bfe4de3efab45d$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u94FE\u63A5\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F",
    'fabric.elements.share.copylink.button.text': "\u590D\u5236\u94FE\u63A5",
    'fabric.elements.share.copypubliclink.button.text': "\u590D\u5236\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.failure.icon.label': "\u9519\u8BEF\u56FE\u6807",
    'fabric.elements.share.failure.message': "\u65E0\u6CD5\u5171\u4EAB",
    'fabric.elements.share.form.comment.label': "\u6D88\u606F\uFF08\u53EF\u9009\uFF09",
    'fabric.elements.share.form.comment.placeholder': "\u5BF9\u65B9\u662F\u5426\u5E94\u77E5\u9053\u67D0\u4E9B\u4FE1\u606F\uFF1F",
    'fabric.elements.share.form.extended.dialog.comment.label': "\u6D88\u606F",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u9875\u9762\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u4E8B\u52A1\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u5DE5\u4F5C\u9879\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.no-permissions': "\u60A8\u65E0\u6CD5\u5171\u4EAB\u3002",
    'fabric.elements.share.form.public.send': "\u53D1\u9001\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.form.public.share': "\u5206\u4EAB\u516C\u5F00\u94FE\u63A5",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u586B\u5B57\u6BB5\u6807\u6709\u661F\u53F7",
    'fabric.elements.share.form.retry': "\u91CD\u8BD5",
    'fabric.elements.share.form.send': "\u53D1\u9001",
    'fabric.elements.share.form.share': "\u5171\u4EAB",
    'fabric.elements.share.form.title': "\u5171\u4EAB",
    'fabric.elements.share.form.user-picker.add-more': "\u8F93\u5165\u66F4\u591A",
    'fabric.elements.share.form.user-picker.label.confluence': "\u59D3\u540D\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u59D3\u540D\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.label.email-only': "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.jira': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002\u8BF7\u7528\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u9080\u8BF7\u4ED6\u4EBA\u3002",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001\u7B2C\u4E00\u7EC4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B\u5982\uFF0Cmaria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7528\u6237\u3001\u7EC4\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.in.integration.button': "\u5728 {integrationName} \u4E2D\u5206\u4EAB",
    'fabric.elements.share.invite.to.confluence': "\u9080\u8BF7\u52A0\u5165 Confluence",
    'fabric.elements.share.invite.to.jira': "\u9080\u8BF7\u52A0\u5165 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u5206\u4EAB\u9875\u9762",
    'fabric.elements.share.main.tab.text.jira': "\u5171\u4EAB\u4E8B\u52A1",
    'fabric.elements.share.menu.email.label': "\u7535\u5B50\u90AE\u4EF6",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u4EAB",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u535A\u5BA2\u6587\u7AE0\u5DF2\u5171\u4EAB}board {\u9762\u677F\u5DF2\u5171\u4EAB}calendar {\u65E5\u5386\u5DF2\u5171\u4EAB}draft {\u8349\u7A3F\u5DF2\u5171\u4EAB}filter {\u7B5B\u9009\u5668\u5DF2\u5171\u4EAB}issue {\u4E8B\u52A1\u5DF2\u5171\u4EAB}summary {\u6458\u8981\u5DF2\u5171\u4EAB}list {\u5217\u8868\u5DF2\u5171\u4EAB}timeline {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}form {\u8868\u5355\u5DF2\u5171\u4EAB}media {\u5A92\u4F53\u5DF2\u5171\u4EAB}page {\u9875\u9762\u5DF2\u5171\u4EAB}project {\u9879\u76EE\u5DF2\u5171\u4EAB}pullrequest {\u62C9\u53D6\u8BF7\u6C42\u5DF2\u5171\u4EAB}question {\u95EE\u9898\u5DF2\u5171\u4EAB}report {\u62A5\u544A\u5DF2\u5171\u4EAB}repository {\u5B58\u50A8\u5E93\u5DF2\u5171\u4EAB}request {\u8BF7\u6C42\u5DF2\u5171\u4EAB}roadmap {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}site {\u7AD9\u70B9\u5DF2\u5171\u4EAB}space {\u7A7A\u95F4\u5DF2\u5171\u4EAB}other {\u94FE\u63A5\u5DF2\u5171\u4EAB}}",
    'fabric.elements.share.to.integration.button': "\u5206\u4EAB\u5230 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u4EAB\u56FE\u6807",
    'fabric.elements.share.trigger.button.invite.text': "\u9080\u8BF7",
    'fabric.elements.share.trigger.button.text': "\u5171\u4EAB",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u4EAB"
};

});




parcelRegister("fitAa", function(module, exports) {
$parcel$export(module.exports, "ShareDialogWithTrigger", () => $072a19537170476b$export$c7f8df1e37e7f581);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $kDaaB = parcelRequire("kDaaB");
var $6YFG2 = parcelRequire("6YFG2");

var $4J0ad = parcelRequire("4J0ad");

var $dAv2D = parcelRequire("dAv2D");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $67YQP = parcelRequire("67YQP");

var $IW7jS = parcelRequire("IW7jS");

var $k71qx = parcelRequire("k71qx");

var $kb1Mm = parcelRequire("kb1Mm");


var $63G4N = parcelRequire("63G4N");

var $adZfk = parcelRequire("adZfk");

var $fECDH = parcelRequire("fECDH");

var $fVOai = parcelRequire("fVOai");

var $dy3nr = parcelRequire("dy3nr");

var $jrqa3 = parcelRequire("jrqa3");

var $akrRa = parcelRequire("akrRa");

var $bpswd = parcelRequire("bpswd");
function $072a19537170476b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $072a19537170476b$var$shareButtonWrapperStyles = {
    name: "8s6ifx",
    styles: "display:inline-flex;outline:none"
};
const $072a19537170476b$export$4d9147e1bc6c176 = {
    users: [],
    comment: {
        format: 'plain_text',
        value: ''
    }
};
const $072a19537170476b$export$55abe7932f6ca981 = ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dAv2D))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    });
class $072a19537170476b$export$e927f7ec13b9edc0 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static{
        this.defaultProps = {
            isDisabled: false,
            dialogPlacement: 'bottom-end',
            shouldCloseOnEscapePress: true,
            triggerButtonAppearance: 'subtle',
            triggerButtonStyle: 'icon-only',
            triggerButtonTooltipPosition: 'top',
            dialogZIndex: (0, $IW7jS.layers).modal()
        };
    }
    componentDidMount() {
        if (this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAutoOpenDialog !== prevProps.isAutoOpenDialog && this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentWillUnmount() {
        if (this.props.isAutoOpenDialog && this.props.onDialogClose) this.props.onDialogClose();
    }
    async generateShareError(err) {
        const errorBody = err.body ? await err.body : {};
        // We'll only try and deal with the first error, sorry
        const firstErrorFromBody = errorBody.messagesDetails?.[0];
        return {
            message: firstErrorFromBody?.message || err.message,
            errorCode: firstErrorFromBody?.errorCode,
            helpUrl: firstErrorFromBody?.helpUrl,
            retryable: firstErrorFromBody?.errorCode === undefined
        };
    }
    render() {
        const { isDialogOpen: isDialogOpen, isSharing: isSharing, shareError: shareError, defaultValue: defaultValue, showIntegrationForm: showIntegrationForm, selectedIntegration: selectedIntegration, isMenuItemSelected: isMenuItemSelected } = this.state;
        const { copyLink: copyLink, dialogPlacement: dialogPlacement, config: config, isFetchingConfig: isFetchingConfig, loadUserOptions: loadUserOptions, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, bottomMessage: bottomMessage, submitButtonLabel: submitButtonLabel, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, cloudId: cloudId, orgId: orgId, shareFieldsFooter: shareFieldsFooter, dialogZIndex: dialogZIndex, isPublicLink: isPublicLink, tabIndex: tabIndex, copyTooltipText: copyTooltipText, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const style = typeof tabIndex !== 'undefined' && tabIndex >= 0 ? {
            outline: 'none'
        } : undefined;
        const footer = (0, $bpswd.resolveShareFooter)(integrationMode, this.state.tabIndex, customFooter);
        // for performance purposes, we may want to have a loadable content i.e. ShareForm
        return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $072a19537170476b$var$shareButtonWrapperStyles,
            tabIndex: tabIndex,
            onKeyDown: this.handleKeyDown,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kJsb4.default), {
            content: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fVOai.default), {
                    Content: selectedIntegration && selectedIntegration.Content,
                    selectedIntegration: selectedIntegration,
                    copyLink: copyLink,
                    showIntegrationForm: showIntegrationForm,
                    bottomMessage: bottomMessage,
                    customHeader: customHeader,
                    customFooter: footer,
                    loadOptions: loadUserOptions,
                    isSharing: isSharing,
                    shareFormTitle: shareFormTitle,
                    showTitle: integrationMode !== 'tabs' || !shareIntegrations || !shareIntegrations.length,
                    shareFormHelperMessage: shareFormHelperMessage,
                    shareError: shareError,
                    defaultValue: defaultValue,
                    config: config,
                    isFetchingConfig: isFetchingConfig,
                    setIsLoading: this.setIsLoading,
                    submitButtonLabel: submitButtonLabel,
                    product: product,
                    productAttributes: productAttributes,
                    enableSmartUserPicker: enableSmartUserPicker,
                    loggedInAccountId: loggedInAccountId,
                    cloudId: cloudId,
                    orgId: orgId,
                    onUserSelectionChange: this.handleOnUserSelectionChange,
                    shareFieldsFooter: shareFieldsFooter,
                    isPublicLink: isPublicLink,
                    copyTooltipText: copyTooltipText,
                    integrationMode: integrationMode,
                    shareIntegrations: shareIntegrations,
                    additionalTabs: additionalTabs,
                    builtInTabContentWidth: builtInTabContentWidth,
                    isMenuItemSelected: isMenuItemSelected,
                    isSubmitShareDisabled: isSubmitShareDisabled,
                    // actions
                    onLinkCopy: this.handleCopyLink,
                    onSubmit: this.handleShareSubmit,
                    onDismiss: this.handleFormDismiss,
                    onDialogClose: this.handleCloseDialog,
                    onTabChange: this.onTabChange,
                    onMenuItemChange: this.onMenuItemChange,
                    //ref
                    selectPortalRef: this.selectPortalRef,
                    isBrowseUsersDisabled: isBrowseUsersDisabled,
                    userPickerOptions: userPickerOptions,
                    additionalUserFields: additionalUserFields,
                    isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                    CustomSubmitButton: CustomSubmitButton
                })),
            isOpen: isDialogOpen,
            onClose: this.handleCloseDialog,
            placement: dialogPlacement,
            trigger: this.renderShareTriggerButton,
            zIndex: dialogZIndex,
            label: this.props.intl.formatMessage((0, $kb1Mm.messages).sharePopupLabel),
            role: "dialog",
            // TODO: remove after https://hello.atlassian.net/wiki/x/SoEGzQ experiment is finished
            offset: this.calculatePopupOffset({
                isMenuItemSelected: isMenuItemSelected,
                dialogPlacement: dialogPlacement
            }),
            shouldRenderToParent: (0, $eGOwo.fg)('enable-appropriate-reading-order-in-share-dialog')
        }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $67YQP.default), {
            zIndex: (0, $bpswd.generateSelectZIndex)(dialogZIndex)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            ref: this.selectPortalRef
        }))));
    }
    constructor(...args){
        super(...args), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), /**
   * Because the PopUp component has a higher zIndex it causes
   * the select to be rendered within it, and add scrollbars.
   * We will render the select options the PopUp outside,
   */ this.selectPortalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.start = 0, this.state = {
            isDialogOpen: false,
            isSharing: false,
            ignoreIntermediateState: false,
            defaultValue: $072a19537170476b$export$4d9147e1bc6c176,
            isUsingSplitButton: false,
            showIntegrationForm: false,
            selectedIntegration: null,
            tabIndex: 0,
            isMenuItemSelected: false,
            isLoading: false
        }, this.closeAndResetDialog = ()=>{
            this.setState({
                defaultValue: $072a19537170476b$export$4d9147e1bc6c176,
                ignoreIntermediateState: true,
                shareError: undefined,
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                isMenuItemSelected: false
            });
            const { onUserSelectionChange: onUserSelectionChange, onDialogClose: onDialogClose } = this.props;
            if (onUserSelectionChange) onUserSelectionChange($072a19537170476b$export$4d9147e1bc6c176.users);
            if (onDialogClose) onDialogClose();
        }, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, analyticsDecorator: analyticsDecorator } = this.props;
            if (analyticsDecorator) payload = analyticsDecorator(payload);
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $63G4N.CHANNEL_ID));
        }, this.onTabChange = (index)=>{
            let subjectId = 'shareTab';
            const { shareContentType: shareContentType } = this.props;
            if (index === 1) subjectId = 'shareToSlackTab';
            this.createAndFireEvent((0, $63G4N.shareTabClicked)(subjectId, shareContentType));
            this.setState({
                tabIndex: index
            });
        }, this.onMenuItemChange = (menuType)=>{
            let subjectId = menuType === 'Slack' ? 'shareToSlackMenuItem' : 'shareMenuItem';
            const { shareContentType: shareContentType } = this.props;
            this.createAndFireEvent((0, $63G4N.shareMenuItemClicked)(subjectId, shareContentType));
            this.setState({
                isMenuItemSelected: true
            });
        }, this.getFlags = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            // The reason for providing message property is that in jira,
            // the Flag system takes only Message Descriptor as payload
            // and formatMessage is called for every flag
            // if the translation data is not provided, a translated default message
            // will be displayed
            return [
                {
                    appearance: 'success',
                    title: {
                        ...(0, $kb1Mm.messages).shareSuccessMessage,
                        defaultMessage: formatMessage((0, $kb1Mm.messages).shareSuccessMessage, {
                            object: this.props.shareContentType.toLowerCase()
                        })
                    },
                    type: (0, $a9b8bb5645790abf$export$9540ac9c843b8743)
                }
            ];
        }, this.setIsLoading = (isLoading)=>{
            this.setState({
                isLoading: isLoading
            });
        }, this.focus = ()=>{
            if (this.containerRef.current) this.containerRef.current.focus();
        }, this.handleKeyDown = (event)=>{
            const { isLoading: isLoading, isDialogOpen: isDialogOpen } = this.state;
            const { shouldCloseOnEscapePress: shouldCloseOnEscapePress } = this.props;
            if (isLoading) {
                event.stopPropagation();
                this.focus();
            }
            if (isDialogOpen) switch(event.key){
                case 'Esc':
                case 'Escape':
                    // The @atlaskit/popup will capture the event and auto-close, we
                    // need to prevent that if the dialog is set to not close on `ESC`
                    if (!shouldCloseOnEscapePress) {
                        event.preventDefault();
                        event.stopPropagation();
                        // put the focus back onto the share dialog so that
                        // the user can press the escape key again to close the dialog
                        this.focus();
                        return;
                    }
                    // The dialog will auto-close in @atlaskit/popup, we just need to fire
                    // the right events.
                    if (shouldCloseOnEscapePress) {
                        // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
                        // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
                        // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
                        (0, $fECDH.renderShareDialogExp).abort();
                        this.createAndFireEvent((0, $63G4N.cancelShare)(this.start));
                        this.closeAndResetDialog();
                    }
            }
        }, this.handleDialogOpen = ()=>{
            this.setState((state)=>({
                    isDialogOpen: !state.isDialogOpen,
                    ignoreIntermediateState: false,
                    showIntegrationForm: false,
                    selectedIntegration: null
                }), ()=>{
                const { onDialogOpen: onDialogOpen, isPublicLink: isPublicLink } = this.props;
                const { isDialogOpen: isDialogOpen } = this.state;
                if (isDialogOpen) {
                    this.start = Date.now();
                    this.createAndFireEvent((0, $63G4N.screenEvent)({
                        isPublicLink: isPublicLink
                    }));
                    if (onDialogOpen) onDialogOpen();
                    this.focus();
                } else this.handleCloseDialog();
            });
        }, this.onTriggerClick = ()=>{
            const { onTriggerButtonClick: onTriggerButtonClick } = this.props;
            this.createAndFireEvent((0, $63G4N.shareTriggerButtonClicked)());
            this.handleDialogOpen();
            if (onTriggerButtonClick) onTriggerButtonClick();
        }, this.handleCloseDialog = ()=>{
            if (this.props.onDialogClose) this.props.onDialogClose();
            // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
            // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
            // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
            (0, $fECDH.renderShareDialogExp).abort();
            this.setState({
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                tabIndex: 0,
                isMenuItemSelected: false
            });
        }, this.handleShareSubmit = (data)=>{
            const { onShareSubmit: onShareSubmit, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, formShareOrigin: formShareOrigin, showFlags: showFlags, isPublicLink: isPublicLink, createAnalyticsEvent: createAnalyticsEvent, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, productAttributes: productAttributes, loggedInAccountId: loggedInAccountId } = this.props;
            if (!onShareSubmit) return;
            (0, $fECDH.shareSubmitExp).start();
            this.setState({
                isSharing: true
            });
            this.createAndFireEvent((0, $63G4N.formShareSubmitted)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            if ((0, $eGOwo.fg)('page_shared_event_from_share_dialogue')) this.createAndFireEvent((0, $63G4N.jiraPageSharedEvent)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                productAttributes: productAttributes,
                loggedInAccountId: loggedInAccountId,
                source: (0, $63G4N.ANALYTICS_SOURCE),
                actionSubjectId: 'submitShare'
            }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'shared',
                    actionSubject: 'page',
                    source: (0, $63G4N.ANALYTICS_SOURCE),
                    attributes: {
                        contentType: shareContentType,
                        subContentType: shareContentSubType,
                        shareData: data
                    }
                }
            }).fire();
            onShareSubmit(data).then(()=>{
                this.closeAndResetDialog();
                this.setState({
                    isSharing: false
                });
                if (isExtendedShareDialogEnabled && data.users.length === 0) (0, $fECDH.shareSubmitExp).abort();
                else {
                    showFlags(this.getFlags());
                    (0, $fECDH.shareSubmitExp).success();
                }
            }).catch(async (err)=>{
                const shareError = await this.generateShareError(err).catch((errorGenFailed)=>({
                        message: err.message || errorGenFailed.message || 'Unknown error',
                        retryable: true
                    }));
                this.setState({
                    isSharing: false,
                    shareError: shareError
                });
                (0, $adZfk.isValidFailedExperience)((0, $fECDH.shareSubmitExp), err);
            });
        }, this.handleFormDismiss = (data)=>{
            this.setState(({ ignoreIntermediateState: ignoreIntermediateState })=>ignoreIntermediateState ? null : {
                    defaultValue: data
                });
        }, this.calculatePopupOffset = ({ isMenuItemSelected: isMenuItemSelected, dialogPlacement: dialogPlacement })=>{
            if (isMenuItemSelected && dialogPlacement === 'bottom-end') return [
                -0.1,
                8
            ];
            return [
                0,
                8
            ];
        }, this.handleCopyLink = ()=>{
            const { copyLinkOrigin: copyLinkOrigin, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, isPublicLink: isPublicLink, shareAri: shareAri, productAttributes: productAttributes, loggedInAccountId: loggedInAccountId } = this.props;
            this.createAndFireEvent((0, $63G4N.copyLinkButtonClicked)({
                start: this.start,
                shareContentType: shareContentType,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                ari: shareAri,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            if ((0, $eGOwo.fg)('page_shared_event_from_share_dialogue')) this.createAndFireEvent((0, $63G4N.jiraPageSharedEvent)({
                start: this.start,
                data: {
                    users: [],
                    comment: {
                        format: 'plain_text',
                        value: ''
                    }
                },
                shareContentType: // Empty data for copy link
                shareContentType,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                productAttributes: productAttributes,
                loggedInAccountId: loggedInAccountId,
                source: (0, $63G4N.ANALYTICS_SOURCE),
                actionSubjectId: 'copyLink'
            }));
        }, this.handleIntegrationClick = (integration)=>{
            this.setState({
                isUsingSplitButton: false,
                isDialogOpen: true,
                showIntegrationForm: true,
                selectedIntegration: integration
            });
        }, this.renderShareTriggerButton = (triggerProps)=>{
            const { isDialogOpen: isDialogOpen, isUsingSplitButton: isUsingSplitButton } = this.state;
            const { intl: { formatMessage: formatMessage }, isDisabled: isDisabled, renderCustomTriggerButton: renderCustomTriggerButton, customTriggerButtonIcon: customTriggerButtonIcon, triggerButtonIcon: triggerButtonIcon, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, triggerButtonAppearance: triggerButtonAppearance, triggerButtonStyle: triggerButtonStyle, integrationMode: integrationMode, shareIntegrations: shareIntegrations, dialogZIndex: dialogZIndex, dialogPlacement: dialogPlacement } = this.props;
            let button;
            const ShareButtonIcon = triggerButtonIcon || $072a19537170476b$export$55abe7932f6ca981;
            // Render a custom or standard button.
            if (renderCustomTriggerButton) {
                const { shareError: shareError } = this.state;
                button = renderCustomTriggerButton({
                    error: shareError,
                    isDisabled: isDisabled,
                    isSelected: isDialogOpen,
                    onClick: this.onTriggerClick,
                    iconBefore: customTriggerButtonIcon
                }, triggerProps);
            } else button = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $dy3nr.default), {
                appearance: triggerButtonAppearance,
                text: triggerButtonStyle !== 'icon-only' ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), (0, $kb1Mm.messages).shareTriggerButtonText) : null,
                "aria-label": formatMessage((0, $kb1Mm.messages).shareTriggerButtonText),
                onClick: this.onTriggerClick,
                iconBefore: triggerButtonStyle !== 'text-only' ? /*#__PURE__*/ (0, $1NIU8.jsx)(ShareButtonIcon, {
                    label: ""
                }) : undefined,
                isSelected: isDialogOpen,
                isDisabled: isDisabled,
                ref: triggerProps.ref,
                // When we autoFocus the dialog, we want to autofocus the trigger as well, that way when the dialog is closed, the trigger is focused
                autoFocus: this.props.isAutoOpenDialog
            });
            // If the button only shows the icon, wrap it in a tooltip containing the button text.
            if (triggerButtonStyle === 'icon-only') button = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
                content: !isUsingSplitButton ? triggerButtonTooltipText || formatMessage((0, $kb1Mm.messages).shareTriggerButtonTooltipText) : null,
                position: triggerButtonTooltipPosition,
                hideTooltipOnClick: true
            }, button);
            // If there are any integrations, wrap the share button in a split button with integrations.
            if (integrationMode === 'split' && shareIntegrations?.length) button = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $akrRa.default), {
                shareButton: button,
                handleOpenSplitButton: this.handleOpenSplitButton,
                handleCloseSplitButton: this.handleCloseSplitButton,
                isUsingSplitButton: isUsingSplitButton,
                triggerButtonAppearance: triggerButtonAppearance,
                dialogZIndex: dialogZIndex,
                dialogPlacement: dialogPlacement,
                shareIntegrations: shareIntegrations,
                onIntegrationClick: this.handleIntegrationClick,
                createAndFireEvent: this.createAndFireEvent
            });
            return button;
        }, this.handleOpenSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: true
            }, ()=>this.handleCloseDialog());
            this.createAndFireEvent((0, $63G4N.shareSplitButtonEvent)());
        }, this.handleCloseSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: false
            });
        }, this.handleOnUserSelectionChange = (value)=>{
            const { onUserSelectionChange: onUserSelectionChange } = this.props;
            this.setState({
                shareError: undefined
            });
            onUserSelectionChange?.(value);
        };
    }
}
const $072a19537170476b$export$bc20a02e9bc30e54 = (props)=>(0, $eGOwo.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jrqa3.ShareDialogWithTriggerInternal), props) : /*#__PURE__*/ (0, $1NIU8.jsx)($072a19537170476b$export$e927f7ec13b9edc0, props);
const $072a19537170476b$export$c7f8df1e37e7f581 = (0, $4J0ad.default)()((0, $6YFG2.default)($072a19537170476b$export$bc20a02e9bc30e54));

});
parcelRegister("dAv2D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9e18c48fa51720497915ca82e3c073ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e46b7569d180ef1$var$_react = $9e46b7569d180ef1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9e46b7569d180ef1$var$_share = $9e46b7569d180ef1$var$_interopRequireDefault((parcelRequire("iePme")));

var $9e46b7569d180ef1$var$_share2 = $9e46b7569d180ef1$var$_interopRequireDefault((parcelRequire("4jCd5")));
function $9e46b7569d180ef1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e46b7569d180ef1$var$ShareIcon = (props)=>/*#__PURE__*/ $9e46b7569d180ef1$var$_react.default.createElement($9e46b7569d180ef1$var$_share.default, Object.assign({
        name: "ShareIcon",
        LEGACY_fallbackIcon: $9e46b7569d180ef1$var$_share2.default
    }, props));
$9e46b7569d180ef1$var$ShareIcon.displayName = 'ShareIconMigration';
var $9e46b7569d180ef1$var$_default = module.exports.default = $9e46b7569d180ef1$var$ShareIcon;

});
parcelRegister("4jCd5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32469378f409d14d$var$_react = $32469378f409d14d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $32469378f409d14d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $32469378f409d14d$var$ShareIcon = (props)=>/*#__PURE__*/ $32469378f409d14d$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props));
$32469378f409d14d$var$ShareIcon.displayName = 'ShareIcon';
var $32469378f409d14d$var$_default = module.exports.default = $32469378f409d14d$var$ShareIcon;

});


const $a9b8bb5645790abf$export$9540ac9c843b8743 = 'object-shared';
const $a9b8bb5645790abf$export$57af6ad1a12df839 = 'admin-notified';

parcelRegister("fVOai", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9ae1a72bfdd122a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $eGOwo = parcelRequire("eGOwo");

var $7ep4S = parcelRequire("7ep4S");

var $aPNSS = parcelRequire("aPNSS");

var $9wjmZ = parcelRequire("9wjmZ");
function $e9ae1a72bfdd122a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e9ae1a72bfdd122a$var$spinnerWrapperStyles = {
    name: "1frfa00",
    styles: "width:100%;height:100%;display:flex;justify-content:center;align-content:center"
};

const $e9ae1a72bfdd122a$var$LazyShareFormLazy = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("amzFr")));
const $e9ae1a72bfdd122a$var$LoadingDialog = ({ shareFormTitle: shareFormTitle, showTitle: showTitle, setIsLoading: setIsLoading, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        setIsLoading(true);
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aPNSS.default), {
        shareFormTitle: shareFormTitle,
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected,
        // if `showTitle` is passed, we use it. Otherwise, we will show title for loading dialog.
        shouldShowTitle: typeof showTitle === 'boolean' ? showTitle : true,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $e9ae1a72bfdd122a$var$spinnerWrapperStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7ep4S.default), null)));
};
var $e9ae1a72bfdd122a$export$2e2bcd8739ae039 = (props)=>(0, $eGOwo.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9wjmZ.default), props) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, $1NIU8.jsx)($e9ae1a72bfdd122a$var$LoadingDialog, {
            shareFormTitle: props.shareFormTitle,
            showTitle: props.showTitle,
            setIsLoading: props.setIsLoading,
            integrationMode: props.integrationMode,
            isMenuItemSelected: props.isMenuItemSelected,
            isExtendedShareDialogEnabled: props.isExtendedShareDialogEnabled
        })
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($e9ae1a72bfdd122a$var$LazyShareFormLazy, props));

});
parcelRegister("aPNSS", function(module, exports) {
$parcel$export(module.exports, "default", () => $655770f1d04566cf$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $eGOwo = parcelRequire("eGOwo");

var $kb1Mm = parcelRequire("kb1Mm");

var $7y7zS = parcelRequire("7y7zS");

var $c3l3q = parcelRequire("c3l3q");

var $bI9w9 = parcelRequire("bI9w9");
const $655770f1d04566cf$var$ShareFormWrapper = ({ shareFormTitle: shareFormTitle, shouldShowTitle: shouldShowTitle, children: children = null, header: header = null, footer: footer = null, integrationMode: integrationMode = 'off', isMenuItemSelected: isMenuItemSelected = false, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const ContentWrapper = (0, $eGOwo.fg)('share-compiled-migration') ? (0, $c3l3q.InlineDialogContentWrapper) : (0, $bI9w9.InlineDialogContentWrapper);
    const FormWrapper = (0, $eGOwo.fg)('share-compiled-migration') ? (0, $c3l3q.InlineDialogFormWrapper) : (0, $bI9w9.InlineDialogFormWrapper);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)(ContentWrapper, {
        label: formatMessage((0, $kb1Mm.messages).formTitle),
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        children: [
            header,
            /*#__PURE__*/ (0, $gt9Am.jsxs)(FormWrapper, {
                integrationMode: integrationMode,
                isMenuItemSelected: isMenuItemSelected,
                isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                children: [
                    shouldShowTitle && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7y7zS.ShareHeader), {
                        title: shareFormTitle
                    }),
                    children
                ]
            }),
            footer
        ]
    });
};
var $655770f1d04566cf$export$2e2bcd8739ae039 = $655770f1d04566cf$var$ShareFormWrapper;

});
parcelRegister("7y7zS", function(module, exports) {
$parcel$export(module.exports, "ShareHeader", () => $93f489a0229be0b5$export$77192fbb468e5af8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $806LH = parcelRequire("806LH");

var $eGOwo = parcelRequire("eGOwo");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $kb1Mm = parcelRequire("kb1Mm");
const $93f489a0229be0b5$var$headerWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: 'space.400',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'space.400'
});
const $93f489a0229be0b5$var$headerWrapperExtraSpaceStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.150',
    color: 'color.text'
});
const $93f489a0229be0b5$export$77192fbb468e5af8 = ({ isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, title: title })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: [
            $93f489a0229be0b5$var$headerWrapperStyles,
            isExtendedShareDialogEnabled && $93f489a0229be0b5$var$headerWrapperExtraSpaceStyles
        ],
        children: (0, $eGOwo.fg)('share-header-accessibility') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
            size: "small",
            as: "h2",
            children: title || /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $kb1Mm.messages).formTitle
            })
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
            size: "small",
            children: title || /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $kb1Mm.messages).formTitle
            })
        })
    });
};

});

parcelRegister("c3l3q", function(module, exports) {
$parcel$export(module.exports, "InlineDialogFormWrapper", () => $c661d2db7b91580d$export$54db87debcabf37b);
$parcel$export(module.exports, "InlineDialogContentWrapper", () => $c661d2db7b91580d$export$a05835e82fd98f96);
/* compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $c661d2db7b91580d$var$styles = {
    menuNotSelectedAndMenuIntegration: "_1bsbpk3t",
    tabsIntegration: "_1bsb1wug",
    default: "_1bsb1j89",
    extendedDefault: "_1bsb1op3",
    inlineDialogContentWrapper: "_ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb",
    extendedInlineDialogContentWrapper: "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k"
};
const $c661d2db7b91580d$export$54db87debcabf37b = ({ children: children, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    if (!isMenuItemSelected && integrationMode === 'menu') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($c661d2db7b91580d$var$styles.menuNotSelectedAndMenuIntegration),
        children: children
    });
    if (integrationMode === 'tabs') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($c661d2db7b91580d$var$styles.tabsIntegration),
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)(isExtendedShareDialogEnabled ? $c661d2db7b91580d$var$styles.extendedDefault : $c661d2db7b91580d$var$styles.default),
        children: children
    });
};
const $c661d2db7b91580d$export$a05835e82fd98f96 = ({ children: children, label: label, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        "aria-label": label,
        xcss: isExtendedShareDialogEnabled ? $c661d2db7b91580d$var$styles.extendedInlineDialogContentWrapper : $c661d2db7b91580d$var$styles.inlineDialogContentWrapper,
        children: children
    });

});

parcelRegister("bI9w9", function(module, exports) {
$parcel$export(module.exports, "InlineDialogFormWrapper", () => $bdf1adf64a60d18e$export$54db87debcabf37b);
$parcel$export(module.exports, "InlineDialogContentWrapper", () => $bdf1adf64a60d18e$export$a05835e82fd98f96);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $7ypih = parcelRequire("7ypih");
function $bdf1adf64a60d18e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Set fixed width considering full form width and full menu width in order
 * to prevent dialog form from bouncing when isLoading prop is set to true.
 * Since loading container has 100% width, it adjusts accordingly.
 */ const $bdf1adf64a60d18e$var$calculateFormWrapperWidth = ({ integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    const formWidth = `${isExtendedShareDialogEnabled ? 452 : 352}px`;
    if (!isMenuItemSelected && integrationMode === 'menu') return 0, $7ypih.menuWrapperWidth;
    if (integrationMode === 'tabs') return 'auto';
    return formWidth;
};
const $bdf1adf64a60d18e$export$54db87debcabf37b = ({ children: children, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    const styles = {
        width: $bdf1adf64a60d18e$var$calculateFormWrapperWidth({
            integrationMode: integrationMode,
            isMenuItemSelected: isMenuItemSelected,
            isExtendedShareDialogEnabled: isExtendedShareDialogEnabled
        })
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: styles
    }, children);
};
const $bdf1adf64a60d18e$var$inlineDialogContentWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`
});
const $bdf1adf64a60d18e$var$extendedInlineDialogContentWrapperStyles = {
    name: "1usqnq9",
    styles: "padding:var(--ds-space-250, 20px)"
};
const $bdf1adf64a60d18e$export$a05835e82fd98f96 = ({ children: children, label: label, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: isExtendedShareDialogEnabled ? $bdf1adf64a60d18e$var$extendedInlineDialogContentWrapperStyles : $bdf1adf64a60d18e$var$inlineDialogContentWrapperStyles,
        "aria-label": label
    }, children);
};

});
parcelRegister("7ypih", function(module, exports) {
$parcel$export(module.exports, "ShareMenuItem", () => $aa6a6b2d03ee7ee7$export$144cc6e5e0841ff9);
$parcel$export(module.exports, "menuWrapperWidth", () => $aa6a6b2d03ee7ee7$export$1cd8104f92c0e299);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $7saMl = parcelRequire("7saMl");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $aa6a6b2d03ee7ee7$var$iconContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'size.200',
    width: 'size.200',
    borderRadius: 'radius.small'
});
const $aa6a6b2d03ee7ee7$export$144cc6e5e0841ff9 = ({ iconName: iconName, labelId: labelId, onClickHandler: onClickHandler })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
        iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($aa6a6b2d03ee7ee7$export$8f314e512d92575f, {
            icon: iconName
        }),
        onClick: onClickHandler,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...labelId
        })
    });
const $aa6a6b2d03ee7ee7$export$8f314e512d92575f = ({ icon: icon })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $aa6a6b2d03ee7ee7$var$iconContainerStyles,
        children: icon
    });
const $aa6a6b2d03ee7ee7$export$1cd8104f92c0e299 = '102px';

});



parcelRegister("9wjmZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d8854345e5b8a2e$export$2e2bcd8739ae039);
/* lazyNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $aPNSS = parcelRequire("aPNSS");
const $1d8854345e5b8a2e$var$styles = {
    spinnerWrapperStyles: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _ae4v1h6o"
};

const $1d8854345e5b8a2e$var$LazyShareFormLazy = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("5FfM4")));
const $1d8854345e5b8a2e$var$LoadingDialog = ({ shareFormTitle: shareFormTitle, showTitle: showTitle, setIsLoading: setIsLoading, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        setIsLoading(true);
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aPNSS.default), {
        shareFormTitle: shareFormTitle,
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected,
        // if `showTitle` is passed, we use it. Otherwise, we will show title for loading dialog.
        shouldShowTitle: typeof showTitle === 'boolean' ? showTitle : true,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: (0, $6qaBj.cx)($1d8854345e5b8a2e$var$styles.spinnerWrapperStyles),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
        })
    });
};
var $1d8854345e5b8a2e$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)($1d8854345e5b8a2e$var$LoadingDialog, {
            shareFormTitle: props.shareFormTitle,
            showTitle: props.showTitle,
            setIsLoading: props.setIsLoading,
            integrationMode: props.integrationMode,
            isMenuItemSelected: props.isMenuItemSelected,
            isExtendedShareDialogEnabled: props.isExtendedShareDialogEnabled
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($1d8854345e5b8a2e$var$LazyShareFormLazy, {
            ...props
        })
    });

});
parcelRegister("5FfM4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("77twN")
]).then(()=>parcelRequire('a01lZ'));

});


parcelRegister("amzFr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("8xxwK")
]).then(()=>parcelRequire('fnkTD'));

});


parcelRegister("dy3nr", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d899f7896591f6f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
const $0d899f7896591f6f$export$e980dfbc2840e8bc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(// Discard aria-haspopup
function ShareButton({ text: text, 'aria-haspopup': _ariaHasPopup, ...props }, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        id: "share-trigger-btn",
        ref: ref,
        "aria-haspopup": "dialog",
        ...props,
        children: text
    });
});
$0d899f7896591f6f$export$e980dfbc2840e8bc.displayName = 'ShareButton';
var $0d899f7896591f6f$export$2e2bcd8739ae039 = $0d899f7896591f6f$export$e980dfbc2840e8bc;

});

parcelRegister("jrqa3", function(module, exports) {
$parcel$export(module.exports, "ShareDialogWithTriggerInternal", () => $5ea0b57a882b7729$export$bc20a02e9bc30e54);
/* ShareDialogWithTriggerNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $6YFG2 = parcelRequire("6YFG2");

var $4J0ad = parcelRequire("4J0ad");

var $6qaBj = parcelRequire("6qaBj");

var $dAv2D = parcelRequire("dAv2D");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $67YQP = parcelRequire("67YQP");

var $8IeH1 = parcelRequire("8IeH1");

var $IW7jS = parcelRequire("IW7jS");

var $k71qx = parcelRequire("k71qx");

var $kb1Mm = parcelRequire("kb1Mm");


var $63G4N = parcelRequire("63G4N");

var $adZfk = parcelRequire("adZfk");

var $fECDH = parcelRequire("fECDH");

var $fVOai = parcelRequire("fVOai");

var $dy3nr = parcelRequire("dy3nr");

var $akrRa = parcelRequire("akrRa");

var $bpswd = parcelRequire("bpswd");
const $5ea0b57a882b7729$var$styles = {
    shareButtonWrapperStyles: "_12ji1r31 _1qu2glyw _12y31o36 _1e0c116y",
    outlineNone: "_12ji1r31 _1qu2glyw _12y31o36"
};
const $5ea0b57a882b7729$export$4d9147e1bc6c176 = {
    users: [],
    comment: {
        format: 'plain_text',
        value: ''
    }
};
const $5ea0b57a882b7729$export$55abe7932f6ca981 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dAv2D))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    });
class $5ea0b57a882b7729$export$bc20a02e9bc30e54 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static{
        this.defaultProps = {
            isDisabled: false,
            dialogPlacement: 'bottom-end',
            shouldCloseOnEscapePress: true,
            triggerButtonAppearance: 'subtle',
            triggerButtonStyle: 'icon-only',
            triggerButtonTooltipPosition: 'top',
            dialogZIndex: (0, $IW7jS.layers).modal()
        };
    }
    componentDidMount() {
        if (this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAutoOpenDialog !== prevProps.isAutoOpenDialog && this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentWillUnmount() {
        if (this.props.isAutoOpenDialog && this.props.onDialogClose) this.props.onDialogClose();
    }
    async generateShareError(err) {
        const errorBody = err.body ? await err.body : {};
        // We'll only try and deal with the first error, sorry
        const firstErrorFromBody = errorBody.messagesDetails?.[0];
        return {
            message: firstErrorFromBody?.message || err.message,
            errorCode: firstErrorFromBody?.errorCode,
            helpUrl: firstErrorFromBody?.helpUrl,
            retryable: firstErrorFromBody?.errorCode === undefined
        };
    }
    render() {
        const { isDialogOpen: isDialogOpen, isSharing: isSharing, shareError: shareError, defaultValue: defaultValue, showIntegrationForm: showIntegrationForm, selectedIntegration: selectedIntegration, isMenuItemSelected: isMenuItemSelected } = this.state;
        const { copyLink: copyLink, dialogPlacement: dialogPlacement, config: config, isFetchingConfig: isFetchingConfig, loadUserOptions: loadUserOptions, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, bottomMessage: bottomMessage, submitButtonLabel: submitButtonLabel, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, cloudId: cloudId, orgId: orgId, shareFieldsFooter: shareFieldsFooter, dialogZIndex: dialogZIndex, isPublicLink: isPublicLink, tabIndex: tabIndex, copyTooltipText: copyTooltipText, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const footer = (0, $bpswd.resolveShareFooter)(integrationMode, this.state.tabIndex, customFooter);
        // for performance purposes, we may want to have a loadable content i.e. ShareForm
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
            xcss: (0, $6qaBj.cx)($5ea0b57a882b7729$var$styles.shareButtonWrapperStyles, typeof tabIndex !== 'undefined' && tabIndex >= 0 && $5ea0b57a882b7729$var$styles.outlineNone),
            tabIndex: tabIndex,
            onKeyDown: this.handleKeyDown,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                    content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: this.containerRef,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fVOai.default), {
                                Content: selectedIntegration && selectedIntegration.Content,
                                selectedIntegration: selectedIntegration,
                                copyLink: copyLink,
                                showIntegrationForm: showIntegrationForm,
                                bottomMessage: bottomMessage,
                                customHeader: customHeader,
                                customFooter: footer,
                                loadOptions: loadUserOptions,
                                isSharing: isSharing,
                                shareFormTitle: shareFormTitle,
                                showTitle: integrationMode !== 'tabs' || !shareIntegrations || !shareIntegrations.length,
                                shareFormHelperMessage: shareFormHelperMessage,
                                shareError: shareError,
                                defaultValue: defaultValue,
                                config: config,
                                isFetchingConfig: isFetchingConfig,
                                setIsLoading: this.setIsLoading,
                                submitButtonLabel: submitButtonLabel,
                                product: product,
                                productAttributes: productAttributes,
                                enableSmartUserPicker: enableSmartUserPicker,
                                loggedInAccountId: loggedInAccountId,
                                cloudId: cloudId,
                                orgId: orgId,
                                onUserSelectionChange: this.handleOnUserSelectionChange,
                                shareFieldsFooter: shareFieldsFooter,
                                isPublicLink: isPublicLink,
                                copyTooltipText: copyTooltipText,
                                integrationMode: integrationMode,
                                shareIntegrations: shareIntegrations,
                                additionalTabs: additionalTabs,
                                builtInTabContentWidth: builtInTabContentWidth,
                                isMenuItemSelected: isMenuItemSelected,
                                isSubmitShareDisabled: isSubmitShareDisabled,
                                // actions
                                onLinkCopy: this.handleCopyLink,
                                onSubmit: this.handleShareSubmit,
                                onDismiss: this.handleFormDismiss,
                                onDialogClose: this.handleCloseDialog,
                                onTabChange: this.onTabChange,
                                onMenuItemChange: this.onMenuItemChange,
                                //ref
                                selectPortalRef: this.selectPortalRef,
                                isBrowseUsersDisabled: isBrowseUsersDisabled,
                                userPickerOptions: userPickerOptions,
                                additionalUserFields: additionalUserFields,
                                isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                                CustomSubmitButton: CustomSubmitButton
                            })
                        }),
                    isOpen: isDialogOpen,
                    onClose: this.handleCloseDialog,
                    placement: dialogPlacement,
                    trigger: this.renderShareTriggerButton,
                    zIndex: dialogZIndex,
                    label: this.props.intl.formatMessage((0, $kb1Mm.messages).sharePopupLabel),
                    role: "dialog",
                    // TODO: remove after https://hello.atlassian.net/wiki/x/SoEGzQ experiment is finished
                    offset: this.calculatePopupOffset({
                        isMenuItemSelected: isMenuItemSelected,
                        dialogPlacement: dialogPlacement
                    }),
                    shouldRenderToParent: (0, $eGOwo.fg)('enable-appropriate-reading-order-in-share-dialog')
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
                    zIndex: (0, $bpswd.generateSelectZIndex)(dialogZIndex),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        ref: this.selectPortalRef
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), /**
   * Because the PopUp component has a higher zIndex it causes
   * the select to be rendered within it, and add scrollbars.
   * We will render the select options the PopUp outside,
   */ this.selectPortalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.start = 0, this.state = {
            isDialogOpen: false,
            isSharing: false,
            ignoreIntermediateState: false,
            defaultValue: $5ea0b57a882b7729$export$4d9147e1bc6c176,
            isUsingSplitButton: false,
            showIntegrationForm: false,
            selectedIntegration: null,
            tabIndex: 0,
            isMenuItemSelected: false,
            isLoading: false
        }, this.closeAndResetDialog = ()=>{
            this.setState({
                defaultValue: $5ea0b57a882b7729$export$4d9147e1bc6c176,
                ignoreIntermediateState: true,
                shareError: undefined,
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                isMenuItemSelected: false
            });
            const { onUserSelectionChange: onUserSelectionChange, onDialogClose: onDialogClose } = this.props;
            if (onUserSelectionChange) onUserSelectionChange($5ea0b57a882b7729$export$4d9147e1bc6c176.users);
            if (onDialogClose) onDialogClose();
        }, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, analyticsDecorator: analyticsDecorator } = this.props;
            if (analyticsDecorator) payload = analyticsDecorator(payload);
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $63G4N.CHANNEL_ID));
        }, this.onTabChange = (index)=>{
            let subjectId = 'shareTab';
            const { shareContentType: shareContentType } = this.props;
            if (index === 1) subjectId = 'shareToSlackTab';
            this.createAndFireEvent((0, $63G4N.shareTabClicked)(subjectId, shareContentType));
            this.setState({
                tabIndex: index
            });
        }, this.onMenuItemChange = (menuType)=>{
            let subjectId = menuType === 'Slack' ? 'shareToSlackMenuItem' : 'shareMenuItem';
            const { shareContentType: shareContentType } = this.props;
            this.createAndFireEvent((0, $63G4N.shareMenuItemClicked)(subjectId, shareContentType));
            this.setState({
                isMenuItemSelected: true
            });
        }, this.getFlags = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            // The reason for providing message property is that in jira,
            // the Flag system takes only Message Descriptor as payload
            // and formatMessage is called for every flag
            // if the translation data is not provided, a translated default message
            // will be displayed
            return [
                {
                    appearance: 'success',
                    title: {
                        ...(0, $kb1Mm.messages).shareSuccessMessage,
                        defaultMessage: formatMessage((0, $kb1Mm.messages).shareSuccessMessage, {
                            object: this.props.shareContentType.toLowerCase()
                        })
                    },
                    type: (0, $a9b8bb5645790abf$export$9540ac9c843b8743)
                }
            ];
        }, this.setIsLoading = (isLoading)=>{
            this.setState({
                isLoading: isLoading
            });
        }, this.focus = ()=>{
            if (this.containerRef.current) this.containerRef.current.focus();
        }, this.handleKeyDown = (event)=>{
            const { isLoading: isLoading, isDialogOpen: isDialogOpen } = this.state;
            const { shouldCloseOnEscapePress: shouldCloseOnEscapePress } = this.props;
            if (isLoading) {
                event.stopPropagation();
                this.focus();
            }
            if (isDialogOpen) switch(event.key){
                case 'Esc':
                case 'Escape':
                    // The @atlaskit/popup will capture the event and auto-close, we
                    // need to prevent that if the dialog is set to not close on `ESC`
                    if (!shouldCloseOnEscapePress) {
                        event.preventDefault();
                        event.stopPropagation();
                        // put the focus back onto the share dialog so that
                        // the user can press the escape key again to close the dialog
                        this.focus();
                        return;
                    }
                    // The dialog will auto-close in @atlaskit/popup, we just need to fire
                    // the right events.
                    if (shouldCloseOnEscapePress) {
                        // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
                        // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
                        // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
                        (0, $fECDH.renderShareDialogExp).abort();
                        this.createAndFireEvent((0, $63G4N.cancelShare)(this.start));
                        this.closeAndResetDialog();
                    }
            }
        }, this.handleDialogOpen = ()=>{
            this.setState((state)=>({
                    isDialogOpen: !state.isDialogOpen,
                    ignoreIntermediateState: false,
                    showIntegrationForm: false,
                    selectedIntegration: null
                }), ()=>{
                const { onDialogOpen: onDialogOpen, isPublicLink: isPublicLink } = this.props;
                const { isDialogOpen: isDialogOpen } = this.state;
                if (isDialogOpen) {
                    this.start = Date.now();
                    this.createAndFireEvent((0, $63G4N.screenEvent)({
                        isPublicLink: isPublicLink
                    }));
                    if (onDialogOpen) onDialogOpen();
                    this.focus();
                } else this.handleCloseDialog();
            });
        }, this.onTriggerClick = ()=>{
            const { onTriggerButtonClick: onTriggerButtonClick } = this.props;
            this.createAndFireEvent((0, $63G4N.shareTriggerButtonClicked)());
            this.handleDialogOpen();
            if (onTriggerButtonClick) onTriggerButtonClick();
        }, this.handleCloseDialog = ()=>{
            if (this.props.onDialogClose) this.props.onDialogClose();
            // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
            // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
            // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
            (0, $fECDH.renderShareDialogExp).abort();
            this.setState({
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                tabIndex: 0,
                isMenuItemSelected: false
            });
        }, this.handleShareSubmit = (data)=>{
            const { onShareSubmit: onShareSubmit, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, formShareOrigin: formShareOrigin, showFlags: showFlags, isPublicLink: isPublicLink, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, productAttributes: productAttributes, loggedInAccountId: loggedInAccountId } = this.props;
            if (!onShareSubmit) return;
            (0, $fECDH.shareSubmitExp).start();
            this.setState({
                isSharing: true
            });
            this.createAndFireEvent((0, $63G4N.formShareSubmitted)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            if ((0, $eGOwo.fg)('page_shared_event_from_share_dialogue')) this.createAndFireEvent((0, $63G4N.jiraPageSharedEvent)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                productAttributes: productAttributes,
                loggedInAccountId: loggedInAccountId,
                source: (0, $63G4N.ANALYTICS_SOURCE),
                actionSubjectId: 'submitShare'
            }));
            onShareSubmit(data).then(()=>{
                this.closeAndResetDialog();
                this.setState({
                    isSharing: false
                });
                if (isExtendedShareDialogEnabled && data.users.length === 0) (0, $fECDH.shareSubmitExp).abort();
                else {
                    showFlags(this.getFlags());
                    (0, $fECDH.shareSubmitExp).success();
                }
            }).catch(async (err)=>{
                const shareError = await this.generateShareError(err).catch((errorGenFailed)=>({
                        message: err.message || errorGenFailed.message || 'Unknown error',
                        retryable: true
                    }));
                this.setState({
                    isSharing: false,
                    shareError: shareError
                });
                (0, $adZfk.isValidFailedExperience)((0, $fECDH.shareSubmitExp), err);
            });
        }, this.handleFormDismiss = (data)=>{
            this.setState(({ ignoreIntermediateState: ignoreIntermediateState })=>ignoreIntermediateState ? null : {
                    defaultValue: data
                });
        }, this.calculatePopupOffset = ({ isMenuItemSelected: isMenuItemSelected, dialogPlacement: dialogPlacement })=>{
            if (isMenuItemSelected && dialogPlacement === 'bottom-end') return [
                -0.1,
                8
            ];
            return [
                0,
                8
            ];
        }, this.handleCopyLink = ()=>{
            const { copyLinkOrigin: copyLinkOrigin, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, isPublicLink: isPublicLink, shareAri: shareAri, productAttributes: productAttributes, loggedInAccountId: loggedInAccountId } = this.props;
            this.createAndFireEvent((0, $63G4N.copyLinkButtonClicked)({
                start: this.start,
                shareContentType: shareContentType,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                ari: shareAri,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            // Fire the new Jira-specific analytics event when product is Jira and it's a copy link action
            if ((0, $eGOwo.fg)('page_shared_event_from_share_dialogue')) this.createAndFireEvent((0, $63G4N.jiraPageSharedEvent)({
                start: this.start,
                data: {
                    users: [],
                    comment: {
                        format: 'plain_text',
                        value: ''
                    }
                },
                shareContentType: // Empty data for copy link
                shareContentType,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                productAttributes: productAttributes,
                loggedInAccountId: loggedInAccountId,
                source: (0, $63G4N.ANALYTICS_SOURCE),
                actionSubjectId: 'copyLink'
            }));
        }, this.handleIntegrationClick = (integration)=>{
            this.setState({
                isUsingSplitButton: false,
                isDialogOpen: true,
                showIntegrationForm: true,
                selectedIntegration: integration
            });
        }, this.renderShareTriggerButton = (triggerProps)=>{
            const { isDialogOpen: isDialogOpen, isUsingSplitButton: isUsingSplitButton } = this.state;
            const { intl: { formatMessage: formatMessage }, isDisabled: isDisabled, renderCustomTriggerButton: renderCustomTriggerButton, customTriggerButtonIcon: customTriggerButtonIcon, triggerButtonIcon: triggerButtonIcon, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, triggerButtonAppearance: triggerButtonAppearance, triggerButtonStyle: triggerButtonStyle, integrationMode: integrationMode, shareIntegrations: shareIntegrations, dialogZIndex: dialogZIndex, dialogPlacement: dialogPlacement } = this.props;
            let button;
            const ShareButtonIcon = triggerButtonIcon || $5ea0b57a882b7729$export$55abe7932f6ca981;
            // Render a custom or standard button.
            if (renderCustomTriggerButton) {
                const { shareError: shareError } = this.state;
                button = renderCustomTriggerButton({
                    error: shareError,
                    isDisabled: isDisabled,
                    isSelected: isDialogOpen,
                    onClick: this.onTriggerClick,
                    iconBefore: customTriggerButtonIcon
                }, triggerProps);
            } else button = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dy3nr.default), {
                appearance: triggerButtonAppearance,
                text: triggerButtonStyle !== 'icon-only' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $kb1Mm.messages).shareTriggerButtonText
                }) : null,
                "aria-label": formatMessage((0, $kb1Mm.messages).shareTriggerButtonText),
                onClick: this.onTriggerClick,
                iconBefore: triggerButtonStyle !== 'text-only' ? /*#__PURE__*/ (0, $gt9Am.jsx)(ShareButtonIcon, {
                    label: ""
                }) : undefined,
                isSelected: isDialogOpen,
                isDisabled: isDisabled,
                ref: triggerProps.ref,
                // When we autoFocus the dialog, we want to autofocus the trigger as well, that way when the dialog is closed, the trigger is focused
                autoFocus: this.props.isAutoOpenDialog
            });
            // If the button only shows the icon, wrap it in a tooltip containing the button text.
            if (triggerButtonStyle === 'icon-only') button = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                content: !isUsingSplitButton ? triggerButtonTooltipText || formatMessage((0, $kb1Mm.messages).shareTriggerButtonTooltipText) : null,
                position: triggerButtonTooltipPosition,
                hideTooltipOnClick: true,
                children: button
            });
            // If there are any integrations, wrap the share button in a split button with integrations.
            if (integrationMode === 'split' && shareIntegrations?.length) button = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $akrRa.default), {
                shareButton: button,
                handleOpenSplitButton: this.handleOpenSplitButton,
                handleCloseSplitButton: this.handleCloseSplitButton,
                isUsingSplitButton: isUsingSplitButton,
                triggerButtonAppearance: triggerButtonAppearance,
                dialogZIndex: dialogZIndex,
                dialogPlacement: dialogPlacement,
                shareIntegrations: shareIntegrations,
                onIntegrationClick: this.handleIntegrationClick,
                createAndFireEvent: this.createAndFireEvent
            });
            return button;
        }, this.handleOpenSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: true
            }, ()=>this.handleCloseDialog());
            this.createAndFireEvent((0, $63G4N.shareSplitButtonEvent)());
        }, this.handleCloseSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: false
            });
        }, this.handleOnUserSelectionChange = (value)=>{
            const { onUserSelectionChange: onUserSelectionChange } = this.props;
            this.setState({
                shareError: undefined
            });
            onUserSelectionChange?.(value);
        };
    }
}
const $5ea0b57a882b7729$export$c7f8df1e37e7f581 = (0, $4J0ad.default)()((0, $6YFG2.default)($5ea0b57a882b7729$export$bc20a02e9bc30e54));

});
parcelRegister("akrRa", function(module, exports) {
$parcel$export(module.exports, "default", () => $d822d933cfcdac09$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $kDaaB = parcelRequire("kDaaB");

var $Ay1uj = parcelRequire("Ay1uj");
var $2ntmI = parcelRequire("2ntmI");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $5lAAn = parcelRequire("5lAAn");

var $eGOwo = parcelRequire("eGOwo");


var $kb1Mm = parcelRequire("kb1Mm");

var $63G4N = parcelRequire("63G4N");

var $28I5q = parcelRequire("28I5q");
// span
const $d822d933cfcdac09$var$dropDownIntegrationButtonWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    ['button:hover']: {
        background: 'transparent'
    }
});
const $d822d933cfcdac09$var$integrationButtonText = (integrationName)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), {
        ...(0, $kb1Mm.messages).shareToIntegrationButtonText,
        values: {
            integrationName: integrationName
        }
    });
const $d822d933cfcdac09$var$IntegrationButtonWrapper = ({ children: children })=>// The css has no discernible effect on the button, so it is not included in the migration
    (0, $eGOwo.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $1NIU8.jsx)("span", null, children) : /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $d822d933cfcdac09$var$dropDownIntegrationButtonWrapperStyles
    }, children);
const $d822d933cfcdac09$var$SplitButtonDropdown = (props)=>{
    const { triggerButtonAppearance: triggerButtonAppearance, isUsingSplitButton: isUsingSplitButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, createAndFireEvent: createAndFireEvent } = props;
    const onOpenChange = (0, $eJOHy.useCallback)(({ isOpen: isOpen })=>{
        if (isOpen) handleOpenSplitButton();
        else handleCloseSplitButton();
    }, [
        handleOpenSplitButton,
        handleCloseSplitButton
    ]);
    const onIntegrationButtonClick = (0, $eJOHy.useCallback)((integration)=>{
        onIntegrationClick(integration);
        createAndFireEvent((0, $63G4N.shareIntegrationButtonEvent)(integration.type));
    }, [
        createAndFireEvent,
        onIntegrationClick
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7rjYb.default), {
        testId: "split-button-dropdown",
        trigger: ({ triggerRef: triggerRef, ...providedProps })=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $Ay1uj.default), {
                label: "",
                ...providedProps,
                ref: triggerRef,
                icon: (iconProps)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                        ...iconProps,
                        size: "small"
                    }),
                appearance: triggerButtonAppearance
            }),
        placement: "bottom-end",
        isOpen: isUsingSplitButton,
        onOpenChange: onOpenChange,
        shouldRenderToParent: (0, $eGOwo.fg)('should-render-to-parent-should-be-true-people-and-')
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aLJ1L.default), null, shareIntegrations.map((integration)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $jYYbf.default), {
            key: integration.type,
            testId: `split-button-dropdownitem-${integration.type}`
        }, /*#__PURE__*/ (0, $1NIU8.jsx)($d822d933cfcdac09$var$IntegrationButtonWrapper, null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $28I5q.default), {
            textColor: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`,
            appearance: "subtle",
            onClick: ()=>onIntegrationButtonClick(integration),
            shouldFitContainer: true,
            text: $d822d933cfcdac09$var$integrationButtonText(integration.type),
            IntegrationIcon: integration.Icon
        }))))));
};
$d822d933cfcdac09$var$SplitButtonDropdown.displayName = 'SplitButtonDropdown';
function $d822d933cfcdac09$export$2e2bcd8739ae039({ shareButton: shareButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, isUsingSplitButton: isUsingSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, triggerButtonAppearance: triggerButtonAppearance, createAndFireEvent: createAndFireEvent }) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2ntmI.SplitButton), {
        "data-testid": "split-button",
        appearance: triggerButtonAppearance
    }, shareButton, /*#__PURE__*/ (0, $1NIU8.jsx)($d822d933cfcdac09$var$SplitButtonDropdown, {
        shareIntegrations: shareIntegrations,
        triggerButtonAppearance: triggerButtonAppearance,
        isUsingSplitButton: isUsingSplitButton,
        handleOpenSplitButton: handleOpenSplitButton,
        handleCloseSplitButton: handleCloseSplitButton,
        onIntegrationClick: onIntegrationClick,
        createAndFireEvent: createAndFireEvent
    }));
}

});
parcelRegister("28I5q", function(module, exports) {
$parcel$export(module.exports, "default", () => $f578299aad9c22d6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $abjs4 = parcelRequire("abjs4");

var $eGOwo = parcelRequire("eGOwo");


var $dDrIT = parcelRequire("dDrIT");
function $f578299aad9c22d6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $f578299aad9c22d6$var$integrationButtonCopyWrapperStyle = {
    name: "16rgrc1",
    styles: "display:flex;justify-content:left"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $f578299aad9c22d6$var$integrationIconWrapperStyle = {
    name: "mz1ewe",
    styles: "margin:var(--ds-space-025, 2px) var(--ds-space-100, 8px) var(--ds-space-0, 0px) var(--ds-space-0, 0px)"
};
const $f578299aad9c22d6$var$IntegrationButtonInner = (props)=>{
    const { text: text, textColor: textColor, IntegrationIcon: IntegrationIcon, ...restProps } = props;
    return(// TODO: (from codemod) CustomThemeButton will be deprecated. Please consider migrating to Pressable or Anchor Primitives with custom styles.
    /*#__PURE__*/ (0, $1NIU8.jsx)((0, $abjs4.default), restProps, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $f578299aad9c22d6$var$integrationButtonCopyWrapperStyle,
        style: {
            color: textColor || `var(--ds-text, ${0, $7bb4c1736002a04a$export$c39c0fe0f26207ae})`
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $f578299aad9c22d6$var$integrationIconWrapperStyle
    }, /*#__PURE__*/ (0, $1NIU8.jsx)(IntegrationIcon, null)), /*#__PURE__*/ (0, $1NIU8.jsx)("span", null, text))));
};
const $f578299aad9c22d6$var$IntegrationButton = (props)=>(0, $eGOwo.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $dDrIT.default), {
        text: props.text,
        onClick: props.onClick,
        IntegrationIcon: props.IntegrationIcon
    }) : /*#__PURE__*/ (0, $1NIU8.jsx)($f578299aad9c22d6$var$IntegrationButtonInner, props);
$f578299aad9c22d6$var$IntegrationButton.displayName = 'IntegrationButton';
var $f578299aad9c22d6$export$2e2bcd8739ae039 = $f578299aad9c22d6$var$IntegrationButton;

});
parcelRegister("dDrIT", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce8a1c2631a67519$export$2e2bcd8739ae039);
/* IntegrationButtonNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");
const $ce8a1c2631a67519$var$styles = {
    integrationButtonCopyWrapperStyle: "_1e0c1txw _1bah1e5h _syaz10s3",
    integrationIconWrapperStyle: "_19pkv77o _2hwxu2gc _otyrze3t _18u0ze3t"
};
const $ce8a1c2631a67519$var$IntegrationButton = (props)=>{
    const { text: text, IntegrationIcon: IntegrationIcon } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
        appearance: "subtle",
        shouldFitContainer: true,
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
            as: "span",
            xcss: (0, $6qaBj.cx)($ce8a1c2631a67519$var$styles.integrationButtonCopyWrapperStyle),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    xcss: (0, $6qaBj.cx)($ce8a1c2631a67519$var$styles.integrationIconWrapperStyle),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(IntegrationIcon, {})
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    color: "color.text",
                    children: text
                })
            ]
        })
    });
};
$ce8a1c2631a67519$var$IntegrationButton.displayName = 'IntegrationButton';
var $ce8a1c2631a67519$export$2e2bcd8739ae039 = $ce8a1c2631a67519$var$IntegrationButton;

});



parcelRegister("bpswd", function(module, exports) {
$parcel$export(module.exports, "generateSelectZIndex", () => $7289b973ae3b2ee5$export$eedd642610b90f47);
$parcel$export(module.exports, "getMenuPortalTargetCurrentHTML", () => $7289b973ae3b2ee5$export$e3e96376b61c8ea);
$parcel$export(module.exports, "optionDataToUsers", () => $7289b973ae3b2ee5$export$1c6fd61621efa6e2);
$parcel$export(module.exports, "allowEmails", () => $7289b973ae3b2ee5$export$e3c57815dfd9a32c);
$parcel$export(module.exports, "resolveShareFooter", () => $7289b973ae3b2ee5$export$6900a66855146901);

var $IW7jS = parcelRequire("IW7jS");
const $7289b973ae3b2ee5$export$ff1a1e5addedc4cc = 10;
const $7289b973ae3b2ee5$export$eedd642610b90f47 = (dialogZIndex)=>{
    // If user provided non-number value for zIndex, ignore and return undefined,
    // which will default to `layers.layer()` inside PopUp
    if (typeof dialogZIndex !== 'number' || !dialogZIndex) return (0, $IW7jS.layers).modal() + $7289b973ae3b2ee5$export$ff1a1e5addedc4cc;
    return dialogZIndex + $7289b973ae3b2ee5$export$ff1a1e5addedc4cc;
};
const $7289b973ae3b2ee5$export$e3e96376b61c8ea = (ref)=>{
    if (!ref) return null;
    if (!Object.prototype.hasOwnProperty.call(ref, 'current')) return null;
    // @ts-ignore ts(2339) - ref not having property current
    return ref.current;
};
const $7289b973ae3b2ee5$export$1c6fd61621efa6e2 = (optionDataArray)=>optionDataArray.map((optionData)=>{
        switch(optionData.type){
            case 'email':
                const user = {
                    type: 'user',
                    email: optionData.id
                };
                return user;
            case 'external_user':
                // When optionData.type is 'external_user', we need to convert it to 'user'
                // because 'external_user' isn't a valid type for the '/gateway/api/share' API.
                return {
                    type: 'user',
                    id: optionData.id
                };
            default:
                return {
                    type: optionData.type || 'user',
                    id: optionData.id
                };
        }
    });
const $7289b973ae3b2ee5$export$e3c57815dfd9a32c = (config)=>!(config && config.disableSharingToEmails);
const $7289b973ae3b2ee5$export$6900a66855146901 = (integrationMode, tabIndex, customFooter)=>{
    if (customFooter) {
        if (integrationMode !== 'tabs' || tabIndex === 0) return customFooter;
    }
};

});




parcelRegister("8uUv3", function(module, exports) {
$parcel$export(module.exports, "ShareDialogContainer", () => $ebd7f2f2871f7408$export$78b28896b43ae5d6);

var $eJOHy = parcelRequire("eJOHy");

var $iePme = parcelRequire("iePme");

var $k71qx = parcelRequire("k71qx");

var $IW7jS = parcelRequire("IW7jS");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $b8OI0 = parcelRequire("b8OI0");

var $gYnSx = parcelRequire("gYnSx");

var $jd93d = parcelRequire("jd93d");

var $h47gY = parcelRequire("h47gY");

var $6YQhs = parcelRequire("6YQhs");

var $9tIzF = parcelRequire("9tIzF");

var $2vkDT = parcelRequire("2vkDT");

var $cZ67K = parcelRequire("cZ67K");

var $24I12 = parcelRequire("24I12");

var $bYiRq = parcelRequire("bYiRq");

var $eQR3n = parcelRequire("eQR3n");

var $73pRz = parcelRequire("73pRz");

var $03gWs = parcelRequire("03gWs");

var $7y4xb = parcelRequire("7y4xb");

var $4XK86 = parcelRequire("4XK86");

var $7ZqTj = parcelRequire("7ZqTj");
const $ebd7f2f2871f7408$export$55abe7932f6ca981 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iePme))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    });
const $ebd7f2f2871f7408$var$params = {};
const $ebd7f2f2871f7408$export$78b28896b43ae5d6 = ({ shareLink: shareLink, originTracingFactory: originTracingFactory, productId: productId, shareTitle: shareTitle, workspaceAri: workspaceAri, onSubmit: onSubmit, onDialogOpen: onDialogOpen, formatCopyLink: formatCopyLink, cloudId: cloudId, orgId: orgId, loadUserOptions: loadUserOptions, renderCustomTriggerButton: renderCustomTriggerButton, dialogPlacement: dialogPlacement = 'bottom-end', customTriggerButtonIcon: customTriggerButtonIcon, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, showFlags: showFlags, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, triggerButtonAppearance: triggerButtonAppearance, triggerButtonIcon: triggerButtonIcon, triggerButtonStyle: triggerButtonStyle = 'icon-only', triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, bottomMessage: bottomMessage, shareeAction: shareeAction, productAttributes: productAttributes, dialogZIndex: dialogZIndex = (0, $IW7jS.layers).modal(), customHeader: customHeader, customFooter: customFooter, onTriggerButtonClick: onTriggerButtonClick, onUserSelectionChange: onUserSelectionChange, shareFieldsFooter: shareFieldsFooter, isPublicLink: isPublicLink, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, shareAri: shareAri, copyTooltipText: copyTooltipText, onDialogClose: onDialogClose, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton, shareClient: shareClientProp, isAutoOpenDialog: isAutoOpenDialog, dialogOffset: dialogOffset })=>{
    const [defaultData, setDefaultData] = (0, $eJOHy.useState)((0, $bYiRq.defaultShareContentState));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const shareClient = (0, $eJOHy.useMemo)(()=>shareClientProp || new (0, $2vkDT.ShareServiceClient)(), [
        shareClientProp
    ]);
    const { fetch: fetchSettings, result: settings } = (0, $73pRz.useFetchSettings)();
    const { fetch: fetchExtendedDialogData, status: extendedDialogData } = (0, $03gWs.useFetchExtendedDialogData)();
    const { config: config, fetchConfig: fetchConfig } = (0, $24I12.useShareConfig)(shareClient, cloudId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onTriggerClick = (0, $eJOHy.useCallback)(()=>{
        createAnalyticsEvent((0, $6YQhs.shareTriggerButtonClicked)()).fire((0, $6YQhs.CHANNEL_ID));
        (0, $7y4xb.shareDialogLoadingExp).start();
        onTriggerButtonClick?.();
        fetchSettings();
    }, [
        createAnalyticsEvent,
        fetchSettings,
        onTriggerButtonClick
    ]);
    const onFetchFormData = (0, $eJOHy.useCallback)(()=>{
        fetchConfig();
        if (isExtendedShareDialogEnabled) fetchExtendedDialogData();
    }, [
        fetchConfig,
        isExtendedShareDialogEnabled,
        fetchExtendedDialogData
    ]);
    const localRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        /* This is a temporary solution to move away from EntrypointContainer loading.
    	 */ if (isAutoOpenDialog) localRef.current?.click();
    }, [
        isAutoOpenDialog
    ]);
    const renderTriggerButton = (0, $eJOHy.useCallback)(({ ref: triggerRef, ...triggerProps })=>{
        const ref = (0, $jd93d.mergeRefs)(localRef, triggerRef);
        let button;
        const ShareButtonIcon = triggerButtonIcon || $ebd7f2f2871f7408$export$55abe7932f6ca981;
        if (renderCustomTriggerButton) button = renderCustomTriggerButton({
            isSelected: triggerProps['aria-expanded'],
            onClick: onTriggerClick,
            iconBefore: customTriggerButtonIcon,
            isDisabled: config === 'fetching'
        }, {
            ...triggerProps,
            ref: ref
        });
        else button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ZqTj.ShareButton), {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            appearance: triggerButtonAppearance,
            text: triggerButtonStyle !== 'icon-only' ? formatMessage((0, $4XK86.default).shareTriggerButtonText) : null,
            "aria-label": formatMessage((0, $4XK86.default).shareTriggerButtonText),
            onClick: onTriggerClick,
            iconBefore: triggerButtonStyle !== 'text-only' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ShareButtonIcon, {
                label: ""
            }) : undefined,
            isSelected: triggerProps['aria-expanded'],
            ref: ref,
            isDisabled: config === 'fetching'
        });
        if (triggerButtonStyle === 'icon-only') button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: triggerButtonTooltipText || formatMessage((0, $4XK86.default).shareTriggerButtonTooltipText),
            position: triggerButtonTooltipPosition,
            hideTooltipOnClick: true
        }, button);
        return button;
    }, [
        config,
        customTriggerButtonIcon,
        formatMessage,
        onTriggerClick,
        renderCustomTriggerButton,
        triggerButtonAppearance,
        triggerButtonIcon,
        triggerButtonStyle,
        triggerButtonTooltipPosition,
        triggerButtonTooltipText
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "share-dialog-container",
        packageName: "jiraShareDialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZ67K.EntrypointPropsProvider), {
        formSettings: {
            isBrowseUsersDisabled: isBrowseUsersDisabled,
            extendedDialogData: extendedDialogData
        },
        config: config,
        emailSettings: settings
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b8OI0.PopupTrigger), {
        onClose: ()=>{
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'shareDialog closed', {
                isExtendedShareDialogEnabled: isExtendedShareDialogEnabled
            });
        },
        entryPoint: (0, $9tIzF.shareDialogContentEntryPoint),
        entryPointParams: $ebd7f2f2871f7408$var$params,
        entryPointProps: {
            onFetchFormData: onFetchFormData,
            onDialogOpen: onDialogOpen,
            onDialogClose: onDialogClose,
            onUserSelectionChange: onUserSelectionChange,
            onSubmit: onSubmit,
            showFlags: showFlags,
            isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
            shareContentType: shareContentType,
            shareContentSubType: shareContentSubType,
            shareContentId: shareContentId,
            isPublicLink: isPublicLink,
            shareAri: shareAri,
            productAttributes: productAttributes,
            loggedInAccountId: loggedInAccountId,
            integrationMode: integrationMode,
            shareIntegrations: shareIntegrations,
            customFooter: customFooter,
            loadUserOptions: loadUserOptions,
            shareFormTitle: shareFormTitle,
            shareFormHelperMessage: shareFormHelperMessage,
            bottomMessage: bottomMessage,
            shareeAction: shareeAction,
            customHeader: customHeader,
            enableSmartUserPicker: enableSmartUserPicker,
            cloudId: cloudId,
            orgId: orgId,
            copyTooltipText: copyTooltipText,
            additionalTabs: additionalTabs,
            builtInTabContentWidth: builtInTabContentWidth,
            userPickerOptions: userPickerOptions,
            isSubmitShareDisabled: isSubmitShareDisabled,
            CustomSubmitButton: CustomSubmitButton,
            defaultData: defaultData,
            setDefaultData: setDefaultData,
            shareClient: shareClient,
            shareLink: shareLink,
            productId: productId,
            originTracingFactory: originTracingFactory,
            formatCopyLink: formatCopyLink,
            shareTitle: shareTitle,
            workspaceAri: workspaceAri,
            dialogZIndex: dialogZIndex,
            shareFieldsFooter: shareFieldsFooter
        },
        trigger: renderTriggerButton,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eQR3n.LoadingSpinner), null),
        onError: (props)=>{
            (0, $7y4xb.shareDialogLoadingExp).failure();
            (0, $gYnSx.default)({
                ...props,
                meta: {
                    id: 'jira-share-dialog-container',
                    packageName: 'jiraShareDialog',
                    teamName: 'jira-warepil'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        },
        placement: dialogPlacement,
        offset: dialogOffset,
        role: "dialog",
        zIndex: dialogZIndex,
        label: formatMessage((0, $4XK86.default).sharePopupLabel)
    })));
};

});
parcelRegister("jd93d", function(module, exports) {
$parcel$export(module.exports, "mergeRefs", () => $03c18883e9007fda$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $03c18883e9007fda$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $03c18883e9007fda$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $03c18883e9007fda$export$2e2bcd8739ae039(...refs) {
    return (0, $eJOHy.useMemo)(()=>$03c18883e9007fda$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});

parcelRegister("6YQhs", function(module, exports) {
$parcel$export(module.exports, "CHANNEL_ID", () => $de38c7c49c6b9636$export$e5fd2b76433ec8a8);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $de38c7c49c6b9636$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "INTEGRATION_MODAL_SOURCE", () => $de38c7c49c6b9636$export$8944b0a832f27e18);
$parcel$export(module.exports, "shareTriggerButtonClicked", () => $de38c7c49c6b9636$export$584e8ee8b04ff145);
$parcel$export(module.exports, "shareTabClicked", () => $de38c7c49c6b9636$export$544b588ba577a9a6);
$parcel$export(module.exports, "shareMenuItemClicked", () => $de38c7c49c6b9636$export$69ab8fd7ab99f6db);
$parcel$export(module.exports, "shareConfigurationLoaded", () => $de38c7c49c6b9636$export$75ace3c1905ea74c);
$parcel$export(module.exports, "shareConfigurationLoadFailed", () => $de38c7c49c6b9636$export$cbf264bae587b83d);
$parcel$export(module.exports, "copyLinkButtonClicked", () => $de38c7c49c6b9636$export$9af471d00b79f9b0);
$parcel$export(module.exports, "formShareSubmitted", () => $de38c7c49c6b9636$export$e2e6cacbe383cb80);
$parcel$export(module.exports, "jiraPageSharedEvent", () => $de38c7c49c6b9636$export$7ab6dc9ee5da4a70);

var $bp6ad = parcelRequire("bp6ad");
const $de38c7c49c6b9636$var$buildAttributes = (attributes = {})=>({
        packageName: 'share-dialog',
        ...attributes
    });
const $de38c7c49c6b9636$var$createEvent = (eventType, source, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        source: source,
        attributes: $de38c7c49c6b9636$var$buildAttributes(attributes)
    });
const $de38c7c49c6b9636$export$e5fd2b76433ec8a8 = 'fabric-elements';
const $de38c7c49c6b9636$export$f7109619a5e9e0d6 = 'shareModal';
const $de38c7c49c6b9636$export$8944b0a832f27e18 = 'integrationShareDialog';
const $de38c7c49c6b9636$export$eab30ffadcd0ab75 = ()=>$de38c7c49c6b9636$var$createEvent('ui', $de38c7c49c6b9636$export$8944b0a832f27e18, 'clicked', 'button', 'shareSplitButton');
const $de38c7c49c6b9636$export$f04d85d45801fef1 = (type = '')=>$de38c7c49c6b9636$var$createEvent('ui', $de38c7c49c6b9636$export$8944b0a832f27e18, 'clicked', 'button', 'shareToIntegration', {
        integrationType: type.toLowerCase()
    });
const $de38c7c49c6b9636$export$afe83ea4a1997503 = (actionSubjectId, attributes = {})=>$de38c7c49c6b9636$var$createEvent('operational', $de38c7c49c6b9636$export$f7109619a5e9e0d6, 'encountered', 'error', actionSubjectId, {
        ...attributes,
        source: $de38c7c49c6b9636$export$f7109619a5e9e0d6
    });
const $de38c7c49c6b9636$export$584e8ee8b04ff145 = ()=>$de38c7c49c6b9636$var$createEvent('ui', $de38c7c49c6b9636$export$f7109619a5e9e0d6, 'clicked', 'button', 'share');
const $de38c7c49c6b9636$export$544b588ba577a9a6 = (subjectId, shareContentType)=>$de38c7c49c6b9636$var$createEvent('ui', $de38c7c49c6b9636$export$f7109619a5e9e0d6, 'clicked', 'tab', subjectId || 'shareTab', {
        shareContentType: shareContentType
    });
const $de38c7c49c6b9636$export$69ab8fd7ab99f6db = (subjectId, shareContentType)=>$de38c7c49c6b9636$var$createEvent('ui', $de38c7c49c6b9636$export$f7109619a5e9e0d6, 'clicked', 'menuItem', subjectId || 'shareMenuItem', {
        shareContentType: shareContentType
    });
const $de38c7c49c6b9636$export$b4731c87331a8174 = (start)=>$de38c7c49c6b9636$var$createEvent('ui', $de38c7c49c6b9636$export$f7109619a5e9e0d6, 'pressed', 'keyboardShortcut', 'cancelShare', {
        source: $de38c7c49c6b9636$export$f7109619a5e9e0d6,
        duration: $de38c7c49c6b9636$var$duration(start)
    });
const $de38c7c49c6b9636$export$35781a2d50f9fba9 = ()=>$de38c7c49c6b9636$var$createEvent('operational', $de38c7c49c6b9636$export$f7109619a5e9e0d6, 'requested', 'shortUrl', undefined, {
        source: $de38c7c49c6b9636$export$f7109619a5e9e0d6
    });
const $de38c7c49c6b9636$export$e78d65558f8d859a = (start, tooSlow)=>$de38c7c49c6b9636$var$createEvent('operational', $de38c7c49c6b9636$export$f7109619a5e9e0d6, 'generated', 'shortUrl', undefined, {
        source: $de38c7c49c6b9636$export$f7109619a5e9e0d6,
        duration: $de38c7c49c6b9636$var$duration(start),
        tooSlow: tooSlow
    });
const $de38c7c49c6b9636$export$75ace3c1905ea74c = (attributes)=>$de38c7c49c6b9636$var$createEvent('track', $de38c7c49c6b9636$export$f7109619a5e9e0d6, 'loaded', 'shareConfiguration', undefined, {
        source: $de38c7c49c6b9636$export$f7109619a5e9e0d6,
        ...attributes
    });
const $de38c7c49c6b9636$export$cbf264bae587b83d = (attributes)=>$de38c7c49c6b9636$var$createEvent('track', $de38c7c49c6b9636$export$f7109619a5e9e0d6, 'error', 'shareConfiguration', undefined, {
        source: $de38c7c49c6b9636$export$f7109619a5e9e0d6,
        ...attributes
    });
const $de38c7c49c6b9636$export$9af471d00b79f9b0 = ({ start: start, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false, ari: ari })=>$de38c7c49c6b9636$var$createEvent('ui', $de38c7c49c6b9636$export$f7109619a5e9e0d6, 'clicked', 'button', 'copyShareLink', {
        source: $de38c7c49c6b9636$export$f7109619a5e9e0d6,
        duration: $de38c7c49c6b9636$var$duration(start),
        shortUrl: undefined,
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        isPublicLink: isPublicLink,
        ari: ari,
        // this specific string is needed for marking a successful navigation session
        navdexPointType: 'navigationSessionEnd',
        ...$de38c7c49c6b9636$var$getOriginTracingAttributes(shareOrigin)
    });
const $de38c7c49c6b9636$export$e2e6cacbe383cb80 = ({ start: start, data: data, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false })=>{
    const users = $de38c7c49c6b9636$var$extractIdsByType(data, (0, $bp6ad.isUser));
    const externalUsers = $de38c7c49c6b9636$var$extractIdsByType(data, (0, $bp6ad.isExternalUser));
    const groups = $de38c7c49c6b9636$var$extractIdsByType(data, (0, $bp6ad.isGroup));
    const teams = $de38c7c49c6b9636$var$extractIdsByType(data, (0, $bp6ad.isTeam));
    const teamUserCounts = $de38c7c49c6b9636$var$extractMemberCountsFromTeams(data, (0, $bp6ad.isTeam));
    const emails = $de38c7c49c6b9636$var$extractIdsByType(data, (0, $bp6ad.isEmail));
    return $de38c7c49c6b9636$var$createEvent('ui', $de38c7c49c6b9636$export$f7109619a5e9e0d6, 'clicked', 'button', 'submitShare', {
        ...$de38c7c49c6b9636$var$getOriginTracingAttributes(shareOrigin),
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        duration: $de38c7c49c6b9636$var$duration(start),
        emailCount: emails.length,
        teamCount: teams.length,
        userCount: users.length,
        groupCount: groups.length,
        externalUserCount: externalUsers.length,
        users: users,
        teams: teams,
        teamUserCounts: teamUserCounts,
        groups: groups,
        messageLength: data.comment && data.comment.format === 'plain_text' ? data.comment.value.length : 0,
        isMessageEnabled: true,
        isPublicLink: isPublicLink
    });
};
const $de38c7c49c6b9636$var$duration = (start)=>Date.now() - start;
const $de38c7c49c6b9636$var$getOriginTracingAttributes = (origin)=>origin ? origin.toAnalyticsAttributes({
        hasGeneratedId: true
    }) : {};
const $de38c7c49c6b9636$var$extractIdsByType = (data, checker)=>data.users.filter(checker).map((option)=>option.id);
const $de38c7c49c6b9636$var$extractMemberCountsFromTeams = (data, checker)=>// teams with zero memberships cannot exist in share, so we use that
    // as the default value for undefined team member counts
    data.users.filter(checker).map((option)=>option.memberCount || 0);
const $de38c7c49c6b9636$export$7ab6dc9ee5da4a70 = ({ start: start, data: data, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false, productAttributes: productAttributes, loggedInAccountId: loggedInAccountId, source: source = $de38c7c49c6b9636$export$f7109619a5e9e0d6, actionSubjectId: actionSubjectId = 'submitShare' })=>{
    const users = $de38c7c49c6b9636$var$extractIdsByType(data, (0, $bp6ad.isUser));
    const externalUsers = $de38c7c49c6b9636$var$extractIdsByType(data, (0, $bp6ad.isExternalUser));
    const groups = $de38c7c49c6b9636$var$extractIdsByType(data, (0, $bp6ad.isGroup));
    const teams = $de38c7c49c6b9636$var$extractIdsByType(data, (0, $bp6ad.isTeam));
    const teamUserCounts = $de38c7c49c6b9636$var$extractMemberCountsFromTeams(data, (0, $bp6ad.isTeam));
    const emails = $de38c7c49c6b9636$var$extractIdsByType(data, (0, $bp6ad.isEmail));
    const baseAttributes = {
        duration: $de38c7c49c6b9636$var$duration(start),
        source: source,
        contentType: shareContentType,
        projectType: productAttributes?.projectType,
        projectStyle: productAttributes?.projectStyle,
        userLocation: productAttributes?.userLocation,
        isAdmin: productAttributes?.isAdmin,
        isProjectAdmin: productAttributes?.isProjectAdmin,
        ...$de38c7c49c6b9636$var$getOriginTracingAttributes(shareOrigin),
        contentId: shareContentId,
        isPublicLink: isPublicLink,
        loggedInAccountId: loggedInAccountId,
        shareContentSubType: shareContentSubType,
        externalUsers: externalUsers
    };
    // User/team/group data (only for non-copy-link shares)
    const shareSpecificAttributes = data.users.length > 0 ? {
        users: users,
        userCount: users.length,
        teams: teams,
        teamCount: teams.length,
        teamCounts: teamUserCounts,
        groups: groups,
        groupCount: groups.length,
        emailCount: emails.length
    } : {};
    return $de38c7c49c6b9636$var$createEvent('track', source, 'shared', 'page', actionSubjectId, {
        ...baseAttributes,
        ...shareSpecificAttributes
    });
};

});

parcelRegister("9tIzF", function(module, exports) {
$parcel$export(module.exports, "shareDialogContentEntryPoint", () => $9e8c2b25d78d1bd3$export$98a5c6396b7cc38e);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $9e8c2b25d78d1bd3$export$98a5c6396b7cc38e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("ovNyZ")).then((module)=>module.ContentSwitcher), {
        moduleId: "2056151e",
        moduleName: "ContentSwitcher",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("ovNyZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("8EKcx")
]).then(()=>parcelRequire('k8Xrg'));

});


parcelRegister("2vkDT", function(module, exports) {
$parcel$export(module.exports, "ShareServiceClient", () => $7da49f8a8be5a38f$export$ee05f3e1f0248b62);

var $kp3br = parcelRequire("kp3br");
const $7da49f8a8be5a38f$export$a7d7a4246bdd7a12 = 'share';
const $7da49f8a8be5a38f$export$1a440d9a41e6ce3e = 'share/configuration';
const $7da49f8a8be5a38f$export$7745139d0aa6183c = '/gateway/api';
class $7da49f8a8be5a38f$export$ee05f3e1f0248b62 {
    constructor(serviceConfig){
        this.serviceConfig = {
            url: $7da49f8a8be5a38f$export$7745139d0aa6183c,
            ...serviceConfig || {}
        };
    }
    getConfig(cloudId) {
        const options = {
            path: $7da49f8a8be5a38f$export$1a440d9a41e6ce3e,
            queryParams: {
                cloudId: cloudId
            },
            requestInit: {
                method: 'get'
            }
        };
        return (0, $kp3br.utils).requestService(this.serviceConfig, options);
    }
    /**
	 * To send a POST request to the share endpoint in Share service
	 */ share(content, recipients, metadata, comment) {
        return fetch(`${this.serviceConfig.url}/${$7da49f8a8be5a38f$export$a7d7a4246bdd7a12}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            credentials: 'include',
            body: JSON.stringify({
                content: content,
                recipients: recipients,
                metadata: metadata,
                comment: comment
            })
        }).then((response)=>{
            if (response.status === 204) return Promise.resolve();
            if (response.ok) return response.json();
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({
                code: response.status,
                reason: response.statusText,
                body: response.json()
            });
        });
    }
}

});

parcelRegister("cZ67K", function(module, exports) {
$parcel$export(module.exports, "EntrypointPropsProvider", () => $c63493d716292494$export$11fb94117e9f43f7);
$parcel$export(module.exports, "useEntrypointProps", () => $c63493d716292494$export$2423d0186e859ed7);

var $eJOHy = parcelRequire("eJOHy");
const $c63493d716292494$var$initialProps = {
    config: 'fetching',
    emailSettings: {
        status: 'loading',
        payload: undefined
    },
    formSettings: {
        extendedDialogData: 'idle'
    }
};
const $c63493d716292494$export$4c4cf33df5e3a573 = /*#__PURE__*/ (0, $eJOHy.createContext)($c63493d716292494$var$initialProps);
const $c63493d716292494$export$11fb94117e9f43f7 = ({ config: config, children: children, emailSettings: emailSettings, formSettings: formSettings })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c63493d716292494$export$4c4cf33df5e3a573.Provider, {
        value: {
            config: config,
            emailSettings: emailSettings,
            formSettings: formSettings
        }
    }, children);
const $c63493d716292494$export$2423d0186e859ed7 = ()=>(0, $eJOHy.useContext)($c63493d716292494$export$4c4cf33df5e3a573);

});

parcelRegister("24I12", function(module, exports) {
$parcel$export(module.exports, "useShareConfig", () => $28d7857b5d9d713c$export$8df29699b7259470);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $6YQhs = parcelRequire("6YQhs");

var $bYiRq = parcelRequire("bYiRq");

var $inc2L = parcelRequire("inc2L");
const $28d7857b5d9d713c$export$8df29699b7259470 = (shareClient, cloudId)=>{
    const [config, setConfig] = (0, $eJOHy.useState)('idle');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const lastFetchedAtRef = (0, $eJOHy.useRef)(null);
    const fetchConfig = (0, $eJOHy.useCallback)(async ()=>{
        /*
		The share dialog rendering experience in Platform was measured around
		the fetch config API call. This is being ported one-to-one to avoid breaking existing TOME alerts and dashboards.
		 */ (0, $inc2L.renderShareDialogExp).start();
        const startTime = Date.now();
        if (lastFetchedAtRef.current && Date.now() - lastFetchedAtRef.current < (0, $bYiRq.CACHE_TTL_MS)) {
            (0, $inc2L.renderShareDialogExp).success();
            return;
        }
        try {
            setConfig('fetching');
            const configResponse = await shareClient.getConfig(cloudId);
            createAnalyticsEvent((0, $6YQhs.shareConfigurationLoaded)({
                disableSharingToEmails: configResponse.disableSharingToEmails,
                durationMs: Date.now() - startTime
            })).fire((0, $6YQhs.CHANNEL_ID));
            (0, $inc2L.renderShareDialogExp).success();
            lastFetchedAtRef.current = Date.now();
            setConfig(configResponse);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $inc2L.renderShareDialogExp).abort();
            setConfig('error');
            createAnalyticsEvent((0, $6YQhs.shareConfigurationLoadFailed)({
                statusCode: error.code || error.status || error.statusCode,
                durationMs: Date.now() - startTime
            })).fire((0, $6YQhs.CHANNEL_ID));
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        shareClient
    ]);
    return {
        config: config,
        fetchConfig: fetchConfig
    };
};

});
parcelRegister("bYiRq", function(module, exports) {
$parcel$export(module.exports, "defaultShareContentState", () => $26e5d0f33332021b$export$4d9147e1bc6c176);
$parcel$export(module.exports, "CACHE_TTL_MS", () => $26e5d0f33332021b$export$eca93c456abcab01);
const $26e5d0f33332021b$export$4d9147e1bc6c176 = {
    users: [],
    comment: {
        format: 'plain_text',
        value: ''
    }
};
const $26e5d0f33332021b$export$eca93c456abcab01 = 120000; // 1 minute

});

parcelRegister("inc2L", function(module, exports) {
$parcel$export(module.exports, "isValidFailedExperience", () => $89f4d31c49ab307d$export$883079293b9cad76);
$parcel$export(module.exports, "renderShareDialogExp", () => $89f4d31c49ab307d$export$99c0383421ae57eb);
$parcel$export(module.exports, "shareSubmitExp", () => $89f4d31c49ab307d$export$31627ee726f40567);
$parcel$export(module.exports, "generateSelectZIndex", () => $89f4d31c49ab307d$export$eedd642610b90f47);
$parcel$export(module.exports, "getMenuPortalTargetCurrentHTML", () => $89f4d31c49ab307d$export$e3e96376b61c8ea);
$parcel$export(module.exports, "optionDataToUsers", () => $89f4d31c49ab307d$export$1c6fd61621efa6e2);
$parcel$export(module.exports, "allowEmails", () => $89f4d31c49ab307d$export$e3c57815dfd9a32c);
$parcel$export(module.exports, "resolveShareFooter", () => $89f4d31c49ab307d$export$6900a66855146901);
$parcel$export(module.exports, "getUniqueFormShareOriginTracing", () => $89f4d31c49ab307d$export$2b3c6eea41978039);
$parcel$export(module.exports, "getUniqueCopyLinkOriginTracing", () => $89f4d31c49ab307d$export$3c724bb159c3f615);
$parcel$export(module.exports, "memoizedFormatCopyLink", () => $89f4d31c49ab307d$export$3de1fa4df43b98ff);
$parcel$export(module.exports, "getIsOutgoingEmailDisabled", () => $89f4d31c49ab307d$export$f7da8da3045d5907);
$parcel$export(module.exports, "splitUsers", () => $89f4d31c49ab307d$export$7cac9ce217df8b49);

var $LFmXM = parcelRequire("LFmXM");

var $aRnO1 = parcelRequire("aRnO1");
var $2pMzV = parcelRequire("2pMzV");

var $IW7jS = parcelRequire("IW7jS");
const $89f4d31c49ab307d$var$ignoredErrorStatusCode = new Set([
    401,
    403,
    429
]);
const $89f4d31c49ab307d$export$883079293b9cad76 = (experience, // the type for error is 'any' because consumers of the share config can pass in custom error objects
// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>{
    const errorStatusCode = error.code || error.status || error.statusCode;
    if ($89f4d31c49ab307d$var$ignoredErrorStatusCode.has(parseInt(errorStatusCode, 10))) {
        experience.abort({
            metadata: {
                error: error
            }
        });
        return;
    }
    experience.failure({
        metadata: {
            error: error
        }
    });
};
const $89f4d31c49ab307d$export$99c0383421ae57eb = new (0, $2pMzV.UFOExperience)('render-share-dialog', {
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $89f4d31c49ab307d$export$31627ee726f40567 = new (0, $2pMzV.UFOExperience)('share-submit-action', {
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $89f4d31c49ab307d$export$ff1a1e5addedc4cc = 10;
const $89f4d31c49ab307d$export$eedd642610b90f47 = (dialogZIndex)=>{
    // If user provided non-number value for zIndex, ignore and return undefined,
    // which will default to `layers.layer()` inside PopUp
    if (typeof dialogZIndex !== 'number' || !dialogZIndex) return (0, $IW7jS.layers).modal() + $89f4d31c49ab307d$export$ff1a1e5addedc4cc;
    return dialogZIndex + $89f4d31c49ab307d$export$ff1a1e5addedc4cc;
};
const $89f4d31c49ab307d$export$e3e96376b61c8ea = (ref)=>{
    if (!ref) return null;
    if (!Object.prototype.hasOwnProperty.call(ref, 'current')) return null;
    // @ts-expect-error - Property 'current' does not exist on type '(instance: HTMLDivElement | null) => void'.ts(2339)
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ref.current;
};
const $89f4d31c49ab307d$export$1c6fd61621efa6e2 = (optionDataArray)=>optionDataArray.map((optionData)=>{
        switch(optionData.type){
            case 'email':
                {
                    const user = {
                        type: 'user',
                        email: optionData.id
                    };
                    return user;
                }
            case 'external_user':
                // When optionData.type is 'external_user', we need to convert it to 'user'
                // because 'external_user' isn't a valid type for the '/gateway/api/share' API.
                return {
                    type: 'user',
                    id: optionData.id
                };
            default:
                return {
                    type: optionData.type || 'user',
                    id: optionData.id
                };
        }
    });
const $89f4d31c49ab307d$export$e3c57815dfd9a32c = (config)=>!(config && config.disableSharingToEmails);
const $89f4d31c49ab307d$export$6900a66855146901 = (integrationMode, tabIndex, customFooter)=>{
    if (customFooter) {
        if (integrationMode !== 'tabs' || tabIndex === 0) return customFooter;
    }
};
const $89f4d31c49ab307d$export$2b3c6eea41978039 = (_link, originTracingFactory)=>{
    return originTracingFactory();
};
const $89f4d31c49ab307d$export$3c724bb159c3f615 = (0, $LFmXM.default)((_link, originTracingFactory)=>{
    return originTracingFactory();
});
const $89f4d31c49ab307d$export$3de1fa4df43b98ff = (0, $LFmXM.default)((origin, link)=>origin.addToUrl(link));
const $89f4d31c49ab307d$export$f7da8da3045d5907 = (settings)=>{
    if (settings.status === 'success') return settings.payload.emailSettings !== 'error' && !settings.payload.emailSettings?.enabled;
    return false;
};
const $89f4d31c49ab307d$export$7cac9ce217df8b49 = (users, canInvite)=>{
    const initialState = {
        usersToInvite: [],
        usersToShare: []
    };
    if (!canInvite) return {
        usersToInvite: [],
        usersToShare: users
    };
    return users.reduce((acc, user)=>{
        if (user.type === 'email') acc.usersToInvite.push(user);
        else acc.usersToShare.push(user);
        return acc;
    }, initialState);
};

});


parcelRegister("eQR3n", function(module, exports) {
$parcel$export(module.exports, "LoadingSpinner", () => $ecba59f9a04162ae$export$b08b517936747730);
/* LoadingSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $2sLVw = parcelRequire("2sLVw");
const $ecba59f9a04162ae$var$styles = {
    loadingContainer: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $ecba59f9a04162ae$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $ecba59f9a04162ae$var$styles.loadingContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        testId: "share-dialog.common.ui.loading",
        size: "medium"
    }));

});

parcelRegister("73pRz", function(module, exports) {
$parcel$export(module.exports, "useFetchSettings", () => $a54e0dd536265a59$export$1e09f4a4896688c8);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $gYnSx = parcelRequire("gYnSx");

var $cj27a = parcelRequire("cj27a");
const $a54e0dd536265a59$var$getHipaaComplianceStatus = ()=>(0, $jGzN3.performGetRequest)('/rest/internal/latest/compliance/status/HIPAA');
const $a54e0dd536265a59$var$getEmailSettings = ()=>(0, $jGzN3.performGetRequest)('/rest/jira-mail-plugin/1.0/outgoingMail/config');
const $a54e0dd536265a59$export$1e09f4a4896688c8 = ()=>{
    const callback = (0, $eJOHy.useCallback)(()=>Promise.allSettled([
            $a54e0dd536265a59$var$getHipaaComplianceStatus(),
            $a54e0dd536265a59$var$getEmailSettings()
        ]), []);
    const { fetch: fetch, status: status } = (0, $cj27a.useFetchWithCache)(callback, 'fetchSettings');
    const result = (0, $eJOHy.useMemo)(()=>{
        if (status === 'loading' || status === 'idle') return {
            status: 'loading',
            payload: undefined
        };
        // This should never happen but need to cater for type
        if (status === 'error') return {
            status: 'error',
            payload: undefined
        };
        const [hipaaResult, emailResult] = status;
        let shouldError = true;
        status.forEach((s)=>{
            if (s.status === 'rejected') {
                shouldError = shouldError && true;
                (0, $gYnSx.default)({
                    meta: {
                        id: 'fetchSettings',
                        packageName: 'jiraShareDialog',
                        teamName: 'jira-warepil'
                    },
                    error: new Error(s.reason)
                });
                return;
            }
            shouldError = shouldError && false;
        });
        if (shouldError) return {
            status: 'error',
            payload: undefined
        };
        return {
            status: 'success',
            payload: {
                hipaaComplianceStatus: hipaaResult.status === 'fulfilled' ? hipaaResult.value : 'error',
                emailSettings: emailResult.status === 'fulfilled' ? emailResult.value : 'error'
            }
        };
    }, [
        status
    ]);
    return {
        fetch: fetch,
        result: result
    };
};

});
parcelRegister("cj27a", function(module, exports) {
$parcel$export(module.exports, "useFetchWithCache", () => $fbcfd4edabcb7c18$export$a6289a05eb4f6cf3);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $bYiRq = parcelRequire("bYiRq");
const $fbcfd4edabcb7c18$export$a6289a05eb4f6cf3 = (callback, id)=>{
    const lastFetchedAtRef = (0, $eJOHy.useRef)(null);
    const [status, setStatus] = (0, $eJOHy.useState)('idle');
    const fetch = (0, $eJOHy.useCallback)(async ()=>{
        // Skip if cached, not fetching and was successful recently and not stale
        if (lastFetchedAtRef.current && Date.now() - lastFetchedAtRef.current < (0, $bYiRq.CACHE_TTL_MS)) return;
        setStatus('loading');
        lastFetchedAtRef.current = Date.now();
        try {
            const data = await callback();
            if (data === undefined || data === null) {
                // nothing came back, mark as error and clear cache
                setStatus('error');
                lastFetchedAtRef.current = null;
                return;
            }
            setStatus(data);
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: id,
                    packageName: 'jiraShareDialog',
                    teamName: 'jira-warepil'
                },
                error: error instanceof Error ? error : new Error(`Unknown error while fetching ${id}`)
            });
            setStatus('error');
            lastFetchedAtRef.current = null;
        }
    }, [
        callback,
        id
    ]);
    return {
        status: status,
        fetch: fetch
    };
};

});


parcelRegister("03gWs", function(module, exports) {
$parcel$export(module.exports, "getUserRoles", () => $afe161fd94baf38f$export$2c9de0a1c6b83fdc);
$parcel$export(module.exports, "useFetchExtendedDialogData", () => $afe161fd94baf38f$export$570dcca53ef1d5e0);

var $eJOHy = parcelRequire("eJOHy");

var $2aY2d = parcelRequire("2aY2d");

var $jGzN3 = parcelRequire("jGzN3");

var $cj27a = parcelRequire("cj27a");
const $afe161fd94baf38f$var$getProjectAccessLevels = async ()=>{
    return (0, $jGzN3.performGetRequest)('/rest/internal/simplified/1.0/accesslevel?projectType=software');
};
const $afe161fd94baf38f$export$2c9de0a1c6b83fdc = (projectKey)=>{
    if (!projectKey) throw new Error('Project Key is required to fetch user roles');
    return (0, $jGzN3.performGetRequest)(`/rest/api/3/project/${projectKey}/roledetails?excludeConnectAddons=true`);
};
const $afe161fd94baf38f$var$getProjectAccessLevel = async (projectId)=>{
    if (!projectId) throw new Error('Project ID is missing while fetching project access level.');
    return (0, $jGzN3.performGetRequest)(`/rest/internal/simplified/1.0/accesslevel/project/${projectId}`);
};
const $afe161fd94baf38f$export$570dcca53ef1d5e0 = ()=>{
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const callback = (0, $eJOHy.useCallback)(()=>Promise.all([
            $afe161fd94baf38f$var$getProjectAccessLevels(),
            $afe161fd94baf38f$export$2c9de0a1c6b83fdc(projectContext?.projectKey),
            $afe161fd94baf38f$var$getProjectAccessLevel(projectContext?.projectId)
        ]), [
        projectContext?.projectId,
        projectContext?.projectKey
    ]);
    return (0, $cj27a.useFetchWithCache)(callback, 'fetchExtendedDialogData');
};

});

parcelRegister("7y4xb", function(module, exports) {
$parcel$export(module.exports, "shareDialogLoadingExp", () => $5a9f565d8142a59f$export$ef5dc6a8cef2cf82);
$parcel$export(module.exports, "useShareDialogLoadingSuccess", () => $5a9f565d8142a59f$export$9a6055bc939da026);

var $eJOHy = parcelRequire("eJOHy");

var $aRnO1 = parcelRequire("aRnO1");
var $2pMzV = parcelRequire("2pMzV");
const $5a9f565d8142a59f$export$ef5dc6a8cef2cf82 = new (0, $2pMzV.UFOExperience)('render-jira-share-dialog', {
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
});
const $5a9f565d8142a59f$export$9a6055bc939da026 = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        $5a9f565d8142a59f$export$ef5dc6a8cef2cf82.success();
    }, []);
};

});

parcelRegister("4XK86", function(module, exports) {
$parcel$export(module.exports, "default", () => $b22af82f526b7ff7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b22af82f526b7ff7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    shareTriggerButtonText: {
        "id": "jira.share-dialog.trigger-button-text",
        "defaultMessage": "Share"
    },
    shareTriggerButtonTooltipText: {
        "id": "jira.share-dialog.trigger-button-tooltip-text",
        "defaultMessage": "Share"
    },
    sharePopupLabel: {
        "id": "jira.share-dialog.popup-label",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("7ZqTj", function(module, exports) {
$parcel$export(module.exports, "ShareButton", () => $4d880c3ab190eb5c$export$e980dfbc2840e8bc);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
const $4d880c3ab190eb5c$export$e980dfbc2840e8bc = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ text: text, 'aria-haspopup': _ariaHasPopup, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        id: "share-trigger-btn",
        // TODO: update to correct test id during fg (move_share_dialog_to_jira) cleanup
        // Temporarily keeping this test ID aligned with pre-share-view
        // so existing issue view Cypress tests still run and ensure our migration
        // is not breaking anything.
        // On cleanup, update all related test IDs under:
        //   - jira/src/packages/issue/page-objects
        //   - jira/src/packages/issue/playwright-page-objects
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "share-button.ui.pre-share-view.button",
        ref: ref,
        "aria-haspopup": "dialog",
        ...props
    }, text);
});

});


parcelRegister("clti7", function(module, exports) {
$parcel$export(module.exports, "createAri", () => $26581c6958877359$export$594d18a0ad2e0e57);
const $26581c6958877359$var$getAriResourceOwner = (subProductId)=>{
    switch(subProductId){
        // these options aren't currently valid resource owners
        case 'jira-addon':
        case 'jira-platform':
        case 'jira-polaris':
        case 'jira-portfolio':
        case 'jira-unknown':
            return 'jira';
        // being explicit that these 3 are valid and were not forgotten
        case 'jira-core':
        case 'jira-servicedesk':
        case 'jira-software':
        default:
            return subProductId;
    }
};
const $26581c6958877359$export$594d18a0ad2e0e57 = (subProductId, cloudId)=>`ari:cloud:${$26581c6958877359$var$getAriResourceOwner(subProductId)}::site/${cloudId}`;

});

parcelRegister("hMZQ4", function(module, exports) {
$parcel$export(module.exports, "LegacyShareClient", () => $864b5a99340e87a8$export$8d1e97acf6765201);

var $1kFb3 = parcelRequire("1kFb3");

var $2vkDT = parcelRequire("2vkDT");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
class $864b5a99340e87a8$export$8d1e97acf6765201 extends (0, $2vkDT.ShareServiceClient) {
    constructor({ getShareEndpoint: getShareEndpoint, getSharePayload: getSharePayload }){
        super(), this.categorizeRecipients = (recipients)=>{
            const accumulator = {
                userIds: [],
                emails: []
            };
            return recipients.reduce((acc, recipient)=>{
                if (recipient.type === 'user') {
                    // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    if (recipient.email !== undefined) // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    acc.emails.push(recipient.email);
                    else if (recipient.id !== undefined) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'User'.
                    acc.userIds.push(recipient.id);
                }
                return acc;
            }, accumulator);
        };
        this.getShareEndpoint = getShareEndpoint;
        this.getSharePayload = getSharePayload;
    }
    share(content, recipients, metadata, comment) {
        const categorizedRecipients = this.categorizeRecipients(recipients);
        const shareRequest = {
            usernames: categorizedRecipients.userIds,
            emails: categorizedRecipients.emails,
            message: comment?.value || '',
            atlOrigin: new (0, $1kFb3.default)({
                id: metadata.atlOriginId,
                product: 'jira'
            }).encode(),
            ...this.getSharePayload ? this.getSharePayload(content) : null
        };
        return (0, $jGzN3.performPostRequest)(this.getShareEndpoint(content), {
            body: JSON.stringify(shareRequest)
        }).catch((error)=>{
            (0, $gYnSx.default)({
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                meta: {
                    packageName: 'jiraShareButton',
                    id: 'LegacyShareClient.share'
                },
                attributes: {
                    contentType: content.type
                }
            });
            throw error;
        });
    }
}

});

parcelRegister("6KHqk", function(module, exports) {
$parcel$export(module.exports, "LegacyShareClientOld", () => $6a5b0f60881a5bc9$export$32432a2063c4d58c);

var $1kFb3 = parcelRequire("1kFb3");

var $1dYNL = parcelRequire("1dYNL");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
class $6a5b0f60881a5bc9$export$32432a2063c4d58c extends (0, $1dYNL.ShareServiceClient) {
    constructor({ getShareEndpoint: getShareEndpoint, getSharePayload: getSharePayload }){
        super(), this.categorizeRecipients = (recipients)=>{
            const accumulator = {
                userIds: [],
                emails: []
            };
            return recipients.reduce((acc, recipient)=>{
                if (recipient.type === 'user') {
                    // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    if (recipient.email !== undefined) // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    acc.emails.push(recipient.email);
                    else if (recipient.id !== undefined) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'User'.
                    acc.userIds.push(recipient.id);
                }
                return acc;
            }, accumulator);
        };
        this.getShareEndpoint = getShareEndpoint;
        this.getSharePayload = getSharePayload;
    }
    share(content, recipients, metadata, comment) {
        const categorizedRecipients = this.categorizeRecipients(recipients);
        const shareRequest = {
            usernames: categorizedRecipients.userIds,
            emails: categorizedRecipients.emails,
            message: comment?.value || '',
            atlOrigin: new (0, $1kFb3.default)({
                id: metadata.atlOriginId,
                product: 'jira'
            }).encode(),
            ...this.getSharePayload ? this.getSharePayload(content) : null
        };
        return (0, $jGzN3.performPostRequest)(this.getShareEndpoint(content), {
            body: JSON.stringify(shareRequest)
        }).catch((error)=>{
            (0, $gYnSx.default)({
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                meta: {
                    packageName: 'jiraShareButton',
                    id: 'LegacyShareClient.share'
                },
                attributes: {
                    contentType: content.type
                }
            });
            throw error;
        });
    }
}

});

parcelRegister("4iD6p", function(module, exports) {
$parcel$export(module.exports, "loadUsers", () => $00b6f649e538aa51$export$2c3a8e05396a78be);
// @ts-expect-error - TS2305 - Module '"'@atlassian/jira-share-dialog"' has no exported member 'OptionData'.

var $1Ozm9 = parcelRequire("1Ozm9");
const $00b6f649e538aa51$var$USER_PICKER_LIMIT = 20;
const $00b6f649e538aa51$export$2c3a8e05396a78be = async (searchText = '')=>{
    const searchTextEncoded = encodeURIComponent(searchText);
    const url = `/rest/api/3/groupuserpicker?maxResults=${$00b6f649e538aa51$var$USER_PICKER_LIMIT}&query=${searchTextEncoded}&showAvatar=true&avatarSize=medium&excludeConnectAddons=true`;
    const groupsAndUsers = await (0, $1Ozm9.default)(url);
    return groupsAndUsers.users.users.filter((user)=>user.accountType === 'atlassian').map((user)=>({
            type: 'user',
            id: user.accountId,
            name: user.displayName,
            avatarUrl: user.avatarUrl
        }));
};

});
parcelRegister("1Ozm9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ce52bb22689abcd$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $1oMOM = parcelRequire("1oMOM");

var $1uIew = parcelRequire("1uIew");

var $i4YfB = parcelRequire("i4YfB");

var $3WOLx = parcelRequire("3WOLx");

var $7AheX = parcelRequire("7AheX");
/**
 * Fetch from the given URL, returning the json response.
 * <p>
 * If there are any HTTP errors the promise is rejected with a {@link FetchError}.
 *
 * @param url - to fetch the JSON from
 * @param options - for the fetch call
 * @returns promise containing the JSON
 * @throws {@link FetchError} if there was an HTTP Error. This will reject the promise.
 */ // the `@typescript-eslint/no-unnecessary-type-constraint` rule is disabled because otherwise syntax highlighting breaks with a trailing comma,
// other rules should be fixed ideally.
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unnecessary-type-constraint
const $7ce52bb22689abcd$var$fetchJson = (url, options = {})=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, (0, $iWqim.merge)((0, $1oMOM.defaultOptions), options))).then((response)=>{
        if (!response.ok) {
            const traceId = (0, $7AheX.getTraceId)(response);
            if (traceId !== undefined && traceId.length > 0) throw new (0, $1uIew.default)(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new (0, $1uIew.default)(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.json();
    });
var $7ce52bb22689abcd$export$2e2bcd8739ae039 = $7ce52bb22689abcd$var$fetchJson;

});


parcelRegister("9Ag4n", function(module, exports) {
$parcel$export(module.exports, "UserRole", () => $9fd45915fb5c85e5$export$eb3485a690c2f0b8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");
var $c4OV1 = parcelRequire("c4OV1");

var $6svxr = parcelRequire("6svxr");
var $byJNH = parcelRequire("byJNH");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");
const $9fd45915fb5c85e5$var$styles = {
    userRoleSelect: "_16jlkb7n _i0dlidpf _1ul91obz _ca0qv47k _19pkv77o"
};
const $9fd45915fb5c85e5$var$messages = (0, $7qGN1.defineMessages)({
    userRoleLabel: {
        "id": "share-button.user-role.user-role-label",
        "defaultMessage": "User role"
    }
});
const $9fd45915fb5c85e5$var$SelectOption = ({ children: children, ...props })=>{
    const { data: data, isSelected: isSelected } = props;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "medium",
        color: isSelected ? 'color.text.selected' : undefined
    }, data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "small",
        color: "color.text.subtle"
    }, data.description)));
};
const $9fd45915fb5c85e5$var$getDefaultUserRole = (userRoleOptions)=>userRoleOptions.find((role)=>role.default) || userRoleOptions[0];
const $9fd45915fb5c85e5$export$eb3485a690c2f0b8 = ({ accessLevel: accessLevel, roles: roles, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formData = (0, $byJNH.useFormState)({
        values: true
    });
    const shouldShowUserRole = (0, $eJOHy.useMemo)(()=>{
        const projectAccessLevel = formData?.values.projectAccessLevel?.value || accessLevel;
        return roles.length > 0 && projectAccessLevel && projectAccessLevel !== 'OPEN';
    }, [
        accessLevel,
        formData?.values.projectAccessLevel?.value,
        roles.length
    ]);
    const userRoleOptions = (0, $eJOHy.useMemo)(()=>roles.map((role)=>({
                label: role.name,
                value: role.id,
                description: role.description,
                default: role.default || false
            })), [
        roles
    ]);
    const [currentUserRole, setCurrentUserRole] = (0, $eJOHy.useState)($9fd45915fb5c85e5$var$getDefaultUserRole(userRoleOptions));
    (0, $eJOHy.useEffect)(()=>{
        if (!currentUserRole && userRoleOptions.length > 0) // If currentUserRole is not set, we set it to the default role from options.
        // This happens when the component is rendered before userRoleOptions are fetched.
        setCurrentUserRole($9fd45915fb5c85e5$var$getDefaultUserRole(userRoleOptions));
    }, [
        currentUserRole,
        userRoleOptions
    ]);
    if (!shouldShowUserRole) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: "userRole",
        defaultValue: currentUserRole
    }, ({ fieldProps: { onChange: onChange, value: value, ...fieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            xcss: $9fd45915fb5c85e5$var$styles.userRoleSelect
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
            ...fieldProps,
            isLoading: isLoading,
            options: userRoleOptions,
            value: currentUserRole,
            onChange: (userRoleOption)=>{
                if (!userRoleOption) return;
                onChange(userRoleOption);
                setCurrentUserRole(userRoleOption);
            },
            label: formatMessage($9fd45915fb5c85e5$var$messages.userRoleLabel),
            components: {
                Option: $9fd45915fb5c85e5$var$SelectOption
            },
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999
                    }),
                control: (base)=>({
                        ...base,
                        minHeight: '44px',
                        height: '100%',
                        width: '100%'
                    }),
                singleValue: (base)=>({
                        ...base,
                        color: "var(--ds-text, #172B4D)"
                    }),
                menu: (base)=>({
                        ...base,
                        width: 'fit-content',
                        position: 'absolute',
                        right: 0
                    }),
                option: (base)=>({
                        ...base,
                        width: '320px'
                    })
            },
            menuPortalTarget: globalThis.document.body
        })));
};

});
parcelRegister("6svxr", function(module, exports) {
$parcel$export(module.exports, "default", () => $b792a43640ff13ce$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gl2vi = parcelRequire("gl2vi");

var $h8JmM = parcelRequire("h8JmM");

var $3L3Os = parcelRequire("3L3Os");

var $cDJ0f = parcelRequire("cDJ0f");

var $fKXve = parcelRequire("fKXve");

var $lP4Q7 = parcelRequire("lP4Q7");
const $b792a43640ff13ce$var$fieldWrapperStyles = null;
function $b792a43640ff13ce$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $b792a43640ff13ce$var$isFunction(x) {
    return typeof x === 'function';
}
function $b792a43640ff13ce$var$usePreviousRef(current) {
    const ref = (0, $eJOHy.useRef)(current);
    // will be updated on the next render
    (0, $eJOHy.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $b792a43640ff13ce$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $b792a43640ff13ce$export$2e2bcd8739ae039(props) {
    const { children: children = ()=>null, component: component } = props;
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eJOHy.useContext)((0, $3L3Os.FormContext));
    const isDisabled = (0, $eJOHy.useContext)((0, $3L3Os.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $b792a43640ff13ce$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $b792a43640ff13ce$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$b792a43640ff13ce$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eJOHy.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $b792a43640ff13ce$var$usePreviousRef(state);
    (0, $eJOHy.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $b792a43640ff13ce$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($b792a43640ff13ce$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $gl2vi.useId)();
    const fieldId = (0, $eJOHy.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $hcewu.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $cDJ0f.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lP4Q7.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8JmM.FieldId).Provider, {
                value: fieldId,
                children: component ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: [
                        component({
                            fieldProps: extendedFieldProps
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fKXve.MessageWrapper), {
                            children: [
                                props.helperMessage && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.HelperMessage), {
                                    children: props.helperMessage
                                }),
                                state.error && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                                    children: props.errorMessage || state.error
                                }),
                                state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ValidMessage), {
                                    children: props.validMessage
                                })
                            ]
                        })
                    ]
                }) : children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("h8JmM", function(module, exports) {
$parcel$export(module.exports, "FieldId", () => $32369bd40dc5a2d5$export$3c4232819458a302);

var $eJOHy = parcelRequire("eJOHy");
const $32369bd40dc5a2d5$export$3c4232819458a302 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);

});

parcelRegister("3L3Os", function(module, exports) {
$parcel$export(module.exports, "FormContext", () => $b42d4fbe800f0292$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $b42d4fbe800f0292$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $b42d4fbe800f0292$export$2e2bcd8739ae039);
/* form.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kOCbD = parcelRequire("kOCbD");

var $dPWTT = parcelRequire("dPWTT");

var $d3vFW = parcelRequire("d3vFW");

var $immLL = parcelRequire("immLL");

var $gyJTO = parcelRequire("gyJTO");

var $eGOwo = parcelRequire("eGOwo");

var $lcsDn = parcelRequire("lcsDn");
const $b42d4fbe800f0292$export$c24727297075ec6a = /*#__PURE__*/ (0, $eJOHy.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $b42d4fbe800f0292$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $b42d4fbe800f0292$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $eJOHy.useRef)(null);
    const onSubmitRef = (0, $eJOHy.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $eJOHy.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $kOCbD.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(values, name, value);
                    }
                }
            }
        });
        (0, $dPWTT.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $eGOwo.fg)('platform-form-field-error-focus') ? (0, $lcsDn.getFirstErrorField) : undefined)(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eJOHy.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eJOHy.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ const getCurrentValue = (0, $eJOHy.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eJOHy.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    };
    // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $gyJTO.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                ...(0, $eGOwo.fg)('platform-form-reset-field-state') && {
                    resetFieldState: form.resetFieldState
                }
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, $gt9Am.jsx)("form", {
            ...formProps,
            ...userProvidedFormProps,
            children: children
        });
    })();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b42d4fbe800f0292$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($b42d4fbe800f0292$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $b42d4fbe800f0292$var$Form = (0, $immLL.default)($b42d4fbe800f0292$var$FormBase);
var $b42d4fbe800f0292$export$2e2bcd8739ae039 = $b42d4fbe800f0292$var$Form;

});
parcelRegister("kOCbD", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $f276193df2f288e0$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f276193df2f288e0$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f276193df2f288e0$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f276193df2f288e0$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f276193df2f288e0$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f276193df2f288e0$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f276193df2f288e0$export$f681a8129d2e9d28);

var $fpB9r = parcelRequire("fpB9r");

var $2unhp = parcelRequire("2unhp");
//      
var $f276193df2f288e0$var$charCodeOfDot = ".".charCodeAt(0);
var $f276193df2f288e0$var$reEscapeChar = /\\(\\)?/g;
var $f276193df2f288e0$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f276193df2f288e0$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f276193df2f288e0$var$charCodeOfDot) result.push("");
    string.replace($f276193df2f288e0$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f276193df2f288e0$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f276193df2f288e0$var$keysCache = {};
var $f276193df2f288e0$var$keysRegex = /[.[\]]+/;
var $f276193df2f288e0$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f276193df2f288e0$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f276193df2f288e0$var$keysCache[key] = key.split($f276193df2f288e0$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f276193df2f288e0$var$keysCache[key] = $f276193df2f288e0$var$stringToPath(key);
    }
    return $f276193df2f288e0$var$keysCache[key];
};
//      
var $f276193df2f288e0$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f276193df2f288e0$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f276193df2f288e0$var$_toPropertyKey(arg) {
    var key = $f276193df2f288e0$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f276193df2f288e0$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f276193df2f288e0$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $2unhp.default)(current, [
                key
            ].map($f276193df2f288e0$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $fpB9r.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f276193df2f288e0$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f276193df2f288e0$var$setInRecursor(state, 0, $f276193df2f288e0$var$toPath(key), value1, destroyArrays);
};
var $f276193df2f288e0$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f276193df2f288e0$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f276193df2f288e0$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f276193df2f288e0$export$c52e5867d5879e24(values, name);
    var error = $f276193df2f288e0$export$c52e5867d5879e24(errors, name);
    if (error && error[$f276193df2f288e0$export$735bebc8ffabf28a]) error = error[$f276193df2f288e0$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f276193df2f288e0$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f276193df2f288e0$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f276193df2f288e0$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f276193df2f288e0$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f276193df2f288e0$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f276193df2f288e0$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f276193df2f288e0$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f276193df2f288e0$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f276193df2f288e0$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f276193df2f288e0$var$subscriptionFilter(result, state, previousState, subscription, $f276193df2f288e0$export$41e855cb628c1b55, $f276193df2f288e0$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f276193df2f288e0$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f276193df2f288e0$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f276193df2f288e0$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f276193df2f288e0$var$subscriptionFilter(result, state, previousState, subscription, $f276193df2f288e0$export$f1ff97b9d1c7a3c3, $f276193df2f288e0$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f276193df2f288e0$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f276193df2f288e0$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f276193df2f288e0$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f276193df2f288e0$export$83d89fbfd8236492 = "4.20.10";
var $f276193df2f288e0$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f276193df2f288e0$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f276193df2f288e0$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f276193df2f288e0$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f276193df2f288e0$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f276193df2f288e0$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f276193df2f288e0$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f276193df2f288e0$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f276193df2f288e0$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f276193df2f288e0$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $fpB9r.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $fpB9r.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $fpB9r.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $fpB9r.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $fpB9r.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f276193df2f288e0$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f276193df2f288e0$export$e6bdf135a54e021b,
                    shallowEqual: $f276193df2f288e0$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $fpB9r.default)({}, state.formState.values)); // clone to avoid writing
            if ($f276193df2f288e0$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f276193df2f288e0$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f276193df2f288e0$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $fpB9r.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $fpB9r.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f276193df2f288e0$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f276193df2f288e0$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f276193df2f288e0$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f276193df2f288e0$export$735bebc8ffabf28a]) {
                    var existing = $f276193df2f288e0$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f276193df2f288e0$export$735bebc8ffabf28a] = error[$f276193df2f288e0$export$735bebc8ffabf28a];
                    merged = $f276193df2f288e0$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f276193df2f288e0$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f276193df2f288e0$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $fpB9r.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f276193df2f288e0$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f276193df2f288e0$var$notify(fieldSubscriber, fieldState, lastFieldState, $f276193df2f288e0$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f276193df2f288e0$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $fpB9r.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f276193df2f288e0$export$c52e5867d5879e24(formState.values, key), $f276193df2f288e0$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f276193df2f288e0$export$c52e5867d5879e24(formState.values, key), $f276193df2f288e0$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f276193df2f288e0$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f276193df2f288e0$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f276193df2f288e0$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f276193df2f288e0$var$notify(state.subscribers, nextFormState, lastFormState, $f276193df2f288e0$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $fpB9r.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f276193df2f288e0$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $fpB9r.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $fpB9r.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f276193df2f288e0$export$c52e5867d5879e24(formState.values, key), $f276193df2f288e0$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f276193df2f288e0$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f276193df2f288e0$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f276193df2f288e0$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, name) === $f276193df2f288e0$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f276193df2f288e0$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $fpB9r.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $fpB9r.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $fpB9r.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f276193df2f288e0$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f276193df2f288e0$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $fpB9r.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f276193df2f288e0$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f276193df2f288e0$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f276193df2f288e0$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f276193df2f288e0$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("dPWTT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a12dba3049b97319$export$2e2bcd8739ae039);

var $kOCbD = parcelRequire("kOCbD");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $a12dba3049b97319$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $a12dba3049b97319$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($a12dba3049b97319$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $a12dba3049b97319$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $kOCbD.getIn)(errors, input.name);
    });
};
//      
var $a12dba3049b97319$var$noop = function noop() {};
var $a12dba3049b97319$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $a12dba3049b97319$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $a12dba3049b97319$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $a12dba3049b97319$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $a12dba3049b97319$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($a12dba3049b97319$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$a12dba3049b97319$export$2e2bcd8739ae039 = $a12dba3049b97319$var$createDecorator;

});

parcelRegister("d3vFW", function(module, exports) {

var $j4TC7 = parcelRequire("j4TC7");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $981420477fbe9257$var$set(object, path, value) {
    return object == null ? object : $j4TC7(object, path, value);
}
module.exports = $981420477fbe9257$var$set;

});

parcelRegister("lcsDn", function(module, exports) {
$parcel$export(module.exports, "getFirstErrorField", () => $f9eb62dae4e2689c$export$fc06342dc8588d3b);

var $kOCbD = parcelRequire("kOCbD");
const $f9eb62dae4e2689c$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $kOCbD.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $kOCbD.getIn)(errors, input.name);
    });
};

});


parcelRegister("cDJ0f", function(module, exports) {
$parcel$export(module.exports, "Label", () => $ed0e34f34427bb25$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $ed0e34f34427bb25$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $ed0e34f34427bb25$var$fieldsetLabelStyles = null;
const $ed0e34f34427bb25$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $ed0e34f34427bb25$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("legend", {
        className: (0, $hcewu.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("fKXve", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", () => $d60bc96267cb44d2$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $d60bc96267cb44d2$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $d60bc96267cb44d2$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $d60bc96267cb44d2$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1NG86 = parcelRequire("1NG86");

var $i9bjW = parcelRequire("i9bjW");

var $eGOwo = parcelRequire("eGOwo");

var $h8JmM = parcelRequire("h8JmM");
const $d60bc96267cb44d2$var$messageStyles = null;
const $d60bc96267cb44d2$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
const $d60bc96267cb44d2$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $d60bc96267cb44d2$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            $d60bc96267cb44d2$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $d60bc96267cb44d2$var$messageIcons = {
    error: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i9bjW))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
const $d60bc96267cb44d2$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $d60bc96267cb44d2$var$messageIcons[appearance];
    const { isWrapper: isWrapper } = (0, $eJOHy.useContext)($d60bc96267cb44d2$var$MessageWrapperContext);
    const [shouldRenderAfterDelay, setShouldRenderAfterDelay] = (0, $eJOHy.useState)(false);
    // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
    const isDelayRenderEnabled = (0, $eGOwo.fg)('platform_dst_form_screenreader_message_fix') && !isWrapper;
    (0, $eJOHy.useEffect)(()=>{
        if (isDelayRenderEnabled) {
            // Only delay rendering if there is no wrapper and feature flag is enabled
            const timer = setTimeout(()=>{
                setShouldRenderAfterDelay(true);
            }, 10);
            return ()=>clearTimeout(timer);
        }
    }, [
        isDelayRenderEnabled
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        children: children
    });
    const childrenToRender = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            icon && /*#__PURE__*/ (0, $gt9Am.jsx)($d60bc96267cb44d2$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        id: fieldId,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
        "aria-live": !isWrapper ? 'polite' : undefined,
        className: (0, $hcewu.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $d60bc96267cb44d2$var$messageAppearanceStyles[appearance]
        ]),
        children: isDelayRenderEnabled ? shouldRenderAfterDelay && childrenToRender : childrenToRender
    });
};
const $d60bc96267cb44d2$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8JmM.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $gt9Am.jsx)($d60bc96267cb44d2$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $d60bc96267cb44d2$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8JmM.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $gt9Am.jsx)($d60bc96267cb44d2$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $d60bc96267cb44d2$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8JmM.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $gt9Am.jsx)($d60bc96267cb44d2$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $d60bc96267cb44d2$var$MessageWrapperContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isWrapper: false
});
const $d60bc96267cb44d2$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d60bc96267cb44d2$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});
parcelRegister("i9bjW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::849e146248de3896aa5effb6cb325c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d361d947cb810d1b$var$_react = $d361d947cb810d1b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d361d947cb810d1b$var$_statusSuccess = $d361d947cb810d1b$var$_interopRequireDefault((parcelRequire("3wl9L")));

var $d361d947cb810d1b$var$_success = $d361d947cb810d1b$var$_interopRequireDefault((parcelRequire("6BeTe")));
function $d361d947cb810d1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d361d947cb810d1b$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $d361d947cb810d1b$var$_react.default.createElement($d361d947cb810d1b$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $d361d947cb810d1b$var$_success.default
    }, props));
$d361d947cb810d1b$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $d361d947cb810d1b$var$_default = module.exports.default = $d361d947cb810d1b$var$StatusSuccessIcon;

});
parcelRegister("6BeTe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ce1bf91d97a4ffd$var$_react = $4ce1bf91d97a4ffd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4ce1bf91d97a4ffd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4ce1bf91d97a4ffd$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $4ce1bf91d97a4ffd$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$4ce1bf91d97a4ffd$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $4ce1bf91d97a4ffd$var$_default = module.exports.default = $4ce1bf91d97a4ffd$var$EditorSuccessIcon;

});



parcelRegister("lP4Q7", function(module, exports) {
$parcel$export(module.exports, "default", () => $f003b759d66377bb$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f003b759d66377bb$var$requiredIndicatorStyles = null;
function $f003b759d66377bb$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $hcewu.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("byJNH", function(module, exports) {
$parcel$export(module.exports, "useFormState", () => $43f7cff3f66357ce$export$606f11b2eb45ecc6);

var $eJOHy = parcelRequire("eJOHy");

var $3L3Os = parcelRequire("3L3Os");
// Constantized to avoid a new object reference built every call
const $43f7cff3f66357ce$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $43f7cff3f66357ce$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $43f7cff3f66357ce$export$606f11b2eb45ecc6 = (subscriptionConfig = $43f7cff3f66357ce$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $eJOHy.useContext)((0, $3L3Os.FormContext));
    const [state, setState] = (0, $eJOHy.useState)();
    /**
	 * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
	 * We avoid computing the hash if the subscription config has referential equality altogether.
	 */ const subscriptionConfigHash = (0, $eJOHy.useMemo)(()=>$43f7cff3f66357ce$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
	 * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
	 * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
	 * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
	 */ const config = (0, $eJOHy.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});


parcelRegister("P3eqi", function(module, exports) {
$parcel$export(module.exports, "CustomShareSubmitButton", () => $6f752f2f09404e22$export$acf0d09f1a6f345b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $byJNH = parcelRequire("byJNH");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");

var $k71qx = parcelRequire("k71qx");

var $1NG86 = parcelRequire("1NG86");

var $5CSKW = parcelRequire("5CSKW");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");
const $6f752f2f09404e22$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    formSharePublic: {
        "id": "share-button.custom-share-submit.form-share-public",
        "defaultMessage": "Share public link"
    },
    formSendPublic: {
        "id": "share-button.custom-share-submit.form-send-public",
        "defaultMessage": "Send public link"
    },
    formSave: {
        "id": "share-button.custom-share-submit.form-save",
        "defaultMessage": "Save"
    },
    formShare: {
        "id": "share-button.custom-share-submit.form-share",
        "defaultMessage": "Share"
    },
    formRetry: {
        "id": "share-button.custom-share-submit.form-retry",
        "defaultMessage": "Retry"
    },
    shareFailureMessage: {
        "id": "share-button.custom-share-submit.share-failure-message",
        "defaultMessage": "Unable to share"
    },
    shareFailureIconLabel: {
        "id": "share-button.custom-share-submit.share-failure-icon-label",
        "defaultMessage": "Error icon"
    }
});
const $6f752f2f09404e22$var$styles = {
    submitButtonWrapper: "_1e0c1txw _18u01wug",
    centerAlignedIconWrapper: "_1rjcze3t _18zrutpp _1e0c1txw _1wpz1h6o"
};
const $6f752f2f09404e22$export$acf0d09f1a6f345b = ({ isPublicLink: isPublicLink = false, shareError: shareError, isSharing: isSharing = false, isDisabled: isDisabled = false, isSubmitShareDisabled: isSubmitShareDisabled = false, integrationMode: integrationMode, submitButtonLabel: submitButtonLabel })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formData = (0, $byJNH.useFormState)({
        dirtyFields: true,
        values: true
    });
    const [shouldShowButton, setShouldShowButton] = (0, $eJOHy.useState)(false); // We use `useLayoutEffect` to ensure we show/hide the button before the button text is updated to avoid content flickering
    (0, $eJOHy.useLayoutEffect)(()=>{
        // If the form has not provided any state, we don't do anything
        if (!formData) return;
         /**
       * We hide the submit button based on 2 fields:
       * - User picker field
       * - Project access level field (provided by consumers)
       *
       * If both are unchanged, we hide the submit button.
       */ 
        const userPickerValues = formData?.values.users;
        if (userPickerValues?.length > 0 || formData?.dirtyFields?.projectAccessLevel) setShouldShowButton(true);
        else setShouldShowButton(false);
    }, [
        formData
    ]);
    const isRetryableError = !!shareError?.retryable;
    const isNonRetryableError = shareError && !shareError.retryable;
    const shouldShowWarning = isRetryableError && !isSharing;
    const buttonAppearance = !shouldShowWarning ? 'primary' : 'warning';
    const tabMode = integrationMode === 'tabs';
    const formPublicLabel = tabMode ? $6f752f2f09404e22$export$defe85febe8b728c.formSharePublic : $6f752f2f09404e22$export$defe85febe8b728c.formSendPublic;
    const formSendLabel = (0, $eJOHy.useMemo)(()=>{
        /**
     * We change the submit button label based on 2 fields:
     * - User picker field
     * - Project access level field (provided by consumers)
     *
     * If the project access level field is changed but the user picker field is pristine, we show a `Save` button.
     * If the user picker field is changed, we show a `Share` button.
     */ const userPickerValues = formData?.values?.users;
        if (userPickerValues && userPickerValues.length > 0) return $6f752f2f09404e22$export$defe85febe8b728c.formShare;
        return $6f752f2f09404e22$export$defe85febe8b728c.formSave;
    }, [
        formData?.values.users
    ]);
    const sendLabel = isPublicLink ? formPublicLabel : formSendLabel;
    const buttonLabel = isRetryableError ? $6f752f2f09404e22$export$defe85febe8b728c.formRetry : sendLabel;
    const buttonDisabled = isDisabled || isNonRetryableError || isSubmitShareDisabled;
    const ButtonLabelWrapper = buttonAppearance === 'warning' ? 'strong' : (0, $eJOHy.Fragment);
    if (!shouldShowButton) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $6f752f2f09404e22$var$styles.submitButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $6f752f2f09404e22$var$styles.centerAlignedIconWrapper
    }, shouldShowWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage($6f752f2f09404e22$export$defe85febe8b728c.shareFailureMessage),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        spacing: "spacious",
        label: formatMessage($6f752f2f09404e22$export$defe85febe8b728c.shareFailureIconLabel),
        color: "var(--ds-icon-danger, #C9372C)"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: buttonAppearance,
        type: "submit",
        isLoading: isSharing,
        isDisabled: buttonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ButtonLabelWrapper, null, submitButtonLabel || formatMessage(buttonLabel))));
};

});


parcelRegister("l5lRI", function(module, exports) {
$parcel$export(module.exports, "ProjectAccessLevelSelectContainer", () => $771a0d2a64f761a8$export$be750a3a70b4f271);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6svxr = parcelRequire("6svxr");

var $8IeH1 = parcelRequire("8IeH1");
var $hYvlq = parcelRequire("hYvlq");
var $3cMgR = parcelRequire("3cMgR");

var $ffGm1 = parcelRequire("ffGm1");

var $6XEne = parcelRequire("6XEne");
var $c4OV1 = parcelRequire("c4OV1");

var $9A8Wt = parcelRequire("9A8Wt");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $epTsa = parcelRequire("epTsa");

var $iyFlq = parcelRequire("iyFlq");
const $771a0d2a64f761a8$var$gridStyles = {
    root: "_yv0e5bpd _1lmcpt3h"
};
const $771a0d2a64f761a8$var$FIELD_NAME = 'projectAccessLevel';
const $771a0d2a64f761a8$var$styles = {
    iconContainer: "_nd5l2ec4 _18u0r5cr _1e0c1txw _4cvr1h6o",
    selectIconContainer: "_nd5l2ec4 _18zr1b66 _1wpz1h6o _18u0r5cr",
    dropdownContainer: "_nd5l1ba5",
    selectDropdownContainer: "_nd5l1ba5 _ca0qv77o",
    descriptionContainer: "_nd5ltgt2 _1bsb1ns9 _18u0u2gc",
    optionDescriptionContainer: "_nd5ltgt2 _1bsb1ns9",
    field: "_1i53muej _15a5nqa1 _uwhke4h9 _19pk1ejb _otyrutpp _18u0c7mi _2hwxc7mi _ca0qu2gc _19bvv47k _u5f3v47k",
    skeleton: "_otyrutpp"
}; // `css` is used to customise the styles of the Select components, `cssMap` / `xcss` don't work here
const $771a0d2a64f761a8$var$controlStyles = null;
const $771a0d2a64f761a8$var$messages = (0, $7qGN1.defineMessages)({
    projectAccessLevelLabel: {
        "id": "share-dialog.fields.ProjectAccessLevelField.project-access-level-label",
        "defaultMessage": "Project access"
    }
});
const $771a0d2a64f761a8$var$SelectControl = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Control, {
        ...props,
        appearance: "subtle",
        isCompact: true,
        className: (0, $hcewu.default)([
            "_1bsb1ns9"
        ])
    });
};
const $771a0d2a64f761a8$var$SelectOption = ({ children: children, ...props })=>{
    const { data: data, isSelected: isSelected } = props;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hYvlq.default), {
        xcss: $771a0d2a64f761a8$var$gridStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $771a0d2a64f761a8$var$styles.selectIconContainer
    }, $771a0d2a64f761a8$export$16b26cd5e98d9100(data.iconName, isSelected)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $771a0d2a64f761a8$var$styles.selectDropdownContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: isSelected ? 'color.text.selected' : 'color.text'
    }, data.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $771a0d2a64f761a8$var$styles.optionDescriptionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text.subtle",
        size: "small"
    }, data.description))));
};
const $771a0d2a64f761a8$export$16b26cd5e98d9100 = (icon, isSelected)=>{
    const localProps = {
        label: '',
        color: isSelected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)",
        LEGACY_size: 'medium',
        spacing: 'spacious'
    };
    const AccessLevelIcon = (0, $iyFlq.getAccessLevelIconFromIconName)(icon) ?? (0, (/*@__PURE__*/$parcel$interopDefault($ffGm1)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AccessLevelIcon, localProps);
};
const $771a0d2a64f761a8$var$transformToSelectOption = (level)=>({
        label: level.displayName,
        value: level.value,
        iconName: level.iconName,
        description: level.description
    });
const $771a0d2a64f761a8$export$be750a3a70b4f271 = ({ isLoading: isLoading, currentAccessLevel: currentAccessLevel, accessLevels: accessLevels, getProjectAccessLevels: getProjectAccessLevels })=>{
    (0, $eJOHy.useEffect)(()=>{
        (0, $epTsa.expVal)('tmp_secure_project_access_share_dialog', 'isEnabled', false) && getProjectAccessLevels(); // only used to fetch the project access levels when the component mounts
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!(0, $epTsa.expVal)('tmp_secure_project_access_share_dialog', 'isEnabled', false)) return null;
    if (!accessLevels && isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $771a0d2a64f761a8$var$styles.skeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.Skeleton), {
        height: "20px"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($771a0d2a64f761a8$var$ProjectAccessLevelSelect, {
        currentAccessLevel: currentAccessLevel,
        accessLevels: accessLevels,
        getProjectAccessLevels: getProjectAccessLevels
    });
};
const $771a0d2a64f761a8$var$ProjectAccessLevelSelect = ({ currentAccessLevel: currentAccessLevel, accessLevels: accessLevels })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectContainerRef = (0, $eJOHy.useRef)(null);
    const selectOptions = (0, $eJOHy.useMemo)(()=>accessLevels?.map((level)=>$771a0d2a64f761a8$var$transformToSelectOption(level)), [
        accessLevels
    ]);
    const defaultValue = (0, $eJOHy.useMemo)(()=>selectOptions?.find((option)=>option.value === currentAccessLevel?.value), [
        currentAccessLevel,
        selectOptions
    ]);
    const [currentValue, setCurrentValue] = (0, $eJOHy.useState)(defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $771a0d2a64f761a8$var$styles.field
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: $771a0d2a64f761a8$var$FIELD_NAME,
        label: formatMessage($771a0d2a64f761a8$var$messages.projectAccessLevelLabel),
        defaultValue: defaultValue
    }, ({ fieldProps: { onChange: onChange, ...fieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hYvlq.default), {
            xcss: $771a0d2a64f761a8$var$gridStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            xcss: $771a0d2a64f761a8$var$styles.iconContainer,
            testId: "share-button.ui.project-access-level.box"
        }, $771a0d2a64f761a8$export$16b26cd5e98d9100(currentValue?.iconName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            xcss: $771a0d2a64f761a8$var$styles.dropdownContainer,
            ref: selectContainerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
            ...fieldProps,
            value: currentValue,
            options: selectOptions,
            onChange: (value)=>{
                if (!value) return;
                setCurrentValue(value);
                onChange(value);
            },
            isSearchable: false,
            menuPortalTarget: globalThis.document.body,
            components: {
                Control: $771a0d2a64f761a8$var$SelectControl,
                Option: $771a0d2a64f761a8$var$SelectOption
            },
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999,
                        width: selectContainerRef.current?.offsetWidth
                    }),
                dropdownIndicator: (base)=>({
                        ...base,
                        padding: 0,
                        marginLeft: "var(--ds-space-negative-075, -6px)"
                    }),
                singleValue: (base)=>({
                        ...base,
                        color: "var(--ds-text, #172B4D)"
                    })
            },
            menuPosition: "fixed",
            spacing: "compact"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            xcss: $771a0d2a64f761a8$var$styles.descriptionContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            color: "color.text.subtle",
            size: "small"
        }, currentValue?.description)))));
};

});
parcelRegister("hYvlq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e062987a137d87a$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3e062987a137d87a$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $3e062987a137d87a$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $3e062987a137d87a$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $3e062987a137d87a$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $3e062987a137d87a$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $3e062987a137d87a$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $3e062987a137d87a$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $3e062987a137d87a$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hcewu.default)([
            $3e062987a137d87a$var$baseStyles.root,
            gap && $3e062987a137d87a$var$columnGapMap[gap],
            columnGap && $3e062987a137d87a$var$columnGapMap[columnGap],
            gap && $3e062987a137d87a$var$rowGapMap[gap],
            rowGap && $3e062987a137d87a$var$rowGapMap[rowGap],
            alignItems && $3e062987a137d87a$var$alignItemsMap[alignItems],
            alignContent && $3e062987a137d87a$var$alignContentMap[alignContent],
            justifyContent && $3e062987a137d87a$var$justifyContentMap[justifyContent],
            autoFlow && $3e062987a137d87a$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$3e062987a137d87a$var$Grid.displayName = 'Grid';
var $3e062987a137d87a$export$2e2bcd8739ae039 = $3e062987a137d87a$var$Grid;

});

parcelRegister("9A8Wt", function(module, exports) {
$parcel$export(module.exports, "getKeyframes", () => $72d4b536fea173c6$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "SkeletonCompiled", () => $72d4b536fea173c6$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $72d4b536fea173c6$export$e477bb7d17087f28);
$parcel$export(module.exports, "Skeleton", () => $72d4b536fea173c6$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $72d4b536fea173c6$export$d7a54cba636a8cd6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $cdbP5 = parcelRequire("cdbP5");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");
const $72d4b536fea173c6$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $cdbP5.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $72d4b536fea173c6$var$shimmer = $72d4b536fea173c6$export$b2b5e866b2fbf2ec();
const $72d4b536fea173c6$export$1d2144641222f3bd = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $72d4b536fea173c6$var$shimmer,
        animationTimingFunction: 'linear',
        backgroundColor: "var(--ds-skeleton, #091E420F)",
        backgroundImage: `linear-gradient( to right, ${"var(--ds-skeleton, #091E420F)"} 10%, ${"var(--ds-skeleton-subtle, #091E4208)"} 30%, ${"var(--ds-skeleton, #091E420F)"} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $72d4b536fea173c6$export$b1deee0d21f1be36 = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $72d4b536fea173c6$export$dc84d515085190e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height),
            "--_1gljcou": (0, $awdRS.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkolb4i _ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $72d4b536fea173c6$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});
const $72d4b536fea173c6$export$8f31e4c4a37b8e9c = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('enghealth-4756-migrate-complex-styled-component-v2'), $72d4b536fea173c6$export$dc84d515085190e, $72d4b536fea173c6$export$1d2144641222f3bd);
const $72d4b536fea173c6$export$d7a54cba636a8cd6 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('enghealth-4756-migrate-complex-styled-component-v2'), $72d4b536fea173c6$export$e477bb7d17087f28, $72d4b536fea173c6$export$b1deee0d21f1be36);

});




$parcel$global.rlb("3o2sP")
//# sourceMappingURL=JiraShareButtonOld.1ecb3385.js.map
